﻿import React from "react";

export const informationIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 14 14">
        <g id="Group_2791" data-name="Group 2791" transform="translate(-1019 -242)">
            <g id="Ellipse_65" data-name="Ellipse 65" transform="translate(1019 242)" fill="#efeffa" stroke="#7284fa" strokeWidth="1">
                <circle cx="7" cy="7" r="7" stroke="none" />
                <circle cx="7" cy="7" r="6.5" fill="none" />
            </g>
            <g id="info" transform="translate(993.179 245)">
                <path
                    id="Path_1500"
                    data-name="Path 1500"
                    d="M34.4,6.8l-.106.435q-.479.189-.764.288a2.016,2.016,0,0,1-.663.1,1.323,1.323,0,0,1-.9-.283.915.915,0,0,1-.322-.719,2.542,2.542,0,0,1,.024-.346q.024-.177.078-.4l.4-1.413q.053-.2.09-.385a1.672,1.672,0,0,0,.036-.331.512.512,0,0,0-.112-.378.631.631,0,0,0-.427-.107,1.119,1.119,0,0,0-.317.048c-.109.032-.2.063-.279.092l.107-.435q.392-.16.75-.273a2.244,2.244,0,0,1,.679-.114,1.291,1.291,0,0,1,.888.278.924.924,0,0,1,.312.723c0,.061-.007.17-.022.324a2.168,2.168,0,0,1-.08.426l-.4,1.407a3.737,3.737,0,0,0-.087.388,1.994,1.994,0,0,0-.039.329.474.474,0,0,0,.125.382.707.707,0,0,0,.435.1,1.255,1.255,0,0,0,.329-.051A1.838,1.838,0,0,0,34.4,6.8Zm.1-5.907a.823.823,0,0,1-.278.627.946.946,0,0,1-.669.259.957.957,0,0,1-.673-.259A.821.821,0,0,1,32.6.89a.83.83,0,0,1,.281-.629.993.993,0,0,1,1.342,0A.831.831,0,0,1,34.505.89Z"
                    transform="translate(0 0)"
                    fill="#7284fa"
                />
            </g>
        </g>
    </svg>
);

export const blueCheck = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.823 10.436">
        <g id="tick-kopi" transform="translate(0.5 -67.428)">
            <g id="Group_918" data-name="Group 918" transform="translate(0 67.997)">
                <path
                    id="Path_1240"
                    data-name="Path 1240"
                    d="M12.567,68.184a.638.638,0,0,0-.9,0l-7.64,7.64L1.088,72.888a.638.638,0,0,0-.9.9l3.388,3.388a.638.638,0,0,0,.9,0l8.091-8.091A.638.638,0,0,0,12.567,68.184Z"
                    transform="translate(0 -67.998)"
                    fill="#7284FA"
                    stroke="#7284FA"
                    strokeWidth="1"
                />
            </g>
        </g>
    </svg>
);

export const arrow = (
    <svg xmlns="http://www.w3.org/2000/svg" width="20.564" height="11.086" viewBox="0 0 20.564 11.086">
        <g id="Group_2154" data-name="Group 2154" transform="translate(-1752.544 -316.279)">
            <line
                id="Line_363"
                data-name="Line 363"
                x2="18.753"
                transform="translate(1753.294 322.232)"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeWidth="1.5"
            />
            <line
                id="Line_364"
                data-name="Line 364"
                x2="4.892"
                y2="4.892"
                transform="translate(1767.155 317.34)"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeWidth="1.5"
            />
            <line
                id="Line_365"
                data-name="Line 365"
                y1="4.077"
                x2="4.892"
                transform="translate(1767.155 322.232)"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeWidth="1.5"
            />
        </g>
    </svg>
);

export const leftWhiteArrowButton = (
    <svg xmlns="http://www.w3.org/2000/svg" width="20.977" height="11.283" viewBox="0 0 20.977 11.283">
        <g id="Group_7880" data-name="Group 7880" transform="translate(-9335.187 4603.041)">
            <g id="Group_7879" data-name="Group 7879" transform="translate(11108.707 -4275.478) rotate(180)">
                <line
                    id="Line_363"
                    data-name="Line 363"
                    x2="19.166"
                    transform="translate(1753.294 322.34)"
                    fill="none"
                    stroke="#fff"
                    strokeLinecap="round"
                    strokeWidth="1.5"
                />
                <line
                    id="Line_364"
                    data-name="Line 364"
                    x2="5"
                    y2="5"
                    transform="translate(1767.46 317.34)"
                    fill="none"
                    stroke="#fff"
                    strokeLinecap="round"
                    strokeWidth="1.5"
                />
                <line
                    id="Line_365"
                    data-name="Line 365"
                    y1="4.167"
                    x2="5"
                    transform="translate(1767.46 322.34)"
                    fill="none"
                    stroke="#fff"
                    strokeLinecap="round"
                    strokeWidth="1.5"
                />
            </g>
        </g>
    </svg>
);

export const settingsIcon = (
    <svg id="Group_1241" data-name="Group 1241" xmlns="http://www.w3.org/2000/svg" stroke="#7284FA" viewBox="0 0 23.825 24">
        <g id="Group_923" data-name="Group 923">
            <path
                id="Path_1245"
                data-name="Path 1245"
                d="M14.779,14.143l1.577-.911-2-3.464-1.574.909a6.531,6.531,0,0,0-2.354-1.354V7.5h-4V9.321a6.479,6.479,0,0,0-2.356,1.356L2.5,9.768l-2,3.464,1.578.912a6.443,6.443,0,0,0,0,2.713L.5,17.768l2,3.464,1.574-.908a6.525,6.525,0,0,0,2.354,1.354V23.5h4V21.68a6.454,6.454,0,0,0,2.356-1.355l1.572.907,2-3.464-1.577-.91A6.469,6.469,0,0,0,14.779,14.143Z"
                strokeLinejoin="round"
                strokeWidth="1.5"
            />
            <path
                id="Path_1246"
                data-name="Path 1246"
                d="M22.318,4.2l1.007-.582-1-1.732-1.007.582a3.451,3.451,0,0,0-1.39-.81V.5h-2V1.656a3.486,3.486,0,0,0-1.394.806l-1-.579-1,1.732,1,.578A3.443,3.443,0,0,0,15.537,5.8l-1.005.581,1,1.732,1.005-.58a3.457,3.457,0,0,0,1.391.811V9.5h2V8.344a3.5,3.5,0,0,0,1.4-.807l1,.578,1-1.732-1-.578A3.465,3.465,0,0,0,22.318,4.2Z"
                strokeLinejoin="round"
                strokeWidth="1.5"
            />
            <circle id="Ellipse_41" data-name="Ellipse 41" cx="3" cy="3" r="3" transform="translate(5.429 12.5)" strokeLinejoin="round" strokeWidth="1.5" />
            <circle
                id="Ellipse_42"
                data-name="Ellipse 42"
                cx="1.5"
                cy="1.5"
                r="1.5"
                transform="translate(17.429 3.5)"
                strokeLinejoin="round"
                strokeWidth="1.5"
            />
        </g>
    </svg>
);

export const systemsIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.5 21.5">
        <g id="Group_1193" data-name="Group 1193" transform="translate(-1030.75 -2008.75)">
            <g id="Group_1192" data-name="Group 1192">
                <g id="Group_1191" data-name="Group 1191">
                    <path
                        id="Path_1263"
                        data-name="Path 1263"
                        d="M1054.5,2025.911a1.546,1.546,0,0,1-1.5,1.589h-20a1.546,1.546,0,0,1-1.5-1.589v-14.822a1.546,1.546,0,0,1,1.5-1.589h20a1.546,1.546,0,0,1,1.5,1.589Z"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                    />
                    <line
                        id="Line_173"
                        data-name="Line 173"
                        x2="14"
                        transform="translate(1036 2029.5)"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                    />
                    <line
                        id="Line_174"
                        data-name="Line 174"
                        y2="2"
                        transform="translate(1042.5 2027.5)"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                    />
                    <circle
                        id="Ellipse_47"
                        data-name="Ellipse 47"
                        cx="0.5"
                        cy="0.5"
                        r="0.5"
                        transform="translate(1042.5 2025)"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                    />
                    <line id="Line_175" data-name="Line 175" x2="23" transform="translate(1031.5 2023.5)" strokeLinejoin="round" strokeWidth="1.5" />
                </g>
                <circle
                    id="Ellipse_48"
                    data-name="Ellipse 48"
                    cx="5"
                    cy="5"
                    r="5"
                    transform="translate(1034 2011.5)"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                />
                <path
                    id="Path_1264"
                    data-name="Path 1264"
                    d="M1041.827,2012.376,1039,2016.5l3.205,3.836"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                />
                <line
                    id="Line_176"
                    data-name="Line 176"
                    x1="5"
                    transform="translate(1034 2016.5)"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                />
                <line id="Line_177" data-name="Line 177" x2="6" transform="translate(1046 2012.5)" strokeLinejoin="round" strokeWidth="1.5" />
                <line id="Line_178" data-name="Line 178" x2="6" transform="translate(1046 2015.5)" strokeLinejoin="round" strokeWidth="1.5" />
                <line id="Line_179" data-name="Line 179" x2="6" transform="translate(1046 2018.5)" strokeLinejoin="round" strokeWidth="1.5" />
            </g>
        </g>
    </svg>
);

export const systemsMenuIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.5 21.5" stroke="#7284FA">
        <g id="Group_1193" data-name="Group 1193" transform="translate(-1030.75 -2008.75)">
            <g id="Group_1192" data-name="Group 1192">
                <g id="Group_1191" data-name="Group 1191">
                    <path
                        id="Path_1263"
                        data-name="Path 1263"
                        d="M1054.5,2025.911a1.546,1.546,0,0,1-1.5,1.589h-20a1.546,1.546,0,0,1-1.5-1.589v-14.822a1.546,1.546,0,0,1,1.5-1.589h20a1.546,1.546,0,0,1,1.5,1.589Z"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.25"
                    />
                    <line
                        id="Line_173"
                        data-name="Line 173"
                        x2="14"
                        transform="translate(1036 2029.5)"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.25"
                    />
                    <line
                        id="Line_174"
                        data-name="Line 174"
                        y2="2"
                        transform="translate(1042.5 2027.5)"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.25"
                    />
                    <circle
                        id="Ellipse_47"
                        data-name="Ellipse 47"
                        cx="0.5"
                        cy="0.5"
                        r="0.5"
                        transform="translate(1042.5 2025)"
                        strokeLinejoin="round"
                        strokeWidth="1.25"
                    />
                    <line id="Line_175" data-name="Line 175" x2="23" transform="translate(1031.5 2023.5)" strokeLinejoin="round" strokeWidth="1.25" />
                </g>
                <circle
                    id="Ellipse_48"
                    data-name="Ellipse 48"
                    cx="5"
                    cy="5"
                    r="5"
                    transform="translate(1034 2011.5)"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.25"
                />
                <path
                    id="Path_1264"
                    data-name="Path 1264"
                    d="M1041.827,2012.376,1039,2016.5l3.205,3.836"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.25"
                />
                <line
                    id="Line_176"
                    data-name="Line 176"
                    x1="5"
                    transform="translate(1034 2016.5)"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.25"
                />
                <line id="Line_177" data-name="Line 177" x2="6" transform="translate(1046 2012.5)" strokeLinejoin="round" strokeWidth="1.25" />
                <line id="Line_178" data-name="Line 178" x2="6" transform="translate(1046 2015.5)" strokeLinejoin="round" strokeWidth="1.25" />
                <line id="Line_179" data-name="Line 179" x2="6" transform="translate(1046 2018.5)" strokeLinejoin="round" strokeWidth="1.25" />
            </g>
        </g>
    </svg>
);

export const leftArrowIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="15.5" height="10.121" viewBox="0 0 15.5 10.121">
        <g id="Group_2573" data-name="Group 2573" transform="translate(-1160.25 -1064.939)">
            <line
                id="Line_168"
                data-name="Line 168"
                x2="14"
                transform="translate(1161 1070)"
                fill="none"
                stroke="#618cf5"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
            />
            <path
                id="Path_1258"
                data-name="Path 1258"
                d="M989.5,2699.5l-4-4,4-4"
                transform="translate(175.5 -1625.5)"
                fill="#d9daee"
                stroke="#618cf5"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
            />
        </g>
    </svg>
);

export const rightArrowIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="15.5" height="10.121" viewBox="0 0 15.5 10.121">
        <g id="Group_2574" data-name="Group 2574" transform="translate(-1169.25 -1069.939)">
            <line
                id="Line_169"
                data-name="Line 169"
                x2="14"
                transform="translate(1170 1075)"
                fill="none"
                stroke="#618cf5"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
            />
            <path
                id="Path_1259"
                data-name="Path 1259"
                d="M1004.5,2704.5l4-4-4-4"
                transform="translate(175.5 -1625.5)"
                fill="#d9daee"
                stroke="#618cf5"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
            />
        </g>
    </svg>
);

export const dataProcessorIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="18.546" height="20.072" viewBox="0 0 18.546 20.072">
        <g id="Group_3232" data-name="Group 3232" transform="translate(-97 -2143)">
            <path
                id="Path_2781"
                data-name="Path 2781"
                d="M100.17,2164.609v1.061l-1.937.554a1.073,1.073,0,0,0-.733.972v.381h4.2"
                transform="translate(0 -5.006)"
                fill="#dad9ef"
                stroke="#618cf5"
                strokeLinejoin="round"
                strokeWidth="1"
            />
            <path
                id="Path_2782"
                data-name="Path 2782"
                d="M103.526,2164.578v1.085l1.936.554a1.072,1.072,0,0,1,.734.972v.381H102"
                transform="translate(-1.067 -4.998)"
                fill="#dad9ef"
                stroke="#618cf5"
                strokeLinejoin="round"
                strokeWidth="1"
            />
            <ellipse
                id="Ellipse_89"
                data-name="Ellipse 89"
                cx="2.289"
                cy="2.496"
                rx="2.289"
                ry="2.496"
                transform="translate(99.026 2154.943)"
                fill="#dad9ef"
                stroke="#618cf5"
                strokeLinejoin="round"
                strokeWidth="1"
            />
            <path
                id="Path_2783"
                data-name="Path 2783"
                d="M104.069,2161.073a1.309,1.309,0,0,1-1.884-.4,2.194,2.194,0,0,1-2.62.328"
                transform="translate(-0.49 -4.072)"
                fill="#dad9ef"
                stroke="#618cf5"
                strokeLinejoin="round"
                strokeWidth="1"
            />
            <path
                id="Path_2784"
                data-name="Path 2784"
                d="M113.17,2164.609v1.061l-1.937.554a1.073,1.073,0,0,0-.733.972v.381h4.2"
                transform="translate(-3.083 -5.006)"
                fill="#dad9ef"
                stroke="#618cf5"
                strokeLinejoin="round"
                strokeWidth="1"
            />
            <path
                id="Path_2785"
                data-name="Path 2785"
                d="M116.526,2164.594v1.073l1.936.554a1.072,1.072,0,0,1,.734.972v.381H115"
                transform="translate(-4.15 -5.002)"
                fill="#dad9ef"
                stroke="#618cf5"
                strokeLinejoin="round"
                strokeWidth="1"
            />
            <ellipse
                id="Ellipse_90"
                data-name="Ellipse 90"
                cx="2.289"
                cy="2.496"
                rx="2.289"
                ry="2.496"
                transform="translate(108.943 2154.943)"
                fill="#dad9ef"
                stroke="#618cf5"
                strokeLinejoin="round"
                strokeWidth="1"
            />
            <path
                id="Path_2786"
                data-name="Path 2786"
                d="M117.057,2161.07a1.3,1.3,0,0,1-1.871-.4,2.194,2.194,0,0,1-2.62.328"
                transform="translate(-3.573 -4.072)"
                fill="#dad9ef"
                stroke="#618cf5"
                strokeLinejoin="round"
                strokeWidth="1"
            />
            <g id="Group_3233" data-name="Group 3233" transform="translate(102.459 2143.5)">
                <path
                    id="Path_2787"
                    data-name="Path 2787"
                    d="M106.67,2177.609v1.061l-1.937.554a1.073,1.073,0,0,0-.733.972v.381h4.2"
                    transform="translate(-104 -2172.949)"
                    fill="#dad9ef"
                    stroke="#618cf5"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <path
                    id="Path_2788"
                    data-name="Path 2788"
                    d="M110.026,2177.609v1.061l1.936.554a1.072,1.072,0,0,1,.734.972v.381h-4.2"
                    transform="translate(-105.067 -2172.949)"
                    fill="#dad9ef"
                    stroke="#618cf5"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <ellipse
                    id="Ellipse_91"
                    data-name="Ellipse 91"
                    cx="2.289"
                    cy="2.496"
                    rx="2.289"
                    ry="2.496"
                    transform="translate(1.526)"
                    fill="#dad9ef"
                    stroke="#618cf5"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <path
                    id="Path_2789"
                    data-name="Path 2789"
                    d="M110.557,2174.051a1.289,1.289,0,0,1-1.871-.381,2.194,2.194,0,0,1-2.62.328"
                    transform="translate(-104.49 -2172.015)"
                    fill="#dad9ef"
                    stroke="#618cf5"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
            </g>
            <line
                id="Line_415"
                data-name="Line 415"
                x2="1.316"
                y2="1.144"
                transform="translate(108.04 2152.654)"
                fill="none"
                stroke="#618cf5"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
            />
            <path
                id="Path_2790"
                data-name="Path 2790"
                d="M1.312,0,0,1.144"
                transform="translate(103.388 2152.654)"
                fill="#dad9ef"
                stroke="#618cf5"
                strokeLinecap="round"
                strokeWidth="1"
            />
        </g>
    </svg>
);

export const arrowRight = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.05 19.741">
        <g transform="translate(235.429 39.12) rotate(180)">
            <line x1="7.808" y2="7.808" transform="translate(225.5 21.5)" strokeLinecap="round" strokeWidth="3" />
            <line x1="7.808" y1="7.25" transform="translate(225.5 29.75)" strokeLinecap="round" strokeWidth="3" />
        </g>
    </svg>
);

export const arrowLeft = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.05 19.741">
        <g transform="translate(-223.379 -19.379)">
            <line x1="7.808" y2="7.808" transform="translate(225.5 21.5)" strokeLinecap="round" strokeWidth="3" />
            <line x1="7.808" y1="7.25" transform="translate(225.5 29.75)" strokeLinecap="round" strokeWidth="3" />
        </g>
    </svg>
);

export const legalEntitiesIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.166 20.166" stroke="#7284FA">
        <g id="Group_2516" data-name="Group 2516" transform="translate(-91.917 -956.038)">
            <g id="Group_2515" data-name="Group 2515" transform="translate(92.417 956.538)">
                <rect
                    id="Rectangle_728"
                    data-name="Rectangle 728"
                    width="9.166"
                    height="11.666"
                    transform="translate(0 7.5)"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <rect
                    id="Rectangle_729"
                    data-name="Rectangle 729"
                    width="5.833"
                    height="5"
                    transform="translate(1.667 2.5)"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_375"
                    data-name="Line 375"
                    y1="2.5"
                    transform="translate(4.583)"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <path id="Path_2176" data-name="Path 2176" d="M0,0H7.5V15H0Z" transform="translate(11.666 4.167)" strokeLinecap="round" strokeWidth="1" />
                <line
                    id="Line_376"
                    data-name="Line 376"
                    x2="4.167"
                    transform="translate(13.333 5.833)"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_377"
                    data-name="Line 377"
                    x2="4.167"
                    transform="translate(13.333 7.5)"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_378"
                    data-name="Line 378"
                    x2="4.167"
                    transform="translate(13.333 9.166)"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_379"
                    data-name="Line 379"
                    x2="4.167"
                    transform="translate(13.333 10.833)"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_380"
                    data-name="Line 380"
                    x2="4.167"
                    transform="translate(13.333 12.5)"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_381"
                    data-name="Line 381"
                    x2="4.167"
                    transform="translate(13.333 14.166)"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_382"
                    data-name="Line 382"
                    x2="4.167"
                    transform="translate(13.333 15.833)"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_383"
                    data-name="Line 383"
                    x2="5.833"
                    transform="translate(1.667 10)"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_384"
                    data-name="Line 384"
                    x2="5.833"
                    transform="translate(1.667 12.5)"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_385"
                    data-name="Line 385"
                    x2="5.833"
                    transform="translate(1.667 15)"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_386"
                    data-name="Line 386"
                    x2="2.5"
                    transform="translate(3.333 4.167)"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_387"
                    data-name="Line 387"
                    x2="2.5"
                    transform="translate(3.333 5.833)"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <rect
                    id="Rectangle_731"
                    data-name="Rectangle 731"
                    width="1.667"
                    height="1.667"
                    transform="translate(4.167 17.5)"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <rect
                    id="Rectangle_732"
                    data-name="Rectangle 732"
                    width="1.667"
                    height="1.667"
                    transform="translate(14.583 17.5)"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
            </g>
        </g>
    </svg>
);

export const processingActivitiesIcon = (
    <svg id="Group_3479" stroke="#7284FA" data-name="Group 3479" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.404 19.404">
        <defs>
            <clipPath id="clipPath">
                <rect id="Rectangle_1059" data-name="Rectangle 1059" width="19.404" height="19.404" fill="none" strokeWidth="1" />
            </clipPath>
        </defs>
        <g id="Group_3478" data-name="Group 3478" transform="translate(0 0)" clipPath="url(#clipPath)">
            <circle
                id="Ellipse_96"
                data-name="Ellipse 96"
                cx="5.734"
                cy="5.734"
                r="5.734"
                transform="translate(3.964 3.969)"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
            />
            <path
                id="Path_3106"
                data-name="Path 3106"
                d="M14.733,6.4a2.847,2.847,0,0,1-1.246,1.867c-2.312-.578-1.438.73-1.246,1.5.25.249.747,0,.747,0,1.115,2.194-.747,2.742-.747,2.742-1.357,1.357-.915,1.744-2.243,1.744-.25,0-.749-1-.749-1.246,0-1.9-.952-2.243-1.744-2.243-.748,0-.748-1-.748-1s0-1.747,1.246-2,1.246.249,1.246.249c.515.515,2.341-.495.673-1.793-.617-.481,2.251-1.448,2.251-1.448"
                transform="translate(-0.797 -0.564)"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
            />
            <path
                id="Path_3107"
                data-name="Path 3107"
                d="M19.995,2.751l-3.457-.68.268,2.978"
                transform="translate(-1.95 -0.244)"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
            />
            <path
                id="Path_3108"
                data-name="Path 3108"
                d="M1.006,18.707l3.939.823-.318-2.969"
                transform="translate(-0.119 -1.953)"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
            />
            <path
                id="Path_3109"
                data-name="Path 3109"
                d="M15.611,2.071A9.264,9.264,0,0,1,8.759,19"
                transform="translate(-1.033 -0.244)"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
            />
            <path
                id="Path_3110"
                data-name="Path 3110"
                d="M4.885,17.636A9.264,9.264,0,0,1,11.718.707"
                transform="translate(-0.059 -0.059)"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
            />
        </g>
    </svg>
);

export const helpIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 17">
        <g id="Group_3480" data-name="Group 3480" transform="translate(-34.498 -389.476)">
            <g id="Group_1173" data-name="Group 1173" transform="translate(-872.621 -5076.022)">
                <g id="Group_640" data-name="Group 640" transform="translate(907.619 5466.17)">
                    <circle
                        id="Ellipse_34"
                        data-name="Ellipse 34"
                        cx="8"
                        cy="8"
                        r="8"
                        transform="translate(0 -0.172)"
                        fill="#dad9ef"
                        stroke="#7284fa"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                    />
                </g>
            </g>
            <path
                id="Path_3112"
                data-name="Path 3112"
                d="M1.5,10.26V9.927A1.96,1.96,0,0,1,1.7,8.977a2.708,2.708,0,0,1,.727-.784,4.022,4.022,0,0,0,.8-.758,1.138,1.138,0,0,0,.179-.644.81.81,0,0,0-.291-.67,1.307,1.307,0,0,0-.836-.234,2.875,2.875,0,0,0-.914.14,6.491,6.491,0,0,0-.821.338L.109,5.449a4.573,4.573,0,0,1,2.26-.587,2.442,2.442,0,0,1,1.616.5,1.7,1.7,0,0,1,.6,1.377,1.961,1.961,0,0,1-.114.694,1.99,1.99,0,0,1-.345.579,5.578,5.578,0,0,1-.8.717,3.058,3.058,0,0,0-.647.629,1.207,1.207,0,0,0-.164.67v.234Zm-.213,1.657a.684.684,0,0,1,.764-.784.756.756,0,0,1,.571.205.8.8,0,0,1,.2.579.825.825,0,0,1-.2.584.738.738,0,0,1-.569.216.739.739,0,0,1-.566-.21A.828.828,0,0,1,1.283,11.917Z"
                transform="translate(40.652 389.187)"
                fill="#7284fa"
                strokeWidth="0"
            />
        </g>
    </svg>
);

export const recordIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.675 26.001" stroke="#7284FA">
        <g id="Group_3319" data-name="Group 3319" transform="translate(-1174.564 -487.929)">
            <g id="Group_3262" data-name="Group 3262" transform="translate(1175.314 488.679)">
                <g id="Group_3261" data-name="Group 3261" transform="translate(0)">
                    <g id="Group_3260" data-name="Group 3260">
                        <path
                            id="Path_2792"
                            data-name="Path 2792"
                            d="M861.544,912.5h2.131v22.37H844.5V912.5h2.13"
                            transform="translate(-844.5 -910.369)"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                        />
                        <path
                            id="Path_2794"
                            data-name="Path 2794"
                            d="M848.63,914.5H846.5v18.109h14.914V914.5h-2.13"
                            transform="translate(-844.369 -910.239)"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                        />
                        <path
                            id="Path_2793"
                            data-name="Path 2793"
                            d="M855.957,912.631a2.131,2.131,0,1,0-4.261,0h-3.2v3.2h10.653v-3.2Z"
                            transform="translate(-844.239 -910.5)"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                        />
                    </g>
                </g>
                <line
                    id="Line_428"
                    data-name="Line 428"
                    x2="8.554"
                    transform="translate(5.132 8.554)"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_429"
                    data-name="Line 429"
                    x2="8.554"
                    transform="translate(5.132 11.12)"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_430"
                    data-name="Line 430"
                    x2="8.554"
                    transform="translate(5.132 13.686)"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_431"
                    data-name="Line 431"
                    x2="4.794"
                    transform="translate(5.133 16.253)"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
            </g>
        </g>
    </svg>
);

export const signOutIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.5 17.214" stroke="#7284FA">
        <g id="Group_1282" data-name="Group 1282" transform="translate(70.249 975.964) rotate(-180)">
            <path
                id="Path_776"
                data-name="Path 776"
                d="M64.093,963.311a7.764,7.764,0,0,0-6.737-3.811,7.857,7.857,0,1,0,0,15.714,7.941,7.941,0,0,0,6.664-3.692"
                transform="translate(0)"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
            />
            <g id="Group_564" data-name="Group 564" transform="translate(69.499 970.214) rotate(180)">
                <line
                    id="Line_127"
                    data-name="Line 127"
                    x1="10.714"
                    transform="translate(1.429 2.857)"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <path id="Path_775" data-name="Path 775" d="M2.857,0,0,2.857,2.857,5.714" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" />
            </g>
        </g>
    </svg>
);

export const dataControllerRecordIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 12.208 15.321">
        <g id="Group_3263" data-name="Group 3263" transform="translate(-1129.814 -513.179)">
            <g id="Group_3262" data-name="Group 3262" transform="translate(285.814 -396.821)">
                <g id="Group_3261" data-name="Group 3261" transform="translate(844.5 910.5)">
                    <g id="Group_3260" data-name="Group 3260">
                        <path
                            id="Path_2792"
                            data-name="Path 2792"
                            d="M854.463,912.5h1.245v13.076H844.5V912.5h1.245"
                            transform="translate(-844.5 -911.255)"
                            fill="none"
                            stroke="#7387f7"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                        />
                        <path
                            id="Path_2794"
                            data-name="Path 2794"
                            d="M847.745,914.5H846.5v10.585h8.717V914.5h-1.245"
                            transform="translate(-845.255 -912.009)"
                            fill="#efeffa"
                            stroke="#7387f7"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                        />
                        <path
                            id="Path_2793"
                            data-name="Path 2793"
                            d="M852.859,911.745a1.245,1.245,0,0,0-2.491,0H848.5v1.868h6.227v-1.868Z"
                            transform="translate(-846.009 -910.5)"
                            fill="#efeffa"
                            stroke="#7387f7"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                        />
                    </g>
                </g>
                <line
                    id="Line_428"
                    data-name="Line 428"
                    x2="5"
                    transform="translate(847.5 915.5)"
                    fill="none"
                    stroke="#7387f7"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_429"
                    data-name="Line 429"
                    x2="5"
                    transform="translate(847.5 917)"
                    fill="none"
                    stroke="#7387f7"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_430"
                    data-name="Line 430"
                    x2="5"
                    transform="translate(847.5 918.5)"
                    fill="none"
                    stroke="#7387f7"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_431"
                    data-name="Line 431"
                    x2="2.802"
                    transform="translate(847.5 920)"
                    fill="none"
                    stroke="#7387f7"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
            </g>
        </g>
    </svg>
);

export const primaryArrowRight = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10.191 16.846">
        <path
            id="Path_804"
            data-name="Path 804"
            d="M0,0,6.655,6.655,13.31,0"
            transform="translate(1.768 15.078) rotate(-90)"
            fill="none"
            stroke="#7284FA"
            strokeLinecap="round"
            strokeWidth="2.5"
        />
    </svg>
);

export const editIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="23.656" height="24.063" viewBox="0 0 23.656 24.063">
        <g id="Group_1085" data-name="Group 1085" transform="translate(-1768.553 -47.392)">
            <g id="Group_1082" data-name="Group 1082" transform="translate(1623.554 -94.381)">
                <path
                    id="Path_1384"
                    data-name="Path 1384"
                    d="M164.446,153.417v11.919H145.5V144.477H159.46"
                    transform="translate(0)"
                    fill="none"
                    stroke="#5a61a8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
            </g>
            <g id="Group_1080" data-name="Group 1080" transform="translate(1679.407 -46.539)">
                <path
                    id="Path_1383"
                    data-name="Path 1383"
                    d="M101.929,107.945l-4.1.962.962-4.1,9.894-9.9a1.27,1.27,0,0,1,1.794,0l1.346,1.346a1.27,1.27,0,0,1,0,1.794Z"
                    transform="translate(0 0)"
                    fill="#b6d5ef"
                    stroke="#5a61a8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_180"
                    data-name="Line 180"
                    x1="3.142"
                    y1="3.141"
                    transform="translate(108.236 95.359)"
                    fill="none"
                    stroke="#5a61a8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_181"
                    data-name="Line 181"
                    x1="3.134"
                    y1="3.149"
                    transform="translate(107.34 96.256)"
                    fill="none"
                    stroke="#5a61a8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_182"
                    data-name="Line 182"
                    x1="3.14"
                    y1="3.14"
                    transform="translate(98.95 104.646)"
                    fill="none"
                    stroke="#5a61a8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
            </g>
        </g>
    </svg>
);

export const download = (
    <svg xmlns="http://www.w3.org/2000/svg" width="19.5" height="19.5" viewBox="0 0 19.5 19.5">
        <g id="Group_767" data-name="Group 767" transform="translate(-984.75 -2589.75)">
            <path
                id="Path_1070"
                data-name="Path 1070"
                d="M1003.5,2607.718v1.565a2.348,2.348,0,0,1-2.347,2.347H987.847a2.347,2.347,0,0,1-2.347-2.347v-1.565"
                transform="translate(0 -3.13)"
                fill="#dad9ef"
                stroke="#7284fa"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
            />
            <line
                id="Line_163"
                data-name="Line 163"
                y1="13.997"
                transform="translate(994.5 2590.5)"
                fill="none"
                stroke="#7284fa"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
            />
            <path
                id="Path_1071"
                data-name="Path 1071"
                d="M1000.955,2600.608l-5.727,5.727-5.727-5.727"
                transform="translate(-0.727 -1.838)"
                fill="#dad9ef"
                stroke="#7284fa"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
            />
        </g>
    </svg>
);

export const eye = (
    <svg xmlns="http://www.w3.org/2000/svg" width="21.181" height="12.624" viewBox="0 0 21.181 12.624">
        <g id="Group_766" data-name="Group 766" transform="translate(-144.75 -242.75)">
            <path
                id="Path_1068"
                data-name="Path 1068"
                d="M165.181,249.062s-4.405,5.562-9.841,5.562-9.841-5.562-9.841-5.562,4.405-5.562,9.841-5.562S165.181,249.062,165.181,249.062Z"
                fill="#dad9ef"
                stroke="#7284fa"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
            />
            <circle
                id="Ellipse_50"
                data-name="Ellipse 50"
                cx="3.423"
                cy="3.423"
                r="3.423"
                transform="translate(151.918 245.639)"
                fill="#dad9ef"
                stroke="#7284fa"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
            />
            <path
                id="Path_1069"
                data-name="Path 1069"
                d="M156.711,248A1.711,1.711,0,1,1,155,249.711"
                transform="translate(-1.371 -0.649)"
                fill="#dad9ef"
                stroke="#7284fa"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
            />
        </g>
    </svg>
);

export const NoteSVG = (
    <svg xmlns="http://www.w3.org/2000/svg" width="19.811" height="19.811" viewBox="0 0      19.811">
        <g id="Group_10230" data-name="Group 10230" transform="translate(-1684.25 -605.25)">
            <path id="Polygon_1" data-name="Polygon 1" d="M4,0,8,5H0Z" transform="matrix(0.719, -0.695, 0.695, 0.719, 1694, 620.557)" fill="#dad9ef" />
            <g id="Group_1105" data-name="Group 1105" transform="translate(747.5 -256.5)">
                <path
                    id="Path_1449"
                    data-name="Path 1449"
                    d="M949.239,874.239V880.5H937.5v-18h18v11.739Z"
                    fill="#dad9ef"
                    stroke="#7284fa"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                />
                <line
                    id="Line_184"
                    data-name="Line 184"
                    x1="6"
                    y2="6"
                    transform="translate(949.5 874.5)"
                    fill="none"
                    stroke="#7284fa"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                />
                <path
                    id="Path_1450"
                    data-name="Path 1450"
                    d="M942,872l.643-1a.706.706,0,0,1,1.286,0,.706.706,0,0,0,1.286,0,.706.706,0,0,1,1.286,0,.706.706,0,0,0,1.286,0,.706.706,0,0,1,1.286,0,.706.706,0,0,0,1.286,0l.643-1"
                    transform="translate(0 -1.786)"
                    fill="#dad9ef"
                    stroke="#7284fa"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                />
                <path
                    id="Path_1451"
                    data-name="Path 1451"
                    d="M942,877l1-1a1.415,1.415,0,0,1,2,0,1.415,1.415,0,0,0,2,0"
                    transform="translate(0 -3.031)"
                    fill="#dad9ef"
                    stroke="#7284fa"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                />
            </g>
        </g>
    </svg>
);

export const NoteWithDataIcon = (
    <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.2341 16.239V22.5H1.49512V4.5H19.4951V16.239H13.2341Z" fill="#DAD9EF" stroke="#7284FA" strokeWidth="1.5" strokeLinejoin="round" />
        <path d="M19.4951 16.5L13.4951 22.5" stroke="#7284FA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M5.99512 12.214L6.63812 11.214C6.69414 11.0904 6.78459 10.9856 6.89862 10.9121C7.01265 10.8386 7.14546 10.7995 7.28113 10.7995C7.4168 10.7995 7.5496 10.8386 7.66364 10.9121C7.77767 10.9856 7.86811 11.0904 7.92413 11.214C7.98016 11.3376 8.0706 11.4424 8.18463 11.5159C8.29867 11.5894 8.43147 11.6285 8.56714 11.6285C8.70281 11.6285 8.83561 11.5894 8.94965 11.5159C9.06368 11.4424 9.15412 11.3376 9.21014 11.214C9.26617 11.0904 9.35661 10.9856 9.47064 10.9121C9.58468 10.8386 9.71742 10.7995 9.85309 10.7995C9.98876 10.7995 10.1216 10.8386 10.2356 10.9121C10.3496 10.9856 10.4401 11.0904 10.4961 11.214C10.5521 11.3376 10.6426 11.4424 10.7566 11.5159C10.8706 11.5894 11.0034 11.6285 11.1391 11.6285C11.2748 11.6285 11.4076 11.5894 11.5216 11.5159C11.6356 11.4424 11.7261 11.3376 11.7821 11.214C11.8381 11.0904 11.9286 10.9856 12.0426 10.9121C12.1566 10.8386 12.2894 10.7995 12.4251 10.7995C12.5608 10.7995 12.6936 10.8386 12.8076 10.9121C12.9217 10.9856 13.0121 11.0904 13.0681 11.214C13.1241 11.3376 13.2146 11.4424 13.3286 11.5159C13.4426 11.5894 13.5754 11.6285 13.7111 11.6285C13.8468 11.6285 13.9796 11.5894 14.0936 11.5159C14.2077 11.4424 14.2981 11.3376 14.3541 11.214L14.9971 10.214"
            fill="#DAD9EF"
        />
        <path
            d="M5.99512 12.214L6.63812 11.214C6.69414 11.0904 6.78459 10.9856 6.89862 10.9121C7.01265 10.8386 7.14546 10.7995 7.28113 10.7995C7.4168 10.7995 7.5496 10.8386 7.66364 10.9121C7.77767 10.9856 7.86811 11.0904 7.92413 11.214C7.98016 11.3376 8.0706 11.4424 8.18463 11.5159C8.29867 11.5894 8.43147 11.6285 8.56714 11.6285C8.70281 11.6285 8.83561 11.5894 8.94965 11.5159C9.06368 11.4424 9.15412 11.3376 9.21014 11.214C9.26617 11.0904 9.35661 10.9856 9.47064 10.9121C9.58468 10.8386 9.71742 10.7995 9.85309 10.7995C9.98876 10.7995 10.1216 10.8386 10.2356 10.9121C10.3496 10.9856 10.4401 11.0904 10.4961 11.214C10.5521 11.3376 10.6426 11.4424 10.7566 11.5159C10.8706 11.5894 11.0034 11.6285 11.1391 11.6285C11.2748 11.6285 11.4076 11.5894 11.5216 11.5159C11.6356 11.4424 11.7261 11.3376 11.7821 11.214C11.8381 11.0904 11.9286 10.9856 12.0426 10.9121C12.1566 10.8386 12.2894 10.7995 12.4251 10.7995C12.5608 10.7995 12.6936 10.8386 12.8076 10.9121C12.9217 10.9856 13.0121 11.0904 13.0681 11.214C13.1241 11.3376 13.2146 11.4424 13.3286 11.5159C13.4426 11.5894 13.5754 11.6285 13.7111 11.6285C13.8468 11.6285 13.9796 11.5894 14.0936 11.5159C14.2077 11.4424 14.2981 11.3376 14.3541 11.214L14.9971 10.214"
            stroke="#7284FA"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M5.99512 15.9691L6.99512 14.9691C7.26044 14.704 7.62011 14.5552 7.99512 14.5552C8.37013 14.5552 8.7298 14.704 8.99512 14.9691C9.26044 15.2341 9.62011 15.3829 9.99512 15.3829C10.3701 15.3829 10.7298 15.2341 10.9951 14.9691"
            fill="#DAD9EF"
        />
        <path
            d="M5.99512 15.9691L6.99512 14.9691C7.26044 14.704 7.62011 14.5552 7.99512 14.5552C8.37013 14.5552 8.7298 14.704 8.99512 14.9691C9.26044 15.2341 9.62011 15.3829 9.99512 15.3829C10.3701 15.3829 10.7298 15.2341 10.9951 14.9691"
            stroke="#7284FA"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M21 9C23.2091 9 25 7.20914 25 5C25 2.79086 23.2091 1 21 1C18.7909 1 17 2.79086 17 5C17 7.20914 18.7909 9 21 9Z"
            fill="#2CD5C4"
            stroke="#2CD5C4"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const maleIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="88.114" height="86.882" viewBox="0 0 88.114 86.882">
        <g id="Group_679" data-name="Group 679" transform="translate(-904.746 -35.69)">
            <path
                id="Path_23"
                data-name="Path 23"
                d="M960.283,53.137l1.871,9.228c5.616,0,5.616,11.07,0,11.07,0,11.072-13.1,18.452-18.719,18.452s-18.718-7.38-18.718-18.452c-5.617,0-5.617-11.07,0-11.07l2.9-15.088L938.5,54.159l-.412-6.882,12.323,6.882-1.231-6.882Z"
                transform="translate(5.367 3.85)"
                fill="none"
                stroke="#032478"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
            />
            <path
                id="Path_24"
                data-name="Path 24"
                d="M966.238,68.989l1.916-13.847s1.871-18.452-24.335-18.452-24.335,18.452-24.335,18.452L921.4,68.989"
                transform="translate(4.985)"
                fill="none"
                stroke="#032478"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
            />
            <path
                id="Path_25"
                data-name="Path 25"
                d="M939.279,77.335l-23.811,6.432a14.753,14.753,0,0,0-9.722,13.815v9.225H991.86V97.583a14.749,14.749,0,0,0-9.722-13.815L958.4,77.285"
                transform="translate(0 14.764)"
                fill="none"
                stroke="#032478"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
            />
            <path
                id="Path_26"
                data-name="Path 26"
                d="M929.082,61.547c0-2.04,1.675-1.846,3.745-1.846s3.746-.194,3.746,1.846"
                transform="translate(8.487 8.367)"
                fill="none"
                stroke="#032478"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
            />
            <path
                id="Path_27"
                data-name="Path 27"
                d="M940.065,61.547c0-2.04,1.675-1.846,3.745-1.846s3.743-.194,3.743,1.846"
                transform="translate(12.481 8.367)"
                fill="none"
                stroke="#032478"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
            />
        </g>
    </svg>
);

export const womanIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="99.419" height="88.047" viewBox="0 0 99.419 88.047">
        <g id="Group_676" data-name="Group 676" transform="translate(0 -10)">
            <g id="Group_673" data-name="Group 673" transform="translate(0 0)">
                <path
                    id="Path_1056"
                    data-name="Path 1056"
                    d="M60.469,43.91c18.853,8.263,36.9,12.991,36.9,27.444v2.063H1V71.354C1,56.9,19.041,52.173,37.9,43.91"
                    transform="translate(0.526 23.104)"
                    fill="none"
                    stroke="#032478"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                />
                <path
                    id="Path_1057"
                    data-name="Path 1057"
                    d="M46.771,7.866c-29.42,2.913-36.125,44.17-41.657,48.26,0,0,17.72,3.905,24.005-2.292"
                    transform="translate(2.691 5.29)"
                    fill="none"
                    stroke="#032478"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                />
                <path
                    id="Path_1058"
                    data-name="Path 1058"
                    d="M28.83,7.909C62.3,9.071,65.3,52.074,70.975,56.168c0,0-18.187,3.909-24.641-2.295"
                    transform="translate(20.632 5.247)"
                    fill="none"
                    stroke="#032478"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                />
                <path
                    id="Path_1059"
                    data-name="Path 1059"
                    d="M44.525,19.945c-2.265,2.952-12.912,16.2-29.943,16.2"
                    transform="translate(7.747 6.926)"
                    fill="none"
                    stroke="#032478"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                />
                <path
                    id="Path_1060"
                    data-name="Path 1060"
                    d="M60.744,28.133a37.317,37.317,0,0,1-3.985,16.833c.077-.156.671-.122.61,0-4.549,9.113-13.145,10.515-17.575,11.97-6.289-2.063-20.951-4.021-20.951-28.8"
                    transform="translate(9.915 14.802)"
                    fill="none"
                    stroke="#032478"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                />
                <path
                    id="Path_1061"
                    data-name="Path 1061"
                    d="M40.808,19.945c0,4.858,9.979,17,23.286,17"
                    transform="translate(13.089 6.926)"
                    fill="none"
                    stroke="#032478"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                />
                <path
                    id="Path_1062"
                    data-name="Path 1062"
                    d="M24.334,30.136c0-2.283,1.882-2.066,4.189-2.066s4.191-.217,4.191,2.066"
                    transform="translate(12.804 14.766)"
                    fill="none"
                    stroke="#032478"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                />
                <path
                    id="Path_1063"
                    data-name="Path 1063"
                    d="M35.315,30.136c0-2.283,1.882-2.066,4.191-2.066s4.191-.217,4.191,2.066"
                    transform="translate(18.582 14.766)"
                    fill="none"
                    stroke="#032478"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                />
                <path
                    id="Path_1065"
                    data-name="Path 1065"
                    d="M20.216,46v1.532c0,6.843,8.444,12.394,18.856,12.394s18.854-5.551,18.854-12.394V46"
                    transform="translate(10.637 24.205)"
                    fill="none"
                    stroke="#032478"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                />
            </g>
        </g>
    </svg>
);

export const whiteArrowRight = (
    <svg xmlns="http://www.w3.org/2000/svg" width="104.449" height="19.554" viewBox="0 0 104.449 19.554">
        <g id="Group_683" data-name="Group 683" transform="translate(-1590.5 -262.086)">
            <g id="Group_678" data-name="Group 678" transform="translate(1303 -1.392)">
                <line
                    id="Line_1"
                    data-name="Line 1"
                    x2="101.701"
                    transform="translate(288.5 273.258)"
                    fill="none"
                    stroke="#fff"
                    strokeLinecap="round"
                    strokeWidth="2"
                />
                <line
                    id="Line_2"
                    data-name="Line 2"
                    x1="8"
                    y2="8"
                    transform="translate(382.201 273.617)"
                    fill="none"
                    stroke="#fff"
                    strokeLinecap="round"
                    strokeWidth="2"
                />
                <line
                    id="Line_3"
                    data-name="Line 3"
                    x1="8.035"
                    y1="8.244"
                    transform="translate(382.5 264.892)"
                    fill="none"
                    stroke="#fff"
                    strokeLinecap="round"
                    strokeWidth="2"
                />
            </g>
        </g>
    </svg>
);

export const whiteArrowLeft = (
    <svg xmlns="http://www.w3.org/2000/svg" width="104.449" height="19.554" viewBox="0 0 104.449 19.554">
        <g id="Group_670" data-name="Group 670" transform="translate(391.949 283.031) rotate(180)">
            <line
                id="Line_1"
                data-name="Line 1"
                x2="101.701"
                transform="translate(288.5 273.258)"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeWidth="2"
            />
            <line
                id="Line_2"
                data-name="Line 2"
                x1="8"
                y2="8"
                transform="translate(382.201 273.617)"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeWidth="2"
            />
            <line
                id="Line_3"
                data-name="Line 3"
                x1="8"
                y1="8.244"
                transform="translate(382.534 264.892)"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeWidth="2"
            />
        </g>
    </svg>
);

export const changeOrganization = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.08 18.5" stroke="#7284FA">
        <g id="Group_1746" data-name="Group 1746" transform="translate(-792.46 -3312.75)">
            <path id="Path_2196" data-name="Path 2196" d="M808.5,3330.5h-9a3,3,0,0,1-3-3v-8" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
            <path id="Path_2197" data-name="Path 2197" d="M801.5,3313.5h9a3,3,0,0,1,3,3v8" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
            <path id="Path_2198" data-name="Path 2198" d="M793.5,3321.5l3-2,3,2" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
            <path id="Path_2199" data-name="Path 2199" d="M810.5,3322.5l3,2,3-2" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
        </g>
    </svg>
);

export const privacyLogo = (
    <svg xmlns="http://www.w3.org/2000/svg" width="155.344" height="40.052" viewBox="0 0 155.344 40.052">
        <path
            id="Path_5217"
            data-name="Path 5217"
            d="M7.79-9.956V0H2.432V-26.828H12.2q4.75,0,7.163,2.28a8.114,8.114,0,0,1,2.413,6.194,7.892,7.892,0,0,1-2.489,6.118Q16.8-9.956,12.2-9.956Zm3.838-4.294q4.712,0,4.712-4.1a4.083,4.083,0,0,0-1.1-3.078,5.081,5.081,0,0,0-3.61-1.064H7.79v8.246Zm21.28-2.774A8.806,8.806,0,0,1,36.024-20.2a8.278,8.278,0,0,1,4.332-1.159v5.738H38.8q-5.89,0-5.89,5.472V0H27.55V-21.052h5.358Zm12.084-10.07A2.7,2.7,0,0,1,45.9-29.2,3.452,3.452,0,0,1,48.3-30.02a3.452,3.452,0,0,1,2.394.817,2.7,2.7,0,0,1,.912,2.109,2.659,2.659,0,0,1-.912,2.071,3.452,3.452,0,0,1-2.394.817,3.452,3.452,0,0,1-2.394-.817A2.659,2.659,0,0,1,44.992-27.094Zm5.966,6.042V0H45.6V-21.052ZM67.26-5.358l5.32-15.694h5.7L70.49,0H63.954l-7.79-21.052H61.9Zm24.51-15.96a8.09,8.09,0,0,1,4.56,1.254,6.83,6.83,0,0,1,2.7,3.382v-4.37h5.32V0h-5.32V-4.408a6.931,6.931,0,0,1-2.7,3.4A8,8,0,0,1,91.77.266a9.043,9.043,0,0,1-4.788-1.292,8.729,8.729,0,0,1-3.325-3.743,12.98,12.98,0,0,1-1.2-5.757,12.98,12.98,0,0,1,1.2-5.757,8.729,8.729,0,0,1,3.325-3.743A9.043,9.043,0,0,1,91.77-21.318Zm1.672,4.674a5.241,5.241,0,0,0-4.028,1.634,6.326,6.326,0,0,0-1.52,4.484,6.256,6.256,0,0,0,1.52,4.465,5.272,5.272,0,0,0,4.028,1.615A5.3,5.3,0,0,0,97.451-6.1a6.147,6.147,0,0,0,1.577-4.427,6.2,6.2,0,0,0-1.577-4.465A5.3,5.3,0,0,0,93.442-16.644Zm27.512-4.674a10.418,10.418,0,0,1,6.783,2.2,9.629,9.629,0,0,1,3.4,6h-5.662a4.371,4.371,0,0,0-1.558-2.641,4.785,4.785,0,0,0-3.078-.969,4.592,4.592,0,0,0-3.553,1.577,6.672,6.672,0,0,0-1.425,4.617,6.672,6.672,0,0,0,1.425,4.617,4.592,4.592,0,0,0,3.553,1.577,4.785,4.785,0,0,0,3.078-.969,4.371,4.371,0,0,0,1.558-2.641h5.662a9.629,9.629,0,0,1-3.4,6,10.418,10.418,0,0,1-6.783,2.2,11.206,11.206,0,0,1-5.472-1.311,9.215,9.215,0,0,1-3.724-3.743,11.781,11.781,0,0,1-1.33-5.738,11.891,11.891,0,0,1,1.33-5.757,9.065,9.065,0,0,1,3.724-3.743A11.339,11.339,0,0,1,120.954-21.318Zm19.874.266,5.738,14.288,5.32-14.288h5.89L144.894,10.032h-5.928l4.75-10.64-8.854-20.444Z"
            transform="translate(-2.432 30.02)"
            fill="#7284fa"
        />
    </svg>
);

export const dotLegalExpandedNavIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="64.932" height="21.720" viewBox="0 0 32.233 10.875">
        <g id="Group_34" data-name="Group 34" transform="translate(-19.142 -29.434)">
            <g id="Group_33" data-name="Group 33" transform="translate(23.967 29.434)">
                <path id="Path_851" data-name="Path 851" d="M85.314,29.434v7.951H83.8V29.434Z" transform="translate(-83.8 -29.434)" fill="#707070" />
                <path
                    id="Path_852"
                    data-name="Path 852"
                    d="M130.386,58.549h-4.362a1.641,1.641,0,0,0,.429,1.171,1.382,1.382,0,0,0,.988.376,1.435,1.435,0,0,0,.876-.258,1.143,1.143,0,0,0,.446-.7h1.6a2.562,2.562,0,0,1-.5,1.117,2.639,2.639,0,0,1-.994.774,3.4,3.4,0,0,1-2.9-.091,2.6,2.6,0,0,1-1.053-1.058,3.7,3.7,0,0,1,0-3.25,2.563,2.563,0,0,1,1.054-1.058,3.208,3.208,0,0,1,1.547-.365,3.138,3.138,0,0,1,1.542.365,2.576,2.576,0,0,1,1.021,1,2.917,2.917,0,0,1,.36,1.456A2.871,2.871,0,0,1,130.386,58.549Zm-1.853-1.773a1.455,1.455,0,0,0-1.015-.376,1.489,1.489,0,0,0-1.032.376,1.539,1.539,0,0,0-.462,1.107h2.89A1.336,1.336,0,0,0,128.533,56.776Z"
                    transform="translate(-121.501 -53.284)"
                    fill="#707070"
                />
                <path
                    id="Path_853"
                    data-name="Path 853"
                    d="M223.942,55.56a1.932,1.932,0,0,1,.763.956V55.281h1.5v5.974a3.305,3.305,0,0,1-.328,1.488,2.417,2.417,0,0,1-.978,1.037,3.1,3.1,0,0,1-1.574.376,3.322,3.322,0,0,1-2.084-.613,2.533,2.533,0,0,1-.967-1.665h1.494a1.231,1.231,0,0,0,.5.7,1.655,1.655,0,0,0,.951.253,1.487,1.487,0,0,0,1.074-.392,1.576,1.576,0,0,0,.408-1.187V59.987a1.96,1.96,0,0,1-.763.962,2.262,2.262,0,0,1-1.289.36,2.556,2.556,0,0,1-1.354-.365,2.466,2.466,0,0,1-.939-1.058,4.083,4.083,0,0,1,0-3.256,2.468,2.468,0,0,1,.939-1.058,2.558,2.558,0,0,1,1.354-.365A2.288,2.288,0,0,1,223.942,55.56Zm-1.956,1.429a1.788,1.788,0,0,0-.429,1.268,1.768,1.768,0,0,0,.429,1.262,1.628,1.628,0,0,0,2.272-.011,1.995,1.995,0,0,0,0-2.514,1.5,1.5,0,0,0-1.134-.467,1.482,1.482,0,0,0-1.139.462Z"
                    transform="translate(-209.857 -53.282)"
                    fill="#707070"
                />
                <path
                    id="Path_854"
                    data-name="Path 854"
                    d="M327.328,55.561a1.931,1.931,0,0,1,.763.956V55.282h1.5v5.952h-1.5V59.989a1.96,1.96,0,0,1-.763.962,2.262,2.262,0,0,1-1.29.359,2.556,2.556,0,0,1-1.354-.365,2.467,2.467,0,0,1-.939-1.058,4.084,4.084,0,0,1,0-3.256,2.468,2.468,0,0,1,.939-1.058,2.558,2.558,0,0,1,1.354-.365,2.288,2.288,0,0,1,1.29.355Zm-1.956,1.429a1.788,1.788,0,0,0-.429,1.268,1.768,1.768,0,0,0,.429,1.262,1.628,1.628,0,0,0,2.272-.011,1.995,1.995,0,0,0,0-2.514,1.5,1.5,0,0,0-1.134-.467,1.482,1.482,0,0,0-1.139.462Z"
                    transform="translate(-305.529 -53.283)"
                    fill="#707070"
                />
                <path id="Path_855" data-name="Path 855" d="M432.348,29.434v7.951h-1.515V29.434Z" transform="translate(-404.94 -29.434)" fill="#707070" />
            </g>
            <circle id="Ellipse_4" data-name="Ellipse 4" cx="1.178" cy="1.178" r="1.178" transform="translate(19.142 37.145) rotate(-76.717)" fill="#8bbee8" />
        </g>
    </svg>
);

export const riskAssessmentIcon = (
    <svg id="Group_4507" data-name="Group 4507" xmlns="http://www.w3.org/2000/svg" width="21.332" height="15.144" viewBox="0 0 21.332 15.144">
        <g id="Group_4503" data-name="Group 4503" transform="translate(0.5 0.5)">
            <path
                id="Path_8178"
                data-name="Path 8178"
                d="M10.666.5A10.166,10.166,0,0,0,.5,10.666v3.978H20.832V10.666A10.166,10.166,0,0,0,10.666.5Z"
                transform="translate(-0.5 -0.5)"
                fill="#dad9ef"
                stroke="#7284fa"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
            />
            <g id="Group_4504" data-name="Group 4504" transform="translate(1.768 1.768)">
                <circle
                    id="Ellipse_110"
                    data-name="Ellipse 110"
                    cx="1.326"
                    cy="1.326"
                    r="1.326"
                    transform="translate(7.072 7.072)"
                    fill="none"
                    stroke="#7284fa"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_472"
                    data-name="Line 472"
                    y1="4.375"
                    x2="4.376"
                    transform="translate(9.336 3.085)"
                    fill="none"
                    stroke="#7284fa"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_473"
                    data-name="Line 473"
                    x2="1.768"
                    transform="translate(0 8.84)"
                    fill="none"
                    stroke="#7284fa"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_474"
                    data-name="Line 474"
                    x1="1.768"
                    transform="translate(15.028 8.84)"
                    fill="none"
                    stroke="#7284fa"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_475"
                    data-name="Line 475"
                    x1="1.634"
                    y2="0.676"
                    transform="translate(14.522 5.184)"
                    fill="none"
                    stroke="#7284fa"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_476"
                    data-name="Line 476"
                    x1="0.676"
                    y2="1.634"
                    transform="translate(10.934 0.639)"
                    fill="none"
                    stroke="#7284fa"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_477"
                    data-name="Line 477"
                    y2="1.768"
                    transform="translate(8.398)"
                    fill="none"
                    stroke="#7284fa"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_478"
                    data-name="Line 478"
                    x2="0.676"
                    y2="1.634"
                    transform="translate(5.185 0.639)"
                    fill="none"
                    stroke="#7284fa"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_479"
                    data-name="Line 479"
                    x2="1.248"
                    y2="1.251"
                    transform="translate(2.46 2.459)"
                    fill="none"
                    stroke="#7284fa"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_480"
                    data-name="Line 480"
                    x2="1.633"
                    y2="0.676"
                    transform="translate(0.639 5.184)"
                    fill="none"
                    stroke="#7284fa"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
            </g>
        </g>
    </svg>
);

export const exportPdfIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="19.314" height="18.992" viewBox="0 0 19.314 18.992">
        <defs>
            <clipPath id="clipPath">
                <rect id="Rectangle_13238" data-name="Rectangle 13238" width="19.314" height="18.992" fill="none" stroke="#032478" strokeWidth="0.8" />
            </clipPath>
        </defs>
        <g id="Group_5050" data-name="Group 5050" transform="translate(2 1)">
            <g id="Group_5049" data-name="Group 5049" transform="translate(-2 -1)" clipPath="url(#clipPath)">
                <path
                    id="Path_8402"
                    data-name="Path 8402"
                    d="M10.242,6.051H3.971L1,9.17v10.4a.677.677,0,0,0,.66.693h8.582a.677.677,0,0,0,.66-.693V6.744A.677.677,0,0,0,10.242,6.051Z"
                    transform="translate(1.557 -2.785)"
                    fill="none"
                    stroke="#032478"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="0.8"
                />
                <path
                    id="Path_8403"
                    data-name="Path 8403"
                    d="M22.272,15.92l2.311-.347c.454-.065.712-.259.66-.693l-1.65-13.17a.77.77,0,0,0-.99-.693L16,1.711"
                    transform="translate(-8.492 0.516)"
                    fill="none"
                    stroke="#032478"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="0.8"
                />
                <path
                    id="Path_8404"
                    data-name="Path 8404"
                    d="M3.971,6.051V8.477a.677.677,0,0,1-.66.693H1"
                    transform="translate(1.557 -2.785)"
                    fill="none"
                    stroke="#032478"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="0.8"
                />
                <path
                    id="Path_8405"
                    data-name="Path 8405"
                    d="M24.32,27.051H23V30.17"
                    transform="translate(-13.181 -16.507)"
                    fill="none"
                    stroke="#032478"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="0.8"
                />
                <line
                    id="Line_515"
                    data-name="Line 515"
                    x2="0.99"
                    transform="translate(9.819 12.277)"
                    fill="none"
                    stroke="#032478"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="0.8"
                />
                <path
                    id="Path_8406"
                    data-name="Path 8406"
                    d="M6,28.784h.66c.33,0,.66,0,.66-.858,0-.875-.33-.875-.66-.875H6V30.17"
                    transform="translate(-1.792 -16.507)"
                    fill="none"
                    stroke="#032478"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="0.8"
                />
                <path
                    id="Path_8407"
                    data-name="Path 8407"
                    d="M14,30.17h.66c.33,0,.99-.347.99-1.733a1.34,1.34,0,0,0-.99-1.386H14V30.17"
                    transform="translate(-7.152 -16.507)"
                    fill="none"
                    stroke="#032478"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="0.8"
                />
            </g>
        </g>
    </svg>
);

export const warning = (
    <svg xmlns="http://www.w3.org/2000/svg" width="11.177" height="11.177" viewBox="0 0 11.177 11.177">
        <g id="Group_2178" data-name="Group 2178" transform="translate(-1033 -2207)">
            <line
                id="Line_231"
                data-name="Line 231"
                y1="3.54"
                transform="translate(1038.588 2211.04)"
                fill="none"
                stroke="#e3547b"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
            />
            <path
                id="Path_1450"
                data-name="Path 1450"
                d="M1043.677,2217.677H1033.5l5.088-10.177Z"
                fill="none"
                stroke="#e3547b"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
            />
            <path
                id="Path_1451"
                data-name="Path 1451"
                d="M1045.123,2226.061a.561.561,0,0,1-.562.562h0a.562.562,0,0,1-.561-.562h0a.562.562,0,0,1,.561-.562h0a.562.562,0,0,1,.562.562Z"
                transform="translate(-5.973 -10.074)"
                fill="#e3547b"
            />
        </g>
    </svg>
);

// As drawn, the stroke ended 0.29 units above the dot - under half a pixel once rendered - so the two antialiased
// into a single smudge. The stroke is shortened and the dot moved down to a 0.845 unit gap, which stays above a
// whole pixel at the 16px both call sites render at. Colour comes from `currentColor` so callers set it via `color`.
export const warningIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="10.5" height="10.5" viewBox="0 0 10.5 10.5">
        <g id="Group_10305" data-name="Group 10305" transform="translate(0.5 0.5)">
            <line
                id="Line_231"
                data-name="Line 231"
                y1="2.9"
                transform="translate(4.75 3.305)"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
            />
            <path
                id="Path_1450"
                data-name="Path 1450"
                d="M1043,2217h-9.5l4.75-9.5Z"
                transform="translate(-1033.5 -2207.5)"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
            />
            <circle cx="4.75" cy="8.1" r="0.55" fill="currentColor" />
        </g>
    </svg>
);

export const star = (
    <svg xmlns="http://www.w3.org/2000/svg" width="19.76" height="19.065" viewBox="0 0 19.76 19.065">
        <defs>
            <clipPath id="clipPath">
                <rect
                    id="Rectangle_13383"
                    data-name="Rectangle 13383"
                    width="19.76"
                    height="19.065"
                    transform="translate(-2 -2)"
                    fill="#e5e5f7"
                    stroke="#648ef5"
                    strokeWidth="1"
                />
            </clipPath>
        </defs>
        <g id="Group_7609" data-name="Group 7609" transform="translate(2 2)">
            <g id="Group_7608" data-name="Group 7608" transform="translate(0 0)" clipPath="url(#clipPath)">
                <path
                    id="Path_12919"
                    data-name="Path 12919"
                    d="M10.843,5.05,15.31,5.7a.451.451,0,0,1,.249.77L12.323,9.622a.453.453,0,0,0-.131.4l.759,4.451a.452.452,0,0,1-.656.475L8.3,12.843a.45.45,0,0,0-.42,0l-4,2.1a.451.451,0,0,1-.654-.477L4,10.013a.452.452,0,0,0-.129-.4L.637,6.458a.452.452,0,0,1,.251-.769l4.469-.644A.452.452,0,0,0,5.7,4.8L7.7.751a.451.451,0,0,1,.809,0L10.5,4.8a.45.45,0,0,0,.339.247"
                    transform="translate(-0.218 -0.218)"
                    fill="#e5e5f7"
                    stroke="#648ef5"
                    strokeWidth="1"
                />
                <path
                    id="Path_12920"
                    data-name="Path 12920"
                    d="M10.843,5.05,15.31,5.7a.451.451,0,0,1,.249.77L12.323,9.622a.453.453,0,0,0-.131.4l.759,4.451a.452.452,0,0,1-.656.475L8.3,12.843a.45.45,0,0,0-.42,0l-4,2.1a.451.451,0,0,1-.654-.477L4,10.013a.452.452,0,0,0-.129-.4L.637,6.458a.452.452,0,0,1,.251-.769l4.469-.644A.452.452,0,0,0,5.7,4.8L7.7.751a.451.451,0,0,1,.809,0L10.5,4.8A.45.45,0,0,0,10.843,5.05Z"
                    transform="translate(-0.218 -0.218)"
                    fill="#e5e5f7"
                    stroke="#648ef5"
                    strokeMiterlimit="10"
                    strokeWidth="1"
                />
            </g>
        </g>
    </svg>
);

export const dotlegalLinkIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="17.99" height="17.99" viewBox="0 0 12.361 11.195">
        <g id="Group_7636" data-name="Group 7636" transform="translate(-1324.715 -334.682)">
            <path
                id="Path_12989"
                data-name="Path 12989"
                d="M-16621.969,18722.6s1.818-1.773,2.463-1.348a8.568,8.568,0,0,1,1.559,1.816s-.049,1.672-.74,1.969a18.827,18.827,0,0,0-2.76,2.443s-1.574-.062-1.893-.516"
                transform="translate(17953.887 -18385.506)"
                fill="none"
                stroke="#efeffa"
                strokeWidth="2"
            />
            <path
                id="Path_12990"
                data-name="Path 12990"
                d="M23.684,1.262,23.128.706a2.416,2.416,0,0,0-3.413,0L18.529,1.892a.167.167,0,0,0,.066.277L20,2.635a.166.166,0,0,0,.17-.04l.642-.643a.88.88,0,0,1,1.21,0l.411.411a.859.859,0,0,1,0,1.21L20.057,5.954a.85.85,0,0,1-.382.219.86.86,0,0,1-.828-.219l-.235-.235L18.594,5.7a.169.169,0,0,0-.119-.053.152.152,0,0,0-.12.049l-.94.94a.167.167,0,0,0,0,.236l.331.33a2.387,2.387,0,0,0,.851.547,2.422,2.422,0,0,0,2.224-.269,2.389,2.389,0,0,0,.337-.279l2.526-2.526a2.42,2.42,0,0,0,0-3.413m-.236,3.177L20.923,6.965a2.1,2.1,0,0,1-2.208.47,2.06,2.06,0,0,1-.733-.47l-.213-.213.7-.7.14.14a1.194,1.194,0,0,0,1.682,0l.513-.513,1.868-1.868a1.19,1.19,0,0,0,0-1.682l-.411-.411a1.191,1.191,0,0,0-1.682,0l-.57.57-1.056-.349,1-1a2.082,2.082,0,0,1,2.941,0l.556.556a2.086,2.086,0,0,1,0,2.941"
                transform="translate(1312.438 335.049)"
                fill="#efeffa"
                stroke="#618cf5"
                strokeWidth="0.5"
            />
            <path
                id="Path_12992"
                data-name="Path 12992"
                d="M-16621.814,18744.162c-.316-.527-2.191-.359-2.191-.359l-3.113,3.176.115.178a1.5,1.5,0,0,0,.406,1.7,13.61,13.61,0,0,0,1.477.973s1.938-.828,2.086-.973"
                transform="translate(17953 -18405)"
                fill="none"
                stroke="#efeffa"
                strokeWidth="1"
            />
            <path
                id="Path_12991"
                data-name="Path 12991"
                d="M5.8,19.265,4.386,18.8a.166.166,0,0,0-.17.04l-.642.643a.88.88,0,0,1-1.21,0l-.411-.411a.859.859,0,0,1,0-1.211l2.38-2.38a.848.848,0,0,1,.382-.219.859.859,0,0,1,.829.219l.236.237.016.018a.168.168,0,0,0,.119.054.181.181,0,0,0,.121-.049l.94-.94a.166.166,0,0,0,0-.235l-.331-.331a2.383,2.383,0,0,0-.851-.547,2.421,2.421,0,0,0-2.224.268,2.385,2.385,0,0,0-.338.279L.706,16.759a2.416,2.416,0,0,0,0,3.413l.556.556a2.417,2.417,0,0,0,3.413,0l1.187-1.187a.167.167,0,0,0-.066-.276M4.439,20.492a2.082,2.082,0,0,1-2.941,0l-.556-.556A2.082,2.082,0,0,1,.941,17l2.526-2.526a2.035,2.035,0,0,1,.291-.24A2.091,2.091,0,0,1,5.676,14a2.051,2.051,0,0,1,.733.47l.213.213-.7.7-.14-.14a1.193,1.193,0,0,0-1.682,0L1.716,17.625a1.19,1.19,0,0,0,0,1.682l.411.411a1.19,1.19,0,0,0,1.682,0l.57-.57,1.055.349Z"
                transform="translate(1324.965 324.193)"
                fill="#efeffa"
                stroke="#618cf5"
                strokeWidth="0.5"
            />
        </g>
    </svg>
);

export const taskManagementIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="24.002" height="24.002" viewBox="0 0 24.002 24.002">
        <defs>
            <clipPath id="clip-path">
                <rect id="Rectangle_13076" data-name="Rectangle 13076" width="23.502" height="24.002" transform="translate(0 0)" fill="#d9daee" />
            </clipPath>
        </defs>
        <g id="Group_4652" data-name="Group 4652" transform="translate(-35 -404)">
            <rect id="Rectangle_13077" data-name="Rectangle 13077" width="19" height="15" transform="translate(36 407)" fill="#d9daee" />
            <g id="Group_4649" data-name="Group 4649" transform="translate(35 404)">
                <path
                    id="Path_8194"
                    data-name="Path 8194"
                    d="M20.5,10V2.5h-4"
                    fill="#d9daee"
                    stroke="#7284fa"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <g id="Group_4644" data-name="Group 4644">
                    <g id="Group_4650" data-name="Group 4650">
                        <path
                            id="Path_8195"
                            data-name="Path 8195"
                            d="M4.5,2.5H.5v16h11"
                            fill="#d9daee"
                            stroke="#7284fa"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                        />
                        <rect
                            id="Rectangle_13072"
                            data-name="Rectangle 13072"
                            width="3"
                            height="4"
                            transform="translate(4.5 0.5)"
                            fill="#d9daee"
                            stroke="#7284fa"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                        />
                        <rect
                            id="Rectangle_13073"
                            data-name="Rectangle 13073"
                            width="3"
                            height="4"
                            transform="translate(13.5 0.5)"
                            fill="#d9daee"
                            stroke="#7284fa"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                        />
                    </g>
                </g>
                <line
                    id="Line_490"
                    data-name="Line 490"
                    x2="6"
                    transform="translate(7.5 2.5)"
                    fill="none"
                    stroke="#7284fa"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <g id="Group_4646" data-name="Group 4646">
                    <g id="Group_4651" data-name="Group 4651">
                        <line
                            id="Line_491"
                            data-name="Line 491"
                            x2="20"
                            transform="translate(0.5 7.5)"
                            fill="none"
                            stroke="#7284fa"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                        />
                        <path
                            id="Path_8196"
                            data-name="Path 8196"
                            d="M15.5,22.5l-3.5,1L13,20l7.5-7.5L23,15Z"
                            fill="#d9daee"
                            stroke="#7284fa"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                        />
                    </g>
                </g>
                <line
                    id="Line_492"
                    data-name="Line 492"
                    x2="2.5"
                    y2="2.5"
                    transform="translate(18.502 14.5)"
                    fill="none"
                    stroke="#7284fa"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <g id="Group_4648" data-name="Group 4648">
                    <g id="Group_4647" data-name="Group 4647" clipPath="url(#clip-path)">
                        <line
                            id="Line_493"
                            data-name="Line 493"
                            x2="2.5"
                            y2="2.5"
                            transform="translate(13 20.002)"
                            fill="none"
                            stroke="#7284fa"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const annualWheelIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23.999" viewBox="0 0 24 23.999">
        <defs>
            <clipPath id="clip-path">
                <rect
                    id="Rectangle_13736"
                    data-name="Rectangle 13736"
                    width="24"
                    height="23.999"
                    transform="translate(0 0)"
                    fill="none"
                    stroke="#7284fa"
                    strokeWidth="1"
                />
            </clipPath>
        </defs>
        <g id="Group_7855" data-name="Group 7855" transform="translate(-1721 -139)">
            <path id="Path_8691" data-name="Path 8691" d="M1725.986,160.871v-4.146l5.976.718Z" fill="#d9daee" />
            <circle id="Ellipse_523" data-name="Ellipse 523" cx="6.5" cy="6.5" r="6.5" transform="translate(1731 140)" fill="#d9daee" />
            <g id="Group_7764" data-name="Group 7764" transform="translate(1721 139)">
                <g id="Group_7763" data-name="Group 7763" clipPath="url(#clip-path)">
                    <circle
                        id="Ellipse_521"
                        data-name="Ellipse 521"
                        cx="7"
                        cy="7"
                        r="7"
                        transform="translate(9.5 0.5)"
                        fill="none"
                        stroke="#7284fa"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                    />
                    <path
                        id="Path_8685"
                        data-name="Path 8685"
                        d="M16.5,4.5v3l3.5,3"
                        fill="none"
                        stroke="#7284fa"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                    />
                    <rect
                        id="Rectangle_13735"
                        data-name="Rectangle 13735"
                        width="4"
                        height="7"
                        transform="translate(0.5 16.499)"
                        fill="#d9daee"
                        stroke="#7284fa"
                        strokeLinejoin="round"
                        strokeWidth="1"
                    />
                    <path
                        id="Path_8686"
                        data-name="Path 8686"
                        d="M4.5,22.5h17c0-1.5-3.5-3-7.5-3H7"
                        fill="#d9daee"
                        stroke="#7284fa"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                    />
                    <path
                        id="Path_8687"
                        data-name="Path 8687"
                        d="M4.5,17.5H8a5.19,5.19,0,0,1,4,2"
                        fill="#d9daee"
                        stroke="#7284fa"
                        strokeLinejoin="round"
                        strokeWidth="1"
                    />
                </g>
            </g>
        </g>
    </svg>
);

export const playIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="25.026" viewBox="0 0 20 15.026">
        <g id="Group_7696" data-name="Group 7696" transform="translate(-3354 835.026)">
            <g id="Path_12548" data-name="Path 12548" transform="translate(3366.459 -828.458) rotate(90)" fill="#7284fa">
                <path d="M2.258.15a.331.331,0,0,1,.554,0l2.2,3.37a.331.331,0,0,1-.277.513H.332A.331.331,0,0,1,.055,3.52Z" stroke="none" />
                <path
                    d="M 2.534980535507202 -1.668930053710938e-06 C 2.640915632247925 -1.668930053710938e-06 2.746850490570068 0.0499885082244873 2.812220573425293 0.1499683856964111 L 5.015410423278809 3.519558429718018 C 5.159460544586182 3.739868402481079 5.00139045715332 4.032068252563477 4.738170623779297 4.032068252563477 L 0.3317904472351074 4.032068252563477 C 0.06857061386108398 4.032068252563477 -0.08949947357177734 3.739868402481079 0.0545506477355957 3.519558429718018 L 2.257740497589111 0.1499683856964111 C 2.323110580444336 0.0499885082244873 2.429045438766479 -1.668930053710938e-06 2.534980535507202 -1.668930053710938e-06 Z"
                    stroke="none"
                    fill="#7284fa"
                />
            </g>
            <g id="Group_7692" data-name="Group 7692" transform="translate(3354 -835)">
                <g id="Rectangle_13861" data-name="Rectangle 13861" fill="none" stroke="#7284fa" strokeWidth="1">
                    <rect width="20" height="15" rx="3" stroke="none" />
                    <rect x="0.5" y="0.5" width="19" height="14" rx="2.5" fill="none" />
                </g>
            </g>
            <path
                id="Path_12549"
                data-name="Path 12549"
                d="M3107.92-1168.07H3126.3"
                transform="translate(247.107 336.912)"
                fill="none"
                stroke="#7284fa"
                strokeLinecap="round"
                strokeWidth="1"
            />
            <path
                id="Path_12550"
                data-name="Path 12550"
                d="M3111.792-1171.136l2.813-3.161"
                transform="translate(245.346 339.979)"
                fill="none"
                stroke="#7284fa"
                strokeLinecap="round"
                strokeWidth="1"
            />
            <path
                id="Path_12551"
                data-name="Path 12551"
                d="M3111.792-1171.207l3.146-3.091"
                transform="translate(249.062 339.979)"
                fill="none"
                stroke="#7284fa"
                strokeLinecap="round"
                strokeWidth="1"
            />
            <path
                id="Path_12552"
                data-name="Path 12552"
                d="M3111.791-1170.913l3.432-3.384"
                transform="translate(253.024 339.756)"
                fill="none"
                stroke="#7284fa"
                strokeWidth="1"
            />
            <path
                id="Path_12553"
                data-name="Path 12553"
                d="M3111.792-1171.769l2.956-2.89"
                transform="translate(256.74 340.611)"
                fill="none"
                stroke="#7284fa"
                strokeLinecap="round"
                strokeWidth="1"
            />
        </g>
    </svg>
);

export const notificationIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="16.722" height="16.851" viewBox="0 0 16.722 16.851">
        <g id="Group_7673" data-name="Group 7673" transform="translate(-5488.092 -8151.277)">
            <g id="Group_7672" data-name="Group 7672" transform="translate(5485.669 8151.778)">
                <g id="Ellipse_162" data-name="Ellipse 162" transform="translate(8.934 12.937)" fill="#b7c1fb" stroke="#7181f9" strokeWidth="1">
                    <circle cx="1.706" cy="1.706" r="1.706" stroke="none" />
                    <circle cx="1.706" cy="1.706" r="1.206" fill="none" />
                </g>
                <path
                    id="Path_12504"
                    data-name="Path 12504"
                    d="M5508.891,8172.459s.239-.008.667-.035c1.66-.1,7.766-.595,5.622-2.1-2.5-1.757-1.62-1.453-2.186-6.615s-4.307-4.957-4.307-4.957-.209-1.109-1.061-1.072-.967.969-.967.969-3.514-.12-4.234,4.637.454,5.432-2.051,7.038,5.97,2.136,5.97,2.136"
                    transform="translate(-5496.987 -8157.678)"
                    fill="#b9c0ed"
                    stroke="#7181f9"
                    strokeWidth="1"
                />
                <path
                    id="Path_12536"
                    data-name="Path 12536"
                    d="M24.019,6.319a8.1,8.1,0,0,1,.958,3.157c.128,1.4-.347,4.358,1.1,5.056s-1.239,1.364-2.19.329.015-2.022-.42-4.287A31.275,31.275,0,0,0,22.1,5.087C21.566,3.835,23.544,5.322,24.019,6.319Z"
                    transform="translate(-10.209 -2.244)"
                    fill="#d4dafd"
                />
            </g>
        </g>
    </svg>
);

export const newFunctionalityIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="21.25" height="21.702" viewBox="0 0 21.25 21.702">
        <defs>
            <clipPath id="clip-path">
                <rect id="Rectangle_13835" data-name="Rectangle 13835" width="21.25" height="21.702" fill="none" />
            </clipPath>
        </defs>
        <g id="Group_7925" data-name="Group 7925" transform="translate(-502 -525.498)">
            <path
                id="Path_8734"
                data-name="Path 8734"
                d="M5.5,0a5.5,5.5,0,0,1,0,11c-3.038,0-.859.031-3.367-4.7S2.462,0,5.5,0Z"
                transform="translate(511 527)"
                fill="#dad9ef"
            />
            <g id="Group_7919" data-name="Group 7919" transform="translate(502 525.498)">
                <g id="Group_7915" data-name="Group 7915" clipPath="url(#clip-path)">
                    <circle
                        id="Ellipse_579"
                        data-name="Ellipse 579"
                        cx="3.165"
                        cy="3.165"
                        r="3.165"
                        transform="translate(2.261 0.452)"
                        fill="#dad9ef"
                        stroke="#7284fa"
                        strokeLinejoin="round"
                        strokeWidth="1"
                    />
                    <path
                        id="Path_8729"
                        data-name="Path 8729"
                        d="M10.447,9.5H.5c0,3.679,1.483,5.825,3.165,6.782V22.16H7.282V16.282C8.962,15.325,10.447,13.179,10.447,9.5Z"
                        transform="translate(-0.048 -0.91)"
                        fill="#dad9ef"
                        stroke="#7284fa"
                        strokeLinejoin="round"
                        strokeWidth="1"
                    />
                    <path
                        id="Path_8730"
                        data-name="Path 8730"
                        d="M6.356,9.5h-.9L5,14.926l.9.9.9-.9Z"
                        transform="translate(-0.479 -0.91)"
                        fill="none"
                        stroke="#7284fa"
                        strokeLinejoin="round"
                        strokeWidth="1"
                    />
                    <path
                        id="Path_8731"
                        data-name="Path 8731"
                        d="M12.1,2.8a5.425,5.425,0,1,1,1.4,9.117"
                        transform="translate(-1.159 -0.144)"
                        fill="#dad9ef"
                        stroke="#7284fa"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                    />
                    <path
                        id="Path_8732"
                        data-name="Path 8732"
                        d="M22.086.5,15.857,8.8,13.45,6.389"
                        transform="translate(-1.288 -0.048)"
                        fill="none"
                        stroke="#7284fa"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                    />
                </g>
            </g>
        </g>
    </svg>
);

export const newRulesIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="20.794" height="20.869" viewBox="0 0 20.794 20.869">
        <defs>
            <clipPath id="clip-path">
                <rect id="Rectangle_13830" data-name="Rectangle 13830" width="18.794" height="18.869" fill="none" />
            </clipPath>
            <clipPath id="clip-path-2">
                <rect id="Rectangle_13834" data-name="Rectangle 13834" width="20.794" height="20.869" transform="translate(-1 -1)" fill="#dad9ef" />
            </clipPath>
        </defs>
        <g id="Group_7918" data-name="Group 7918" transform="translate(1 1)">
            <g id="Group_7911" data-name="Group 7911">
                <g id="Group_7910" data-name="Group 7910" clipPath="url(#clip-path)">
                    <rect
                        id="Rectangle_13828"
                        data-name="Rectangle 13828"
                        width="4.717"
                        height="18.083"
                        transform="translate(3.538 0.393)"
                        fill="#dad9ef"
                        stroke="#7284fa"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                    />
                    <path
                        id="Path_8735"
                        data-name="Path 8735"
                        d="M0,0H4.717V11.793H0Z"
                        transform="translate(8.255 6.683)"
                        fill="#dad9ef"
                        stroke="#7284fa"
                        strokeLinecap="round"
                        strokeWidth="1"
                    />
                </g>
            </g>
            <line
                id="Line_653"
                data-name="Line 653"
                x2="1.572"
                transform="translate(9.828 16.904)"
                fill="none"
                stroke="#7284fa"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
            />
            <line
                id="Line_654"
                data-name="Line 654"
                y2="10.221"
                transform="translate(5.897 1.966)"
                fill="none"
                stroke="#7284fa"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
            />
            <rect
                id="Rectangle_13831"
                data-name="Rectangle 13831"
                width="1.572"
                height="3.145"
                transform="translate(5.11 13.759)"
                fill="none"
                stroke="#7284fa"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
            />
            <line
                id="Line_655"
                data-name="Line 655"
                y2="7.076"
                transform="translate(10.614 8.255)"
                fill="none"
                stroke="#7284fa"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
            />
            <line
                id="Line_656"
                data-name="Line 656"
                y2="11.007"
                transform="translate(1.966 5.11)"
                fill="none"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
            />
            <g id="Group_7913" data-name="Group 7913">
                <g id="Group_7912" data-name="Group 7912" clipPath="url(#clip-path-2)">
                    <rect
                        id="Rectangle_13832"
                        data-name="Rectangle 13832"
                        width="3.145"
                        height="15.725"
                        transform="translate(0.393 2.752)"
                        fill="#dad9ef"
                        stroke="#7284fa"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                    />
                    <rect
                        id="Rectangle_13833"
                        data-name="Rectangle 13833"
                        width="2.358"
                        height="15.725"
                        transform="matrix(0.968, -0.25, 0.25, 0.968, 12.186, 3.251)"
                        fill="#dad9ef"
                        stroke="#7284fa"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                    />
                </g>
            </g>
        </g>
    </svg>
);

export const addSectionIcon = (
    <svg id="Group_8586" data-name="Group 8586" xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23">
        <g id="Group_8585" data-name="Group 8585">
            <circle
                id="Ellipse_543"
                data-name="Ellipse 543"
                cx="10.455"
                cy="10.455"
                r="10.455"
                transform="translate(1.045 1.045)"
                fill="#dad9ef"
                stroke="#7284fa"
                strokeLinejoin="round"
                strokeWidth="1"
            />
            <line
                id="Line_518"
                data-name="Line 518"
                y2="10.455"
                transform="translate(11.5 6.273)"
                fill="none"
                stroke="#7284fa"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
            />
            <line
                id="Line_519"
                data-name="Line 519"
                x1="10.455"
                transform="translate(6.273 11.5)"
                fill="none"
                stroke="#7284fa"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
            />
        </g>
    </svg>
);

export const notificationTaskIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <defs>
            <clipPath id="clip-path">
                <rect id="Rectangle_13827" data-name="Rectangle 13827" width="24" height="24" fill="#dad9ef" stroke="#7284fa" strokeWidth="1" />
            </clipPath>
        </defs>
        <g id="Group_7920" data-name="Group 7920" transform="translate(-497 -191.465)">
            <rect id="Rectangle_13836" data-name="Rectangle 13836" width="12" height="17" transform="translate(501 196)" fill="#dad9ef" />
            <g id="Group_7917" data-name="Group 7917" transform="translate(497 191.465)">
                <rect id="Rectangle_13838" data-name="Rectangle 13838" width="2" height="4" transform="translate(0.5 4.535) rotate(-90)" fill="#dad9ef" />
                <path id="Path_8733" data-name="Path 8733" d="M-.338,0H3V7.273L.23,9.469Z" transform="translate(15 2.535)" fill="#dad9ef" />
                <g id="Group_7908" data-name="Group 7908" clipPath="url(#clip-path)">
                    <circle
                        id="Ellipse_578"
                        data-name="Ellipse 578"
                        cx="6"
                        cy="6"
                        r="6"
                        transform="translate(11.5 11.5)"
                        fill="#dad9ef"
                        stroke="#7284fa"
                        strokeLinejoin="round"
                        strokeWidth="1"
                    />
                    <line
                        id="Line_647"
                        data-name="Line 647"
                        x2="5"
                        transform="translate(15 17.5)"
                        fill="none"
                        stroke="#7284fa"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                    />
                    <line
                        id="Line_648"
                        data-name="Line 648"
                        y1="5"
                        transform="translate(17.5 15)"
                        fill="none"
                        stroke="#7284fa"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                    />
                    <path
                        id="Path_8724"
                        data-name="Path 8724"
                        d="M11,23.5H.5V2.5h2"
                        fill="#dad9ef"
                        stroke="#7284fa"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                    />
                    <path
                        id="Path_8725"
                        data-name="Path 8725"
                        d="M16.5,2.5h2v7"
                        fill="#dad9ef"
                        stroke="#7284fa"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                    />
                    <path
                        id="Path_8726"
                        data-name="Path 8726"
                        d="M11.5,2.5a2,2,0,0,0-4,0h-3v3h10v-3Z"
                        fill="#dad9ef"
                        stroke="#7284fa"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                    />
                    <path
                        id="Path_8727"
                        data-name="Path 8727"
                        d="M16.5,9.5v-5h-2"
                        fill="#dad9ef"
                        stroke="#7284fa"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                    />
                    <path
                        id="Path_8728"
                        data-name="Path 8728"
                        d="M4.5,4.5h-2v17h8"
                        fill="#dad9ef"
                        stroke="#7284fa"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                    />
                    <line
                        id="Line_649"
                        data-name="Line 649"
                        x2="8"
                        transform="translate(5.5 9.5)"
                        fill="none"
                        stroke="#7284fa"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                    />
                    <line
                        id="Line_650"
                        data-name="Line 650"
                        x2="6.5"
                        transform="translate(5.5 11.5)"
                        fill="none"
                        stroke="#7284fa"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                    />
                    <line
                        id="Line_651"
                        data-name="Line 651"
                        x2="5"
                        transform="translate(5.5 13.5)"
                        fill="none"
                        stroke="#7284fa"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                    />
                    <line
                        id="Line_652"
                        data-name="Line 652"
                        x2="4.5"
                        transform="translate(5.5 15.5)"
                        fill="none"
                        stroke="#7284fa"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                    />
                </g>
            </g>
        </g>
    </svg>
);

export const policiesIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="21" viewBox="0 0 19 21">
        <defs>
            <clipPath id="clip-path">
                <rect
                    id="Rectangle_13738"
                    data-name="Rectangle 13738"
                    width="19"
                    height="21"
                    transform="translate(0 -0.273)"
                    fill="#dad9ef"
                    stroke="#7284fa"
                    strokeWidth="1"
                />
            </clipPath>
            <clipPath id="clip-path-2">
                <rect id="Rectangle_13740" data-name="Rectangle 13740" width="6" height="7" fill="none" stroke="#7284fa" strokeWidth="1" />
            </clipPath>
        </defs>
        <g id="Group_8530" data-name="Group 8530" transform="translate(-36 -448)">
            <g id="Group_8527" data-name="Group 8527" transform="translate(0 1)">
                <rect id="Rectangle_13739" data-name="Rectangle 13739" width="17" height="19" transform="translate(36 448)" fill="#dbd8f0" />
                <g id="Group_7834" data-name="Group 7834" transform="translate(36 447.273)">
                    <g id="Group_7832" data-name="Group 7832" clipPath="url(#clip-path)">
                        <path
                            id="Path_13032"
                            data-name="Path 13032"
                            d="M5.182,0A5.182,5.182,0,1,1,0,5.182,5.182,5.182,0,0,1,5.182,0Z"
                            transform="translate(8.205 9.932)"
                            fill="#dad9ef"
                            stroke="#7284fa"
                            strokeWidth="1"
                        />
                        <path
                            id="Path_13033"
                            data-name="Path 13033"
                            d="M0,0"
                            transform="translate(13.386 12.523)"
                            fill="none"
                            stroke="#7284fa"
                            strokeLinecap="round"
                            strokeWidth="1"
                        />
                        <path
                            id="Path_13030"
                            data-name="Path 13030"
                            d="M7.409,20.636H2.227A1.728,1.728,0,0,1,.5,18.909V2.5"
                            transform="translate(-0.068 -0.341)"
                            fill="#dad9ef"
                            stroke="#7284fa"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                        />
                        <path
                            id="Path_13031"
                            data-name="Path 13031"
                            d="M16.909.5H2.227a1.727,1.727,0,0,0,0,3.455H16.909V7.841"
                            transform="translate(-0.068 -0.068)"
                            fill="#dad9ef"
                            stroke="#7284fa"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                        />
                        <line
                            id="Line_496"
                            data-name="Line 496"
                            x2="13.818"
                            transform="translate(2.159 2.159)"
                            fill="none"
                            stroke="#7284fa"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                        />
                    </g>
                </g>
                <g id="Group_7836" data-name="Group 7836" transform="translate(46.5 459)">
                    <g id="Group_7835" data-name="Group 7835" clipPath="url(#clip-path-2)">
                        <path
                            id="Path_13034"
                            data-name="Path 13034"
                            d="M5.5,3,3,.5.5,3"
                            fill="none"
                            stroke="#7284fa"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                        />
                        <line
                            id="Line_497"
                            data-name="Line 497"
                            y1="6"
                            transform="translate(3 0.5)"
                            fill="none"
                            stroke="#7284fa"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const newCommentIcon = (
    <svg id="Group_8416" data-name="Group 8416" xmlns="http://www.w3.org/2000/svg" width="22" height="19" viewBox="0 0 22 19">
        <defs>
            <clipPath id="clip-path">
                <rect id="Rectangle_14021" data-name="Rectangle 14021" width="22" height="19" fill="#d6daf3" stroke="#659cfc" strokeWidth="1" />
            </clipPath>
        </defs>
        <g id="Group_8414" data-name="Group 8414">
            <g id="Group_8413" data-name="Group 8413" clipPath="url(#clip-path)">
                <path
                    id="Path_9368"
                    data-name="Path 9368"
                    d="M20.974,14.743H10.292L6.731,18.3V14.743H.5V.5H20.974Z"
                    transform="translate(-0.055 -0.055)"
                    fill="#d6daf3"
                    stroke="#659cfc"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
            </g>
        </g>
        <line
            id="Line_579"
            data-name="Line 579"
            x2="8.011"
            transform="translate(4.896 4.896)"
            fill="none"
            stroke="#659cfc"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
        />
        <line
            id="Line_580"
            data-name="Line 580"
            x2="11.572"
            transform="translate(4.896 7.566)"
            fill="none"
            stroke="#659cfc"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
        />
        <line
            id="Line_581"
            data-name="Line 581"
            x2="11.572"
            transform="translate(4.896 10.237)"
            fill="none"
            stroke="#659cfc"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
        />
    </svg>
);

export const closeDialogXIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="14.828" height="14.828" viewBox="0 0 14.828 14.828">
        <g id="Group_967" data-name="Group 967" transform="translate(-1108.086 -210.086)">
            <line
                id="Line_169"
                data-name="Line 169"
                x2="12"
                y2="12"
                transform="translate(1109.5 211.5)"
                fill="none"
                stroke="#183683"
                strokeLinecap="round"
                strokeWidth="2"
            />
            <line
                id="Line_170"
                data-name="Line 170"
                x1="12"
                y2="12"
                transform="translate(1109.5 211.5)"
                fill="none"
                stroke="#183683"
                strokeLinecap="round"
                strokeWidth="2"
            />
        </g>
    </svg>
);

export const processingActivityDraft = (
    <svg xmlns="http://www.w3.org/2000/svg" width="16.84" height="16.808" viewBox="0 0 16.84 16.808">
        <g id="Group_8645" data-name="Group 8645" transform="translate(0.052 0.052)">
            <g id="Group_8644" data-name="Group 8644" transform="translate(0.448 0.448)">
                <g id="Group_8646" data-name="Group 8646">
                    <path
                        id="Path_13574"
                        data-name="Path 13574"
                        d="M13.584,8.653v8.263H.5V2.455h9.641"
                        transform="translate(-0.5 -1.109)"
                        fill="#d5d4ed"
                        stroke="#6779f9"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                    />
                    <path
                        id="Path_13575"
                        data-name="Path 13575"
                        d="M11.283,9.8,7.875,11.262,9.336,7.852,16.689.5l1.947,1.947Z"
                        transform="translate(-2.796 -0.5)"
                        fill="#d5d4ed"
                        stroke="#6779f9"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                    />
                </g>
            </g>
            <line
                id="Line_596"
                data-name="Line 596"
                x1="1.948"
                y1="1.948"
                transform="translate(13.076 1.712)"
                fill="none"
                stroke="#6779f9"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
            />
            <line
                id="Line_597"
                data-name="Line 597"
                x1="1.947"
                y1="1.949"
                transform="translate(6.988 7.801)"
                fill="none"
                stroke="#6779f9"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
            />
        </g>
    </svg>
);

export const processingActivityArchived = (
    <svg xmlns="http://www.w3.org/2000/svg" width="17.318" height="13.771" viewBox="0 0 17.318 13.771">
        <g id="Group_8653" data-name="Group 8653" transform="translate(0.145 0.146)">
            <g id="Group_8652" data-name="Group 8652">
                <g id="Group_8654" data-name="Group 8654">
                    <rect
                        id="Rectangle_14445"
                        data-name="Rectangle 14445"
                        width="16.318"
                        height="3.547"
                        transform="translate(0.355 0.355)"
                        fill="#d5d4ed"
                        stroke="#6779f9"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                    />
                    <rect
                        id="Rectangle_14446"
                        data-name="Rectangle 14446"
                        width="14.899"
                        height="9.223"
                        transform="translate(1.064 3.902)"
                        fill="#d5d4ed"
                        stroke="#6779f9"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                    />
                </g>
            </g>
            <rect
                id="Rectangle_14448"
                data-name="Rectangle 14448"
                width="4.966"
                height="1.419"
                transform="translate(6.031 6.031)"
                fill="#d5d4ed"
                stroke="#6779f9"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
            />
        </g>
    </svg>
);

export const processingActivityAwaitingResearcher = (
    <svg xmlns="http://www.w3.org/2000/svg" width="11.625" height="16.333" viewBox="0 0 11.625 16.333">
        <g id="Group_8648" data-name="Group 8648" transform="translate(0.188 0.167)">
            <g id="Group_8650" data-name="Group 8650" transform="translate(0 -0.001)">
                <path
                    id="Path_13576"
                    data-name="Path 13576"
                    d="M10.625,3.833A4.205,4.205,0,0,1,6.562,8.167,4.2,4.2,0,0,1,2.5,3.833V.5h8.125Z"
                    transform="translate(-0.938 -0.166)"
                    fill="#d5d4ed"
                    stroke="#6779f9"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <path
                    id="Path_13577"
                    data-name="Path 13577"
                    d="M10.625,16.333A4.205,4.205,0,0,0,6.562,12,4.2,4.2,0,0,0,2.5,16.333v3.333h8.125Z"
                    transform="translate(-0.938 -3.999)"
                    fill="#d5d4ed"
                    stroke="#6779f9"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_598"
                    data-name="Line 598"
                    x2="10.625"
                    transform="translate(0.312 0.334)"
                    fill="none"
                    stroke="#6779f9"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_599"
                    data-name="Line 599"
                    x2="10.625"
                    transform="translate(0.312 15.667)"
                    fill="none"
                    stroke="#6779f9"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <path
                    id="Path_13578"
                    data-name="Path 13578"
                    d="M2.5,18.5H4.687l1.875-2,1.875,2h2.187"
                    transform="translate(-0.938 -5.5)"
                    fill="#d5d4ed"
                    stroke="#6779f9"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_600"
                    data-name="Line 600"
                    x2="6.38"
                    transform="translate(2.435 6.334)"
                    fill="none"
                    stroke="#6779f9"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
            </g>
        </g>
    </svg>
);

export const processingActivityDraftSubmitted = (
    <svg xmlns="http://www.w3.org/2000/svg" width="16.569" height="16.569" viewBox="0 0 16.569 16.569">
        <g id="Group_8657" data-name="Group 8657" transform="translate(0.162 0.161)">
            <g id="Group_8656" data-name="Group 8656">
                <g id="Group_8658" data-name="Group 8658">
                    <path
                        id="Path_13579"
                        data-name="Path 13579"
                        d="M10.654,10.654v5.415H.5V.5H16.069V10.654Z"
                        transform="translate(-0.162 -0.162)"
                        fill="#d5d4ed"
                        stroke="#6779f9"
                        strokeLinejoin="round"
                        strokeWidth="1"
                    />
                    <line
                        id="Line_601"
                        data-name="Line 601"
                        x1="5.415"
                        y2="5.415"
                        transform="translate(10.492 10.492)"
                        fill="none"
                        stroke="#6779f9"
                        strokeLinejoin="round"
                        strokeWidth="1"
                    />
                </g>
            </g>
            <path
                id="Path_13580"
                data-name="Path 13580"
                d="M13.785,6,8.031,12.431,6,10.4"
                transform="translate(-1.938 -1.938)"
                fill="#d5d4ed"
                stroke="#6779f9"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
            />
        </g>
    </svg>
);

export const downloadIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="19.5" height="19.5" viewBox="0 0 19.5 19.5">
        <g id="Group_8692" data-name="Group 8692" transform="translate(-984.75 -2589.75)">
            <path
                id="Path_1070"
                data-name="Path 1070"
                d="M1003.5,2607.718v1.565a2.348,2.348,0,0,1-2.347,2.347H987.847a2.347,2.347,0,0,1-2.347-2.347v-1.565"
                transform="translate(0 -3.13)"
                fill="#b6d5ef"
                stroke="#7284fa"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
            />
            <line
                id="Line_163"
                data-name="Line 163"
                y1="13.997"
                transform="translate(994.5 2590.5)"
                fill="none"
                stroke="#7284fa"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
            />
            <path
                id="Path_1071"
                data-name="Path 1071"
                d="M1000.955,2600.608l-5.727,5.727-5.727-5.727"
                transform="translate(-0.727 -1.838)"
                fill="#b6d5ef"
                stroke="#7284fa"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
            />
        </g>
    </svg>
);

export const removeIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="14.513" height="14.513" viewBox="0 0 14.513 14.513">
        <g id="Group_2988" data-name="Group 2988" transform="translate(-1653.086 -570.086)">
            <line
                id="Line_404"
                data-name="Line 404"
                x2="11.685"
                y2="11.685"
                transform="translate(1654.5 571.5)"
                fill="none"
                stroke="#ff3f78"
                strokeLinecap="round"
                strokeWidth="2"
            />
            <line
                id="Line_405"
                data-name="Line 405"
                x1="11.685"
                y2="11.685"
                transform="translate(1654.5 571.5)"
                fill="none"
                stroke="#ff3f78"
                strokeLinecap="round"
                strokeWidth="2"
            />
        </g>
    </svg>
);

export const WhiteLockIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="14.37" height="19.16" viewBox="0 0 14.37 19.16">
        <path
            id="padlock_3064155"
            d="M15.574,7.185h-.6V4.79a4.79,4.79,0,1,0-9.58,0V7.185H4.8A1.8,1.8,0,0,0,3,8.981v8.382a1.8,1.8,0,0,0,1.8,1.8H15.574a1.8,1.8,0,0,0,1.8-1.8V8.981A1.8,1.8,0,0,0,15.574,7.185ZM6.992,4.79a3.193,3.193,0,0,1,6.387,0V7.185H6.992Zm3.992,8.56v1.819a.8.8,0,1,1-1.6,0V13.35a1.6,1.6,0,1,1,1.6,0Z"
            transform="translate(-3)"
            fill="#fff"
        />
    </svg>
);

export const PurpleLockIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="14.37" height="19.16" viewBox="0 0 14.37 19.16">
        <path
            id="padlock_3064155"
            d="M15.574,7.185h-.6V4.79a4.79,4.79,0,1,0-9.58,0V7.185H4.8A1.8,1.8,0,0,0,3,8.981v8.382a1.8,1.8,0,0,0,1.8,1.8H15.574a1.8,1.8,0,0,0,1.8-1.8V8.981A1.8,1.8,0,0,0,15.574,7.185ZM6.992,4.79a3.193,3.193,0,0,1,6.387,0V7.185H6.992Zm3.992,8.56v1.819a.8.8,0,1,1-1.6,0V13.35a1.6,1.6,0,1,1,1.6,0Z"
            transform="translate(-3)"
            fill="#7284fa"
        />
    </svg>
);

export const purpleWarning = (
    <svg xmlns="http://www.w3.org/2000/svg" width="11.669" height="11.668" viewBox="0 0 11.669 11.668">
        <g id="Group_8773" data-name="Group 8773" transform="translate(-1033.1 -2207.1)">
            <line
                id="Line_231"
                data-name="Line 231"
                y1="3.781"
                transform="translate(1038.934 2211.281)"
                fill="none"
                stroke="#618cf5"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.8"
            />
            <path
                id="Path_1450"
                data-name="Path 1450"
                d="M1044.369,2218.369H1033.5l5.434-10.869Z"
                fill="none"
                stroke="#618cf5"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.8"
            />
            <path
                id="Path_1451"
                data-name="Path 1451"
                d="M1045.2,2226.1a.6.6,0,0,1-.6.6h0a.6.6,0,0,1-.6-.6h0a.6.6,0,0,1,.6-.6h0a.6.6,0,0,1,.6.6Z"
                transform="translate(-5.665 -9.535)"
                fill="#618cf5"
            />
        </g>
    </svg>
);

export const RepetitionIcon = (
    <svg version="1.1" id="Lag_1" xmlns="http://www.w3.org/2000/svg" width="17.5" height="17.3" viewBox="0 0 25.5 19.3">
        <g id="Group_9850" transform="translate(-515.338 -957.719)">
            <g id="Group_9851" transform="translate(-10 1)">
                <circle id="Ellipse_582" fill="#DAD9EF" stroke="#DAD9EF" cx="537.7" cy="966.5" r="9.1" />
                <g id="Group_8791" transform="translate(526.032 957.271)">
                    <g id="Group_8792" transform="translate(0 0)">
                        <path
                            id="Path_13637"
                            stroke="#618CF5"
                            fill="#DAD9EF"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M20.4,7.6c0.7,4.6-2.2,8.9-6.7,10c-2.9,0.7-6-0.2-8.2-2.3"
                        />
                        <path
                            id="Path_13638"
                            stroke="#618CF5"
                            fill="#DAD9EF"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M2.9,11.7C1.7,6.8,4.6,1.9,9.5,0.6c0,0,0.1,0,0.1,0c3.1-0.7,6.4,0.3,8.6,2.7"
                        />
                        <path id="Path_13636" stroke="#618CF5" fill="#DAD9EF" strokeLinecap="round" strokeLinejoin="round" d="M23.3,11.9l-2.9-4.3l-3.3,4" />
                        <path id="Path_13635" stroke="#618CF5" fill="#DAD9EF" strokeLinecap="round" strokeLinejoin="round" d="M0,7.4l2.9,4.3l3.3-4" />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const newestFirstSortIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="14.281" height="10.75" viewBox="0 0 14.281 10.75">
        <g id="Group_8805" data-name="Group 8805" transform="translate(1.281 -4)">
            <g id="Group_8806" data-name="Group 8806">
                <line
                    id="Line_672"
                    data-name="Line 672"
                    y1="9.75"
                    transform="translate(1.833 4.5)"
                    fill="none"
                    stroke="#6890f5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <path
                    id="Path_13645"
                    data-name="Path 13645"
                    d="M6.315,8,3.908,10.408,1.5,8"
                    transform="translate(-2.074 3.842)"
                    fill="#dad9ef"
                    stroke="#6890f5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_673"
                    data-name="Line 673"
                    x2="1.083"
                    transform="translate(5.417 13.25)"
                    fill="none"
                    stroke="#6890f5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_674"
                    data-name="Line 674"
                    x2="3.083"
                    transform="translate(5.417 9.667)"
                    fill="none"
                    stroke="#6890f5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_675"
                    data-name="Line 675"
                    x2="7.083"
                    transform="translate(5.417 5.583)"
                    fill="none"
                    stroke="#6890f5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
            </g>
        </g>
    </svg>
);

export const oldestFirstSortIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="13.032" height="10.75" viewBox="0 0 13.032 10.75">
        <g id="Group_9984" data-name="Group 9984" transform="translate(17.948 14.75) rotate(180)">
            <g id="Group_8806" data-name="Group 8806">
                <line
                    id="Line_672"
                    data-name="Line 672"
                    y1="9.75"
                    transform="translate(14.833 4.5)"
                    fill="none"
                    stroke="#6890f5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <path
                    id="Path_13645"
                    data-name="Path 13645"
                    d="M6.315,8,3.908,10.408,1.5,8"
                    transform="translate(10.926 3.842)"
                    fill="#dad9ef"
                    stroke="#6890f5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_673"
                    data-name="Line 673"
                    x2="1.083"
                    transform="translate(5.417 13.25)"
                    fill="none"
                    stroke="#6890f5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_674"
                    data-name="Line 674"
                    x2="3.083"
                    transform="translate(5.417 9.667)"
                    fill="none"
                    stroke="#6890f5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_675"
                    data-name="Line 675"
                    x2="7.083"
                    transform="translate(5.417 5.583)"
                    fill="none"
                    stroke="#6890f5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
            </g>
        </g>
    </svg>
);

export const unPinnedCommentIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="13.502" height="13.414" viewBox="0 0 13.502 13.414">
        <g id="Group_9983" data-name="Group 9983" transform="translate(-0.793 0.206)">
            <g id="Group_9982" data-name="Group 9982">
                <line
                    id="Line_1044"
                    data-name="Line 1044"
                    x1="4.076"
                    y2="3.989"
                    transform="translate(1.5 8.511)"
                    fill="none"
                    stroke="#9e9e9e"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <path
                    id="Path_25508"
                    data-name="Path 25508"
                    d="M14.685,5.783l1.174-1.174L11.75.5,10.576,1.674l.587.587L8.228,5.2H5.88L5,6.076l5.283,5.283.88-.88V8.131L14.1,5.2Z"
                    transform="translate(-2.065 -0.207)"
                    fill="none"
                    stroke="#9e9e9e"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
            </g>
        </g>
    </svg>
);

export const pinnedCommentIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="13.502" height="13.414" viewBox="0 0 13.502 13.414">
        <g id="Group_9981" data-name="Group 9981" transform="translate(-0.793 0.207)">
            <g id="Group_9982" data-name="Group 9982">
                <line
                    id="Line_1044"
                    data-name="Line 1044"
                    x1="4.076"
                    y2="3.989"
                    transform="translate(1.5 8.511)"
                    fill="none"
                    stroke="#7284fa"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <path
                    id="Path_25508"
                    data-name="Path 25508"
                    d="M14.685,5.783l1.174-1.174L11.75.5,10.576,1.674l.587.587L8.228,5.2H5.88L5,6.076l5.283,5.283.88-.88V8.131L14.1,5.2Z"
                    transform="translate(-2.065 -0.207)"
                    fill="#7284fa"
                    stroke="#7284fa"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
            </g>
        </g>
    </svg>
);

export const IncidentLogIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="15.379" height="20.86" viewBox="0 0 15.379 20.86">
        <defs>
            <clipPath id="clip-path">
                <rect id="Rectangle_15167" data-name="Rectangle 15167" width="3.086" height="6.012" fill="#7284fa" />
            </clipPath>
        </defs>
        <g id="Group_10084" data-name="Group 10084" transform="translate(-55.5 -462.548)">
            <g id="Group_10077" data-name="Group 10077" transform="translate(56 466.313)">
                <g id="Group_10078" data-name="Group 10078">
                    <path
                        id="Path_25535"
                        data-name="Path 25535"
                        d="M13.535,7.237H3.374V5.19A3.829,3.829,0,0,1,7.19,1.374H7.2a3.829,3.829,0,0,1,3.8,3.816c0,.272.34.19.612.19h.389c.272,0,.373.082.373-.19A5.2,5.2,0,0,0,7.2,0H7.19A5.2,5.2,0,0,0,2,5.19V7.237H.844A.847.847,0,0,0,0,8.082V18.568A1.292,1.292,0,0,0,1.292,19.86h11.8a1.292,1.292,0,0,0,1.292-1.292V8.082a.847.847,0,0,0-.844-.844"
                        transform="translate(0 -3.265)"
                        fill="#dad9ef"
                        stroke="#7284fa"
                        strokeWidth="1"
                    />
                </g>
            </g>
            <g id="Group_10080" data-name="Group 10080" transform="translate(62.858 470.019)">
                <g id="Group_10083" data-name="Group 10083" transform="translate(-0.858 3.348)">
                    <g id="Group_10082" data-name="Group 10082">
                        <g id="Group_10081" data-name="Group 10081" clipPath="url(#clip-path)">
                            <path
                                id="Path_25537"
                                data-name="Path 25537"
                                d="M3.069,5.487,2.374,3.156a.41.41,0,0,1,.137-.436,1.519,1.519,0,0,0,.568-1.2,1.536,1.536,0,0,0-3.072.019A1.52,1.52,0,0,0,.575,2.72a.407.407,0,0,1,.137.433l-.7,2.334a.408.408,0,0,0,.391.525H2.677a.408.408,0,0,0,.391-.525"
                                transform="translate(0 0)"
                                fill="#7284fa"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const excludedIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="14.329" height="14.329" viewBox="0 0 14.329 14.329">
        <g id="Group_8899" data-name="Group 8899" transform="translate(-0.34 -0.34)">
            <g id="Group_8900" data-name="Group 8900" transform="translate(0.34 0.34)">
                <circle id="Ellipse_589" data-name="Ellipse 589" cx="7.164" cy="7.164" r="7.164" fill="#f7447a" />
                <path
                    id="Path_13708"
                    data-name="Path 13708"
                    d="M9.109,4.333a4.775,4.775,0,0,0-3.95,7.46L11.794,5.16A4.751,4.751,0,0,0,9.109,4.333Z"
                    transform="translate(-1.945 -1.945)"
                    fill="#fff"
                />
                <path
                    id="Path_13709"
                    data-name="Path 13709"
                    d="M7.691,14.326a4.775,4.775,0,0,0,6.634-6.634Z"
                    transform="translate(-3.211 -3.211)"
                    fill="#fff"
                />
            </g>
        </g>
    </svg>
);

export const inProgressTaskPaperIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="28.023" height="24.338" viewBox="0 0 28.023 24.338">
        <defs>
            <clipPath id="clip-path">
                <rect
                    id="Rectangle_15048"
                    data-name="Rectangle 15048"
                    width="28.023"
                    height="24.338"
                    transform="translate(0 0)"
                    fill="none"
                    stroke="#7284fa"
                    strokeWidth="1"
                />
            </clipPath>
        </defs>
        <g id="Group_10064" data-name="Group 10064" transform="translate(-1390.099 86.272)">
            <circle id="Ellipse_796" data-name="Ellipse 796" cx="12" cy="12" r="12" transform="translate(1394 -86)" fill="#d9daee" />
            <g id="Group_10062" data-name="Group 10062" transform="translate(3 32)">
                <g id="Group_10050" data-name="Group 10050" transform="translate(1387.099 -118.271)">
                    <g id="Group_9769" data-name="Group 9769">
                        <path
                            id="Path_25313"
                            data-name="Path 25313"
                            d="M.5,8.477l3.685,5.529,4.3-4.914"
                            fill="none"
                            stroke="#7284fa"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                        />
                        <path
                            id="Path_25314"
                            data-name="Path 25314"
                            d="M15.856,23.838A11.669,11.669,0,1,0,4.185,12.17v1.836"
                            fill="none"
                            stroke="#7284fa"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                        />
                    </g>
                </g>
                <g id="Group_10056" data-name="Group 10056" transform="translate(1386.109 -120.102)">
                    <g id="Group_10053" data-name="Group 10053" transform="translate(1 -4)">
                        <g id="Group_10058" data-name="Group 10058">
                            <path
                                id="Path_25528"
                                data-name="Path 25528"
                                d="M14,22.5l-3.5,1,1-3.5L19,12.5,21.5,15Z"
                                fill="none"
                                stroke="#7284fa"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="1"
                            />
                        </g>
                    </g>
                    <line
                        id="Line_1055"
                        data-name="Line 1055"
                        x2="2.5"
                        y2="2.5"
                        transform="translate(18.002 10.499)"
                        fill="none"
                        stroke="#7284fa"
                        strokeLinejoin="round"
                        strokeWidth="1"
                    />
                    <g id="Group_10055" data-name="Group 10055" transform="translate(1 -4)">
                        <g id="Group_10057" data-name="Group 10057">
                            <line
                                id="Line_1056"
                                data-name="Line 1056"
                                x2="2.5"
                                y2="2.5"
                                transform="translate(11.5 20.001)"
                                fill="none"
                                stroke="#7284fa"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="1"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const overdueTaskPaperIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <defs>
            <clipPath id="clip-path">
                <rect
                    id="Rectangle_15160"
                    data-name="Rectangle 15160"
                    width="20"
                    height="20"
                    transform="translate(-0.294 -0.268)"
                    fill="#d9daee"
                    stroke="#7284fa"
                    strokeWidth="1"
                />
            </clipPath>
            <clipPath id="clip-path-2">
                <rect
                    id="Rectangle_15162"
                    data-name="Rectangle 15162"
                    width="13"
                    height="13"
                    transform="translate(-0.174 -0.174)"
                    fill="#d9daee"
                    stroke="#7284fa"
                    strokeWidth="1"
                />
            </clipPath>
        </defs>
        <g id="Group_10075" data-name="Group 10075" transform="translate(-239 -194)">
            <g id="Ellipse_798" data-name="Ellipse 798" transform="translate(239 194)" fill="#d9daee" stroke="#7284fa" strokeWidth="1">
                <circle cx="12" cy="12" r="12" stroke="none" />
                <circle cx="12" cy="12" r="11.5" fill="none" />
            </g>
            <g id="Group_10067" data-name="Group 10067" transform="translate(241.294 196.268)">
                <g id="Group_10066" data-name="Group 10066" transform="translate(0 0)">
                    <g id="Group_10065" data-name="Group 10065" transform="translate(0 0)">
                        <ellipse
                            id="Ellipse_797"
                            data-name="Ellipse 797"
                            cx="9.576"
                            cy="9.576"
                            rx="9.576"
                            ry="9.576"
                            transform="translate(0.164 0.164)"
                            fill="#d9daee"
                            stroke="#7284fa"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                        />
                        <path
                            id="Path_25531"
                            data-name="Path 25531"
                            d="M16.5,6.5v4.58l-5,4.58"
                            transform="translate(-6.34 -1.34)"
                            fill="#d9daee"
                            stroke="#7284fa"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                        />
                    </g>
                </g>
            </g>
            <g id="Group_10068" data-name="Group 10068" transform="translate(250.174 205.174)">
                <g id="Group_10072" data-name="Group 10072">
                    <g id="Group_10071" data-name="Group 10071">
                        <path
                            id="Path_25533"
                            data-name="Path 25533"
                            d="M.5,12.339H12.339L6.42.5Z"
                            transform="translate(-0.007 -0.007)"
                            fill="#d9daee"
                            stroke="#7284fa"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                        />
                    </g>
                </g>
                <line
                    id="Line_1058"
                    data-name="Line 1058"
                    y2="3.453"
                    transform="translate(6.413 5.426)"
                    fill="none"
                    stroke="#7284fa"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <g id="Group_10074" data-name="Group 10074">
                    <g id="Group_10073" data-name="Group 10073">
                        <path
                            id="Path_25534"
                            data-name="Path 25534"
                            d="M6.493,10a.493.493,0,1,0,.493.493A.493.493,0,0,0,6.493,10"
                            transform="translate(-0.08 -0.134)"
                            fill="#7284fa"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const completedTaskPaperIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21.75" viewBox="0 0 22 21.75">
        <defs>
            <clipPath id="clip-path">
                <rect id="Rectangle_15158" data-name="Rectangle 15158" width="22" height="21.75" fill="none" stroke="#7284fa" strokeWidth="1" />
            </clipPath>
        </defs>
        <g id="Group_10063" data-name="Group 10063" transform="translate(-1392 45)">
            <rect id="Rectangle_15159" data-name="Rectangle 15159" width="18" height="18" rx="1" transform="translate(1392.5 -42)" fill="#d9daee" />
            <g id="Group_10061" data-name="Group 10061" transform="translate(1 -3)">
                <g id="Group_10060" data-name="Group 10060" transform="translate(1391 -42)">
                    <g id="Group_10059" data-name="Group 10059">
                        <path
                            id="Path_25529"
                            data-name="Path 25529"
                            d="M21.5.5,9,16,4,11"
                            fill="none"
                            stroke="#7284fa"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                        />
                        <path
                            id="Path_25530"
                            data-name="Path 25530"
                            d="M18.5,9.75v11.5H.5v-18H13"
                            fill="none"
                            stroke="#7284fa"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const closed = (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <g id="Group_10317" data-name="Group 10317" transform="translate(-1301 -794)">
            <g id="Ellipse_582" data-name="Ellipse 582" transform="translate(1301 794)" fill="#dedede" stroke="#c4c4c4" strokeWidth="1">
                <circle cx="10" cy="10" r="10" stroke="none" />
                <circle cx="10" cy="10" r="9.5" fill="none" />
            </g>
            <line
                id="Line_553"
                data-name="Line 553"
                x2="8"
                y2="8"
                transform="translate(1307 800)"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeWidth="2"
            />
            <line
                id="Line_554"
                data-name="Line 554"
                x2="8"
                y2="8"
                transform="translate(1315 800) rotate(90)"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeWidth="2"
            />
        </g>
    </svg>
);

export const auditInProgress = (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <g id="Group_10321" data-name="Group 10321" transform="translate(-1189 -638)">
            <g id="Group_10315" data-name="Group 10315" transform="translate(-112 -156)">
                <g id="Ellipse_582" data-name="Ellipse 582" transform="translate(1301 794)" fill="#fff79f" stroke="#e1da8c" strokeWidth="1">
                    <circle cx="10" cy="10" r="10" stroke="none" />
                    <circle cx="10" cy="10" r="9.5" fill="none" />
                </g>
            </g>
            <g id="Group_10316" data-name="Group 10316" transform="translate(0 0.5)">
                <line
                    id="Line_551"
                    data-name="Line 551"
                    y2="7"
                    transform="translate(1199 641)"
                    fill="none"
                    stroke="#fff"
                    strokeLinecap="round"
                    strokeWidth="2"
                />
                <line
                    id="Line_552"
                    data-name="Line 552"
                    x2="3.5"
                    y2="3"
                    transform="translate(1199 648)"
                    fill="none"
                    stroke="#fff"
                    strokeLinecap="round"
                    strokeWidth="2"
                />
            </g>
        </g>
    </svg>
);

export const blueGreyCheckmark = (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <g id="Group_10318" data-name="Group 10318" transform="translate(-1301 -794)">
            <g id="Ellipse_582" data-name="Ellipse 582" transform="translate(1301 794)" fill="#b0d9fc" stroke="#9cc0df" strokeWidth="1">
                <circle cx="10" cy="10" r="10" stroke="none" />
                <circle cx="10" cy="10" r="9.5" fill="none" />
            </g>
            <g id="Group_8681" data-name="Group 8681" transform="translate(1305.102 799.5)">
                <path
                    id="Path_1240"
                    data-name="Path 1240"
                    d="M10.91,68.183a.507.507,0,0,0-.783,0L3.494,75.755l-2.55-2.91a.507.507,0,0,0-.783,0,.7.7,0,0,0,0,.894L3.1,77.1a.507.507,0,0,0,.783,0l7.024-8.019A.7.7,0,0,0,10.91,68.183Z"
                    transform="translate(0 -67.998)"
                    fill="#fff"
                    stroke="#fff"
                    strokeWidth="1"
                />
            </g>
        </g>
    </svg>
);

export const greenCheckmark = (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <g id="Group_10318" data-name="Group 10318" transform="translate(-1301 -794)">
            <g id="Ellipse_582" data-name="Ellipse 582" transform="translate(1301 794)" fill="#2cd3c4" stroke="#26bbad" strokeWidth="1">
                <circle cx="10" cy="10" r="10" stroke="none" />
                <circle cx="10" cy="10" r="9.5" fill="none" />
            </g>
            <g id="Group_8681" data-name="Group 8681" transform="translate(1305.102 799.5)">
                <path
                    id="Path_1240"
                    data-name="Path 1240"
                    d="M10.91,68.183a.507.507,0,0,0-.783,0L3.494,75.755l-2.55-2.91a.507.507,0,0,0-.783,0,.7.7,0,0,0,0,.894L3.1,77.1a.507.507,0,0,0,.783,0l7.024-8.019A.7.7,0,0,0,10.91,68.183Z"
                    transform="translate(0 -67.998)"
                    fill="#fff"
                    stroke="#fff"
                    strokeWidth="1"
                />
            </g>
        </g>
    </svg>
);

export const purpleCheckmark = (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <g id="Group_10318" data-name="Group 10318" transform="translate(-1301 -794)">
            <g id="Ellipse_582" data-name="Ellipse 582" transform="translate(1301 794)" fill="#95A2F2" stroke="#7284FA" strokeWidth="1">
                <circle cx="10" cy="10" r="10" stroke="none" />
                <circle cx="10" cy="10" r="9.5" fill="none" />
            </g>
            <g id="Group_8681" data-name="Group 8681" transform="translate(1305.102 799.5)">
                <path
                    id="Path_1240"
                    data-name="Path 1240"
                    d="M10.91,68.183a.507.507,0,0,0-.783,0L3.494,75.755l-2.55-2.91a.507.507,0,0,0-.783,0,.7.7,0,0,0,0,.894L3.1,77.1a.507.507,0,0,0,.783,0l7.024-8.019A.7.7,0,0,0,10.91,68.183Z"
                    transform="translate(0 -67.998)"
                    fill="#fff"
                    stroke="#fff"
                    strokeWidth="1"
                />
            </g>
        </g>
    </svg>
);

export const internalAssessments = (
    <svg id="Group_10337" data-name="Group 10337" xmlns="http://www.w3.org/2000/svg" width="20" height="22" viewBox="0 0 20 22">
        <defs>
            <clipPath id="clip-path">
                <rect id="Rectangle_15193" data-name="Rectangle 15193" width="20" height="22" fill="#dad9ef" stroke="#7284fa" strokeWidth="1" />
            </clipPath>
        </defs>
        <g id="Group_10336" data-name="Group 10336">
            <g id="Group_10335" data-name="Group 10335">
                <path
                    id="Path_25599"
                    data-name="Path 25599"
                    d="M14.136,16.136v5.455H.5V2.5H19.591V16.136Z"
                    transform="translate(-0.045 -0.227)"
                    fill="#dad9ef"
                    stroke="#7284fa"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_555"
                    data-name="Line 555"
                    x1="5.455"
                    y2="5.455"
                    transform="translate(14.091 15.909)"
                    fill="none"
                    stroke="#7284fa"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_556"
                    data-name="Line 556"
                    y2="4.091"
                    transform="translate(3.182 0.455)"
                    fill="none"
                    stroke="#7284fa"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_557"
                    data-name="Line 557"
                    y2="4.091"
                    transform="translate(7.727 0.455)"
                    fill="none"
                    stroke="#7284fa"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_558"
                    data-name="Line 558"
                    y2="4.091"
                    transform="translate(12.273 0.455)"
                    fill="none"
                    stroke="#7284fa"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_559"
                    data-name="Line 559"
                    y2="4.091"
                    transform="translate(16.818 0.455)"
                    fill="none"
                    stroke="#7284fa"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
            </g>
        </g>
        <path
            id="Path_25600"
            data-name="Path 25600"
            d="M8.091,7.5,5.364,10.227,4,8.864"
            transform="translate(-0.364 -0.682)"
            fill="#dad9ef"
            stroke="#7284fa"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
        />
        <path
            id="Path_25601"
            data-name="Path 25601"
            d="M8.091,13,5.364,15.727,4,14.364"
            transform="translate(-0.364 -1.182)"
            fill="#dad9ef"
            stroke="#7284fa"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
        />
        <line
            id="Line_560"
            data-name="Line 560"
            x2="5.909"
            transform="translate(9.545 8.636)"
            fill="none"
            stroke="#7284fa"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
        />
        <line
            id="Line_561"
            data-name="Line 561"
            x2="5.909"
            transform="translate(9.545 13.182)"
            fill="none"
            stroke="#7284fa"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
        />
    </svg>
);

export const closedBlue = (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <g id="Group_10320" data-name="Group 10320" transform="translate(-1301 -794)">
            <g id="Ellipse_582" data-name="Ellipse 582" transform="translate(1301 794)" fill="#b0d9fc" stroke="#9cc0df" strokeWidth="1">
                <circle cx="10" cy="10" r="10" stroke="none" />
                <circle cx="10" cy="10" r="9.5" fill="none" />
            </g>
            <line
                id="Line_553"
                data-name="Line 553"
                x2="8"
                y2="8"
                transform="translate(1307 800)"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeWidth="2"
            />
            <line
                id="Line_554"
                data-name="Line 554"
                x2="8"
                y2="8"
                transform="translate(1315 800) rotate(90)"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeWidth="2"
            />
        </g>
    </svg>
);

export const veryDissatisfied = (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M13.2393 33.1274C15.0032 29.0585 19.0554 26.2122 23.7727 26.2122C28.4888 26.2122 32.5403 29.0574 34.3046 33.1248"
            stroke="#F7447A"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M46.2734 24.0042C46.2734 36.4303 36.1998 46.5042 23.7732 46.5042C11.347 46.5042 1.27344 36.4303 1.27344 24.0042C1.27344 11.5777 11.347 1.50421 23.7732 1.50421C36.1998 1.50421 46.2734 11.5777 46.2734 24.0042Z"
            fill="#F7447A"
            fillOpacity="0.101961"
            stroke="#F7447A"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.6787 18.7503C11.6787 17.6895 12.5388 16.8294 13.5997 16.8294C14.6605 16.8294 15.5202 17.6895 15.5202 18.7503C15.5202 19.8111 14.6605 20.6713 13.5997 20.6713C12.5388 20.6713 11.6787 19.8111 11.6787 18.7503Z"
            fill="#F7447A"
        />
        <path
            d="M32.0264 18.7503C32.0264 17.6895 32.8865 16.8294 33.9473 16.8294C35.0081 16.8294 35.8679 17.6895 35.8679 18.7503C35.8679 19.8111 35.0081 20.6713 33.9473 20.6713C32.8865 20.6713 32.0264 19.8111 32.0264 18.7503Z"
            fill="#F7447A"
        />
    </svg>
);

export const dissatisfied = (
    <svg width="47" height="48" viewBox="0 0 47 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M46 24.0042C46 36.4303 35.9264 46.5042 23.4998 46.5042C11.0736 46.5042 1 36.4303 1 24.0042C1 11.5777 11.0736 1.50421 23.4998 1.50421C35.9264 1.50421 46 11.5777 46 24.0042Z"
            fill="#FF9300"
            fillOpacity="0.14902"
            stroke="#F39C12"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.8848 17.6656C13.6689 17.6656 14.3046 18.3013 14.3047 19.0855C14.3047 19.8698 13.6689 20.5055 12.8848 20.5055C12.1006 20.5053 11.4648 19.8696 11.4648 19.0855C11.4649 18.3016 12.1006 17.6658 12.8848 17.6656Z"
            fill="#F39C12"
            stroke="#F39C12"
        />
        <path
            d="M33.6787 17.6656C34.4629 17.6656 35.0986 18.3013 35.0986 19.0855C35.0986 19.8698 34.4629 20.5055 33.6787 20.5055C32.8945 20.5053 32.2588 19.8696 32.2588 19.0855C32.2588 18.3016 32.8946 17.6658 33.6787 17.6656Z"
            fill="#F39C12"
            stroke="#F39C12"
        />
        <path d="M11.291 31C15.291 28.8333 25.891 25.8 36.291 31" stroke="#F39C12" strokeWidth="2" strokeLinecap="round" />
    </svg>
);

export const satisfied = (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M46.8398 24.0042C46.8398 36.4303 36.7662 46.5042 24.3397 46.5042C11.9134 46.5042 1.83984 36.4303 1.83984 24.0042C1.83984 11.5777 11.9134 1.50421 24.3397 1.50421C36.7662 1.50421 46.8398 11.5777 46.8398 24.0042Z"
            fill="#3CACA6"
            fillOpacity="0.101961"
            stroke="#3CACA6"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14.3926 17.6656C15.1767 17.6656 15.8125 18.3013 15.8125 19.0855C15.8125 19.8698 15.1767 20.5055 14.3926 20.5055C13.6084 20.5053 12.9727 19.8696 12.9727 19.0855C12.9727 18.3016 13.6084 17.6658 14.3926 17.6656Z"
            fill="#3CACA6"
            stroke="#3CACA6"
        />
        <path
            d="M35.1875 17.6656C35.9716 17.6656 36.6074 18.3013 36.6074 19.0855C36.6074 19.8698 35.9717 20.5055 35.1875 20.5055C34.4033 20.5053 33.7676 19.8696 33.7676 19.0855C33.7676 18.3016 34.4033 17.6658 35.1875 17.6656Z"
            fill="#3CACA6"
            stroke="#3CACA6"
        />
        <path
            d="M33.0225 30C31.8945 33.628 28.5104 36.2622 24.5111 36.2622C20.5119 36.2622 17.1281 33.628 16 30"
            stroke="#3CACA6"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const verySatisfied = (
    <svg width="47" height="47" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M45.9996 23.5C45.9996 35.9261 35.9261 46 23.4996 46C11.0735 46 1 35.9261 1 23.5C1 11.0735 11.0735 1 23.4996 1C35.9261 1 45.9996 11.0735 45.9996 23.5Z"
            fill="#E9FBF9"
            stroke="#2CD5C4"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M35.5974 27.2655C33.9941 32.422 29.1843 36.166 23.5003 36.166C17.8164 36.166 13.007 32.422 11.4033 27.2655H35.5974Z"
            fill="#E9FBF9"
            stroke="#2CD5C4"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M13.3594 17.2756C13.9046 17.2756 14.3466 17.7173 14.3467 18.2629C14.3467 18.8085 13.9047 19.2502 13.3594 19.2502C12.8142 19.2501 12.3721 18.8081 12.3721 18.2629C12.3722 17.7177 12.8142 17.2757 13.3594 17.2756Z"
            fill="#E9FBF9"
            stroke="#2CD5C4"
            strokeWidth="2"
        />
        <path
            d="M33.6406 17.2757C34.1856 17.2757 34.6278 17.7176 34.6279 18.263C34.6279 18.8085 34.1857 19.2503 33.6406 19.2503C33.0954 19.2502 32.6533 18.8082 32.6533 18.263C32.6534 17.7179 33.0955 17.2758 33.6406 17.2757Z"
            fill="#E9FBF9"
            stroke="#2CD5C4"
            strokeWidth="2"
        />
    </svg>
);

export const partlySatisfied = (
    <svg width="47" height="47" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M46 23.5C46 35.9261 35.9264 46 23.4998 46C11.0736 46 1 35.9261 1 23.5C1 11.0735 11.0736 1 23.4998 1C35.9264 1 46 11.0735 46 23.5Z"
            fill="#FFCD39"
            fillOpacity="0.14902"
            stroke="#FFC400"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M13.5938 16.6656C14.3779 16.6656 15.0136 17.3013 15.0137 18.0855C15.0137 18.8698 14.3779 19.5055 13.5938 19.5055C12.8096 19.5053 12.1738 18.8696 12.1738 18.0855C12.1739 17.3016 12.8096 16.6658 13.5938 16.6656Z"
            fill="#FFC400"
            stroke="#FFC400"
        />
        <path
            d="M34.3877 16.6656C35.1718 16.6656 35.8076 17.3013 35.8076 18.0855C35.8076 18.8698 35.1719 19.5055 34.3877 19.5055C33.6035 19.5053 32.9678 18.8696 32.9678 18.0855C32.9678 17.3016 33.6035 16.6658 34.3877 16.6656Z"
            fill="#FFC400"
            stroke="#FFC400"
        />
        <path d="M13 29C16.3333 31 25.2 33.8 34 29" stroke="#FFC400" strokeWidth="2" strokeLinecap="round" />
    </svg>
);

export const samplingIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <g id="Group_14188" data-name="Group 14188" transform="translate(-1494.995 -370.995)">
            <g id="Group_14184" data-name="Group 14184" transform="translate(-7)">
                <g id="Group_14179" data-name="Group 14179" transform="translate(1502 371)">
                    <g id="Group_14185" data-name="Group 14185">
                        <circle
                            id="Ellipse_583"
                            data-name="Ellipse 583"
                            cx="7.928"
                            cy="7.928"
                            r="7.928"
                            transform="translate(0.495 0.495)"
                            fill="#dad9ef"
                            stroke="#7284fa"
                            strokeLinejoin="round"
                            strokeWidth="1"
                        />
                        <line
                            id="Line_614"
                            data-name="Line 614"
                            x2="9.26"
                            y2="9.26"
                            transform="translate(14.028 14.028)"
                            fill="none"
                            stroke="#7284fa"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                        />
                    </g>
                </g>
            </g>
            <g id="Group_14187" data-name="Group 14187" transform="translate(-7)">
                <g id="Path_39126" data-name="Path 39126" transform="translate(1506 375)" fill="#dad9ef">
                    <path d="M 3.5 3.5 L 0.5 3.5 L 0.5 0.5 L 3.5 0.5 L 3.5 3.5 Z" stroke="none" />
                    <path d="M 1 1 L 1 3 L 3 3 L 3 1 L 1 1 M 0 0 L 4 0 L 4 4 L 0 4 L 0 0 Z" stroke="none" fill="#7284fa" />
                </g>
                <g id="Rectangle_16842" data-name="Rectangle 16842" transform="translate(1511 380)" fill="#dad9ef" stroke="#7284fa" strokeWidth="1">
                    <rect width="4" height="4" stroke="none" />
                    <rect x="0.5" y="0.5" width="3" height="3" fill="none" />
                </g>
                <g id="Rectangle_16843" data-name="Rectangle 16843" transform="translate(1511 375)" fill="#dad9ef" stroke="#7284fa" strokeWidth="1">
                    <rect width="4" height="4" rx="2" stroke="none" />
                    <rect x="0.5" y="0.5" width="3" height="3" rx="1.5" fill="none" />
                </g>
                <g id="Rectangle_16844" data-name="Rectangle 16844" transform="translate(1506 380)" fill="#dad9ef" stroke="#7284fa" strokeWidth="1">
                    <rect width="4" height="4" rx="2" stroke="none" />
                    <rect x="0.5" y="0.5" width="3" height="3" rx="1.5" fill="none" />
                </g>
            </g>
        </g>
    </svg>
);

export const dashboardMenuIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <g id="Group_1181" data-name="Group 1181" transform="translate(-744 -1054)">
            <rect
                id="Rectangle_97"
                data-name="Rectangle 97"
                width="8"
                height="8"
                transform="translate(744.5 1054.5)"
                fill="#dad9ef"
                stroke="#7284fa"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
            />
            <rect
                id="Rectangle_98"
                data-name="Rectangle 98"
                width="8"
                height="8"
                transform="translate(755.5 1054.5)"
                fill="#dad9ef"
                stroke="#7284fa"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
            />
            <rect
                id="Rectangle_99"
                data-name="Rectangle 99"
                width="8"
                height="8"
                transform="translate(744.5 1065.5)"
                fill="#dad9ef"
                stroke="#7284fa"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
            />
            <rect
                id="Rectangle_100"
                data-name="Rectangle 100"
                width="8"
                height="8"
                transform="translate(755.5 1065.5)"
                fill="#dad9ef"
                stroke="#7284fa"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
            />
        </g>
    </svg>
);

export const compliancePlatformLogo = (
    <svg id="Group_14285" data-name="Group 14285" xmlns="http://www.w3.org/2000/svg" width="523.147" height="125" viewBox="0 0 523.147 115">
        <defs>
            <clipPath id="clip-path-compliancePlatformLogo">
                <rect id="Rectangle_17486" data-name="Rectangle 17486" width="523.147" height="115" fill="none" />
            </clipPath>
        </defs>
        <rect id="Rectangle_17484" data-name="Rectangle 17484" width="15.908" height="83.482" transform="translate(48.141)" fill="#040405" />
        <g id="Group_14284" data-name="Group 14284">
            <g id="Group_14283" data-name="Group 14283" clipPath="url(#clip-path-compliancePlatformLogo)">
                <path
                    id="Path_39385"
                    data-name="Path 39385"
                    d="M141.438,55.278h-45.8q.339,8.351,4.512,12.3a14.517,14.517,0,0,0,10.379,3.947,15.059,15.059,0,0,0,9.194-2.707,11.987,11.987,0,0,0,4.682-7.333h16.81a26.9,26.9,0,0,1-5.3,11.733,27.7,27.7,0,0,1-10.435,8.122,35.751,35.751,0,0,1-30.4-.959A27.354,27.354,0,0,1,84.016,69.268a34.96,34.96,0,0,1-3.948-17.036,35.286,35.286,0,0,1,3.948-17.091A26.916,26.916,0,0,1,95.072,24.029a33.673,33.673,0,0,1,16.245-3.836,32.943,32.943,0,0,1,16.189,3.836,27.057,27.057,0,0,1,10.717,10.548A30.622,30.622,0,0,1,142,49.863a30.127,30.127,0,0,1-.565,5.415m-19.46-18.614a15.276,15.276,0,0,0-10.661-3.948,15.63,15.63,0,0,0-10.83,3.948q-4.4,3.951-4.851,11.621h30.347q.337-7.673-4.005-11.621"
                    fill="#040405"
                />
                <path
                    id="Path_39386"
                    data-name="Path 39386"
                    d="M196.039,23.917a20.279,20.279,0,0,1,8.01,10.04V20.984h15.794V83.708A34.7,34.7,0,0,1,216.4,99.333a25.381,25.381,0,0,1-10.266,10.886q-6.828,3.948-16.527,3.949-13.539,0-21.886-6.431A26.594,26.594,0,0,1,157.57,90.251h15.681A12.931,12.931,0,0,0,178.5,97.64a17.379,17.379,0,0,0,9.984,2.652q6.995,0,11.282-4.118t4.287-12.466V70.4a20.569,20.569,0,0,1-8.01,10.1A23.754,23.754,0,0,1,182.5,84.272a26.834,26.834,0,0,1-14.214-3.836,25.892,25.892,0,0,1-9.871-11.112,38.523,38.523,0,0,1-3.554-17.091,38.523,38.523,0,0,1,3.554-17.091,25.912,25.912,0,0,1,9.871-11.113A26.861,26.861,0,0,1,182.5,20.194a24.024,24.024,0,0,1,13.538,3.723m-20.532,15q-4.514,4.851-4.513,13.312t4.513,13.256q4.511,4.8,11.958,4.794a15.744,15.744,0,0,0,11.9-4.907q4.68-4.908,4.682-13.143,0-8.348-4.682-13.256a15.744,15.744,0,0,0-11.9-4.907q-7.446,0-11.958,4.851"
                    fill="#040405"
                />
                <path
                    id="Path_39387"
                    data-name="Path 39387"
                    d="M277.038,23.917a20.279,20.279,0,0,1,8.01,10.04V20.984h15.794v62.5H285.048V70.4a20.569,20.569,0,0,1-8.01,10.1A23.754,23.754,0,0,1,263.5,84.272a26.834,26.834,0,0,1-14.214-3.836,25.9,25.9,0,0,1-9.872-11.112,38.551,38.551,0,0,1-3.553-17.091,38.551,38.551,0,0,1,3.553-17.091,25.92,25.92,0,0,1,9.872-11.113A26.861,26.861,0,0,1,263.5,20.194a24.024,24.024,0,0,1,13.538,3.723m-20.532,15q-4.514,4.851-4.512,13.312t4.512,13.256q4.51,4.8,11.958,4.794a15.744,15.744,0,0,0,11.9-4.907q4.68-4.908,4.682-13.143,0-8.348-4.682-13.256a15.744,15.744,0,0,0-11.9-4.907q-7.446,0-11.958,4.851"
                    fill="#040405"
                />
                <rect id="Rectangle_17485" data-name="Rectangle 17485" width="15.907" height="83.482" transform="translate(320.019)" fill="#040405" />
                <path
                    id="Path_39388"
                    data-name="Path 39388"
                    d="M24.743,71.77A12.372,12.372,0,1,1,12.372,59.4,12.371,12.371,0,0,1,24.743,71.77"
                    fill="#72b1e3"
                />
            </g>
        </g>
    </svg>
);

export const annualWheelActivityIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="18.377" height="19.167" viewBox="0 0 18.377 19.167">
        <g id="Group_15228" data-name="Group 15228" transform="translate(0.105 0.105)">
            <g id="Group_15229" data-name="Group 15229">
                <circle
                    id="Ellipse_793"
                    data-name="Ellipse 793"
                    cx="1.975"
                    cy="1.975"
                    r="1.975"
                    transform="translate(7.109 0.395)"
                    fill="#dad9ef"
                    stroke="#7284f8"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <circle
                    id="Ellipse_794"
                    data-name="Ellipse 794"
                    cx="1.975"
                    cy="1.975"
                    r="1.975"
                    transform="translate(7.109 14.613)"
                    fill="#dad9ef"
                    stroke="#7284f8"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <circle
                    id="Ellipse_795"
                    data-name="Ellipse 795"
                    cx="1.975"
                    cy="1.975"
                    r="1.975"
                    transform="translate(13.823 14.613)"
                    fill="#dad9ef"
                    stroke="#7284f8"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <circle
                    id="Ellipse_796"
                    data-name="Ellipse 796"
                    cx="1.975"
                    cy="1.975"
                    r="1.975"
                    transform="translate(0.395 14.613)"
                    fill="#dad9ef"
                    stroke="#7284f8"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_971"
                    data-name="Line 971"
                    y2="10.268"
                    transform="translate(9.084 4.344)"
                    fill="none"
                    stroke="#7284f8"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <path
                    id="Path_39246"
                    data-name="Path 39246"
                    d="M3,17.239C3,14.622,4.727,12.5,7.344,12.5h4.344a4.739,4.739,0,0,1,4.739,4.739"
                    transform="translate(-0.63 -2.627)"
                    fill="none"
                    stroke="#7284f8"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
            </g>
        </g>
    </svg>
);

export const contractsIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="21.779" height="24.446" viewBox="0 0 21.779 24.446">
        <g id="Group_12069" data-name="Group 12069" transform="translate(-32.493 -534.467)">
            <g id="Group_12067" data-name="Group 12067" transform="translate(32.993 534.967)">
                <line
                    id="Line_562"
                    data-name="Line 562"
                    x1="2.378"
                    y1="1.409"
                    transform="translate(13.781 18.529)"
                    fill="none"
                    stroke="#7284fa"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_563"
                    data-name="Line 563"
                    x1="1.752"
                    y1="1.038"
                    transform="translate(12.927 19.967)"
                    fill="none"
                    stroke="#7284fa"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_564"
                    data-name="Line 564"
                    x1="0.687"
                    y1="0.407"
                    transform="translate(12.2 21.48)"
                    fill="none"
                    stroke="#7284fa"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <g id="Group_12066" data-name="Group 12066" transform="translate(0 0)">
                    <g id="Group_12068" data-name="Group 12068" transform="translate(0 0)">
                        <rect
                            id="Rectangle_15195"
                            data-name="Rectangle 15195"
                            width="6.808"
                            height="5.523"
                            rx="1"
                            transform="matrix(0.995, -0.105, 0.105, 0.995, 10.631, 15.99)"
                            fill="#dad9ef"
                        />
                        <rect
                            id="Rectangle_15194"
                            data-name="Rectangle 15194"
                            width="6.808"
                            height="5.932"
                            rx="1"
                            transform="translate(8.063 17.106)"
                            fill="#dad9ef"
                        />
                        <path
                            id="Path_39781"
                            data-name="Path 39781"
                            d="M64.927,20.544V14.494a1.1,1.1,0,0,0-.323-.781l-3.39-3.39A1.1,1.1,0,0,0,60.434,10H49.769a1.457,1.457,0,0,0-1.457,1.457V30.228a1.457,1.457,0,0,0,1.457,1.457h5.9"
                            transform="translate(-48.312 -10)"
                            fill="#dad9ef"
                            stroke="#7284fa"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                        />
                        <path
                            id="Path_39780"
                            data-name="Path 39780"
                            d="M403.876,12.811v2.48a1.457,1.457,0,0,0,1.457,1.457h2.48"
                            transform="translate(-391.297 -12.712)"
                            fill="#dad9ef"
                            stroke="#7284fa"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                        />
                        <path
                            id="Path_39782"
                            data-name="Path 39782"
                            d="M130.8,347.747l-.732-.434a.424.424,0,0,0-.581.149l-3.011,5.082a.424.424,0,0,0,.149.581l.732.434a1.034,1.034,0,0,0,1.416-.362l2.389-4.033A1.034,1.034,0,0,0,130.8,347.747Z"
                            transform="translate(-123.651 -335.323)"
                            fill="#fff"
                            stroke="#7284fa"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                        />
                        <path
                            id="Path_39783"
                            data-name="Path 39783"
                            d="M497.54,351.306l1.12,1.89a1.034,1.034,0,0,0,1.416.362l.732-.434a.424.424,0,0,0,.149-.581l-3.011-5.082a.424.424,0,0,0-.581-.149l-.732.434a1.034,1.034,0,0,0-.362,1.416l.422.713"
                            transform="translate(-480.284 -335.323)"
                            fill="#fff"
                            stroke="#7284fa"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                        />
                        <path
                            id="Path_39784"
                            data-name="Path 39784"
                            d="M266.523,396.568l-.121-.072a1.584,1.584,0,0,0-1.646-.23l-.683.264a1.454,1.454,0,0,1-1.266-.105l-.422-.249"
                            transform="translate(-254.812 -382.468)"
                            fill="#fff"
                            stroke="#7284fa"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                        />
                        <line
                            id="Line_568"
                            data-name="Line 568"
                            x2="0.708"
                            y2="0.418"
                            transform="translate(4.957 18.08)"
                            fill="none"
                            stroke="#7284fa"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                        />
                        <path
                            id="Path_39786"
                            data-name="Path 39786"
                            d="M364.744,396.764l-.1.057a1.454,1.454,0,0,1-1.266.105l-.77-.3a1.238,1.238,0,0,0-.756-.048l-1.18.3a1.238,1.238,0,0,0-.934,1.2v1.575a.4.4,0,0,0,.4.4,1.216,1.216,0,0,0,1.216-1.216v-.067l5.052,2.992a1.453,1.453,0,0,1,.319-.256l.716-.418"
                            transform="translate(-348.722 -382.864)"
                            fill="#dad9ef"
                            stroke="#7284fa"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                        />
                        <path
                            id="Path_39785"
                            data-name="Path 39785"
                            d="M356.431,549.455l1.133.671a.836.836,0,1,0,.853-1.439l.941.557a.836.836,0,1,0,.853-1.439l.627.372a.836.836,0,1,0,.853-1.439l.767.455a.836.836,0,0,0,.852-1.439"
                            transform="translate(-345.531 -526.8)"
                            fill="none"
                            stroke="#7284fa"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                        />
                        <path
                            id="Path_39787"
                            data-name="Path 39787"
                            d="M189.718,527.815a.836.836,0,0,1-1.358-.975l.474-.66a.836.836,0,0,1,1.358.975"
                            transform="translate(-183.253 -507.583)"
                            fill="none"
                            stroke="#7284fa"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                        />
                        <path
                            id="Path_39788"
                            data-name="Path 39788"
                            d="M229.111,534.143l-1,1.388a.836.836,0,1,1-1.358-.975l1-1.388a.836.836,0,1,1,1.358.975Z"
                            transform="translate(-220.292 -514.323)"
                            fill="none"
                            stroke="#7284fa"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                        />
                        <path
                            id="Path_39789"
                            data-name="Path 39789"
                            d="M266.149,560.732a.836.836,0,0,1,1.358.975l-1,1.388a.836.836,0,0,1-1.358-.975"
                            transform="translate(-257.33 -540.913)"
                            fill="none"
                            stroke="#7284fa"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                        />
                        <path
                            id="Path_39790"
                            data-name="Path 39790"
                            d="M310.166,605.729a.836.836,0,1,1,1.358.975l-.331.462a.836.836,0,1,1-1.358-.975"
                            transform="translate(-300.431 -584.317)"
                            fill="none"
                            stroke="#7284fa"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                        />
                    </g>
                </g>
                <line
                    id="Line_565"
                    data-name="Line 565"
                    x2="11.567"
                    transform="translate(2.945 6.501)"
                    fill="none"
                    stroke="#7284fa"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_566"
                    data-name="Line 566"
                    x2="5.784"
                    transform="translate(2.945 4.036)"
                    fill="none"
                    stroke="#7284fa"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_567"
                    data-name="Line 567"
                    x2="11.567"
                    transform="translate(2.945 8.685)"
                    fill="none"
                    stroke="#7284fa"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_570"
                    data-name="Line 570"
                    x1="1.752"
                    y1="1.038"
                    transform="translate(12.886 19.938)"
                    fill="none"
                    stroke="#7284fa"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_571"
                    data-name="Line 571"
                    x1="2.378"
                    y1="1.409"
                    transform="translate(13.781 18.529)"
                    fill="none"
                    stroke="#7284fa"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
            </g>
        </g>
    </svg>
);

export const linkIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="19.363" height="17.954" viewBox="0 0 19.363 17.954">
        <g id="Group_15397" data-name="Group 15397" transform="translate(-1440.004 -486.75)">
            <g id="Group_15393" data-name="Group 15393" transform="translate(1414.254 505)">
                <g id="Group_15394" data-name="Group 15394" transform="translate(26.5 -17.5)">
                    <path
                        id="Path_39808"
                        data-name="Path 39808"
                        d="M4.753,13.259H2.223A1.721,1.721,0,0,1,.5,11.558V2.2A1.721,1.721,0,0,1,2.223.5h14.46a1.681,1.681,0,0,1,1.679,1.7v9.357a1.682,1.682,0,0,1-1.679,1.7H14.535"
                        transform="translate(-0.5 -0.5)"
                        fill="#dad9ef"
                        stroke="#7284fa"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                    />
                    <g id="Group_15395" data-name="Group 15395">
                        <line
                            id="Line_574"
                            data-name="Line 574"
                            x2="17.863"
                            transform="translate(0 3.402)"
                            fill="none"
                            stroke="#7284fa"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1.5"
                        />
                        <path
                            id="Path_39805"
                            data-name="Path 39805"
                            d="M3.451,2a.425.425,0,1,0,.425.425A.425.425,0,0,0,3.451,2"
                            transform="translate(-0.877 -0.724)"
                            fill="#7284fa"
                        />
                        <path
                            id="Path_39806"
                            data-name="Path 39806"
                            d="M5.451,2a.425.425,0,1,0,.425.425A.425.425,0,0,0,5.451,2"
                            transform="translate(-1.176 -0.724)"
                            fill="#7284fa"
                        />
                        <path
                            id="Path_39807"
                            data-name="Path 39807"
                            d="M7.451,2a.425.425,0,1,0,.425.425A.425.425,0,0,0,7.451,2"
                            transform="translate(-1.475 -0.724)"
                            fill="#7284fa"
                        />
                    </g>
                </g>
            </g>
            <g id="Group_15396" data-name="Group 15396" transform="translate(0 24)">
                <line
                    id="Line_576"
                    data-name="Line 576"
                    y1="9.219"
                    transform="translate(1449.73 479.954) rotate(180)"
                    fill="none"
                    stroke="#7284fa"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                />
                <path
                    id="Path_39810"
                    data-name="Path 39810"
                    d="M7.544,0,3.772,3.772,0,0"
                    transform="translate(1453.502 473.507) rotate(180)"
                    fill="#dad9ef"
                    stroke="#7284fa"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                />
            </g>
        </g>
    </svg>
);

export const frameworkIcon = (
    <svg id="g215" xmlns="http://www.w3.org/2000/svg" width="23.738" height="23.738" viewBox="0 0 23.738 23.738">
        <defs>
            <clipPath id="clip-path">
                <path id="path219" d="M0-682.665H23.738v23.738H0Z" transform="translate(0 682.665)" />
            </clipPath>
        </defs>
        <g id="g217" clipPath="url(#clip-path)">
            <g id="g223" transform="translate(5.334 1.901)">
                <path
                    id="path225"
                    d="M-328.292-231.342h-10.632a1.2,1.2,0,0,1-1.195-1.195v-5.945a1.2,1.2,0,0,1,1.195-1.195h10.632a1.2,1.2,0,0,1,1.195,1.195v5.945A1.2,1.2,0,0,1-328.292-231.342Z"
                    transform="translate(340.119 239.677)"
                    fill="#dad9ef"
                    stroke="#7284fa"
                    strokeMiterlimit="10"
                    strokeWidth="1"
                />
            </g>
            <g id="g227" transform="translate(7.647 4.913)">
                <path id="path229" d="M0,0H5.406" fill="none" stroke="#7284fa" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="1" />
            </g>
            <g id="g231" transform="translate(15.381 4.913)">
                <path
                    id="path233"
                    d="M-20.7,0h-.746"
                    transform="translate(21.447)"
                    fill="none"
                    stroke="#7284fa"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    strokeWidth="1"
                />
            </g>
            <g id="g235" transform="translate(7.647 7.223)">
                <path id="path237" d="M0,0H7.734" fill="none" stroke="#7284fa" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="1" />
            </g>
            <g id="g239" transform="translate(11.844 10.237)">
                <path id="path241" d="M0-177.787v-6.4" transform="translate(0 184.192)" fill="none" stroke="#7284fa" strokeMiterlimit="10" strokeWidth="1" />
            </g>
            <g id="g243" transform="translate(3.293 13.393)">
                <path
                    id="path245"
                    d="M-475.459-90.179v-2.343a.908.908,0,0,0-.91-.906h-15.31a.908.908,0,0,0-.91.906v2.343"
                    transform="translate(492.588 93.428)"
                    fill="none"
                    stroke="#7284fa"
                    strokeMiterlimit="10"
                    strokeWidth="1"
                />
            </g>
            <g id="g247" transform="translate(0.683 16.642)">
                <path
                    id="path249"
                    d="M-116.737-144.221h-3.192a1.013,1.013,0,0,1-1.013-1.013v-3.17a1.013,1.013,0,0,1,1.013-1.013h3.192a1.013,1.013,0,0,1,1.013,1.013v3.17A1.013,1.013,0,0,1-116.737-144.221Z"
                    transform="translate(120.942 149.417)"
                    fill="#dad9ef"
                    stroke="#7284fa"
                    strokeMiterlimit="10"
                    strokeWidth="1"
                />
            </g>
            <g id="g251" transform="translate(9.248 16.642)">
                <path
                    id="path253"
                    d="M-116.738-144.221h-3.192a1.013,1.013,0,0,1-1.013-1.013v-3.17a1.013,1.013,0,0,1,1.013-1.013h3.192a1.013,1.013,0,0,1,1.013,1.013v3.17A1.013,1.013,0,0,1-116.738-144.221Z"
                    transform="translate(120.944 149.417)"
                    fill="#dad9ef"
                    stroke="#7284fa"
                    strokeMiterlimit="10"
                    strokeWidth="1"
                />
            </g>
            <g id="g255" transform="translate(17.812 16.642)">
                <path
                    id="path257"
                    d="M-116.737-144.221h-3.192a1.013,1.013,0,0,1-1.013-1.013v-3.17a1.013,1.013,0,0,1,1.013-1.013h3.192a1.013,1.013,0,0,1,1.013,1.013v3.17A1.013,1.013,0,0,1-116.737-144.221Z"
                    transform="translate(120.942 149.417)"
                    fill="#dad9ef"
                    stroke="#7284fa"
                    strokeMiterlimit="10"
                    strokeWidth="1"
                />
            </g>
        </g>
    </svg>
);

export const obligationIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="22.014" height="27.851" viewBox="0 0 22.014 27.851">
        <g id="Group_8134" data-name="Group 8134" transform="translate(-267.199 -1599.067)">
            <path
                id="Path_8965"
                data-name="Path 8965"
                d="M166.179,2.5h2.335V27.016H147.5V2.5h2.335"
                transform="translate(120.199 1599.402)"
                fill="#dad9ef"
                stroke="#7789f9"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
            />
            <path
                id="Path_8967"
                data-name="Path 8967"
                d="M151.835,4.5H149.5V24.347h11.674v-4.67h4.67V4.5h-2.335"
                transform="translate(120.534 1599.737)"
                fill="#dad9ef"
                stroke="#7789f9"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
            />
            <line
                id="Line_832"
                data-name="Line 832"
                x1="4.67"
                y2="4.67"
                transform="translate(281.708 1619.414)"
                fill="none"
                stroke="#7789f9"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
            />
            <path
                id="Path_8966"
                data-name="Path 8966"
                d="M159.672,2.835a2.335,2.335,0,1,0-4.67,0h-3.5v3.5h11.674v-3.5Z"
                transform="translate(120.868 1599.067)"
                fill="#dad9ef"
                stroke="#7789f9"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
            />
            <g id="Group_8056" data-name="Group 8056" transform="translate(274.807 1609.984)">
                <path
                    id="Path_8869"
                    data-name="Path 8869"
                    d="M483.5,478.5h6.9v2.638a6.459,6.459,0,0,1-3.45,5.715,6.457,6.457,0,0,1-3.45-5.715Z"
                    transform="translate(-483.5 -478.5)"
                    fill="#dad9ef"
                    stroke="#7789f9"
                    strokeLinejoin="round"
                    strokeWidth="0.8"
                />
            </g>
            <path
                id="Path_8968"
                data-name="Path 8968"
                d="M492.133,485l-2.724,2.542-.908-.908"
                transform="translate(-211.877 1127.344)"
                fill="none"
                stroke="#7789f9"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.8"
            />
        </g>
    </svg>
);

export const trashcan = (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="24" viewBox="0 0 23 24">
        <g id="Group_8541" data-name="Group 8541" transform="translate(0.5 0.5)">
            <g id="Group_8540" data-name="Group 8540">
                <g id="Group_8547" data-name="Group 8547">
                    <rect
                        id="Rectangle_14363"
                        data-name="Rectangle 14363"
                        width="16"
                        height="20"
                        transform="translate(3 3)"
                        fill="#dad9ef"
                        stroke="#7284fa"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                    />
                    <rect
                        id="Rectangle_14364"
                        data-name="Rectangle 14364"
                        width="8"
                        height="3"
                        transform="translate(7)"
                        fill="#dad9ef"
                        stroke="#7284fa"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                    />
                    <line
                        id="Line_501"
                        data-name="Line 501"
                        x2="22"
                        transform="translate(0 3)"
                        fill="none"
                        stroke="#7284fa"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                    />
                </g>
            </g>
            <line
                id="Line_502"
                data-name="Line 502"
                y2="12"
                transform="translate(7 6.5)"
                fill="none"
                stroke="#7284fa"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
            />
            <line
                id="Line_503"
                data-name="Line 503"
                y2="12"
                transform="translate(11 6.5)"
                fill="none"
                stroke="#7284fa"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
            />
            <line
                id="Line_504"
                data-name="Line 504"
                y2="12"
                transform="translate(15 6.5)"
                fill="none"
                stroke="#7284fa"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
            />
        </g>
    </svg>
);

export const DisplayIcon = (
    <svg width="20" height="20" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12.6446 8.9509C12.6446 10.0517 13.5509 10.944 14.6688 10.944C15.7866 10.944 16.6929 10.0517 16.6929 8.9509C16.6929 7.85012 15.7866 6.95776 14.6688 6.95776C13.5509 6.95776 12.6446 7.85012 12.6446 8.9509Z"
            fill="#DAD9EF"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#7284FA"
        />
        <path d="M14.6688 10.944L14.6688 17.4416" strokeLinecap="round" strokeLinejoin="round" stroke="#7284FA" />
        <path d="M14.6688 0.5L14.6688 6.95777" strokeLinecap="round" strokeLinejoin="round" stroke="#7284FA" />
        <path
            d="M6.57225 4.96466C6.57225 6.06544 7.47848 6.9578 8.59637 6.9578C9.71426 6.9578 10.6205 6.06544 10.6205 4.96466C10.6205 3.86388 9.71426 2.97153 8.59637 2.97153C7.47848 2.97153 6.57225 3.86388 6.57225 4.96466Z"
            fill="#DAD9EF"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#7284FA"
        />
        <path d="M8.59644 6.95776L8.59644 17.4416" strokeLinecap="round" strokeLinejoin="round" stroke="#7284FA" />
        <path d="M8.59644 0.5L8.59644 2.9715" strokeLinecap="round" strokeLinejoin="round" stroke="#7284FA" />
        <path
            d="M0.499984 6.95777C0.499984 8.05854 1.40621 8.9509 2.5241 8.9509C3.64199 8.9509 4.54822 8.05855 4.54822 6.95777C4.54822 5.85699 3.64199 4.96463 2.5241 4.96463C1.40621 4.96463 0.499984 5.85699 0.499984 6.95777Z"
            fill="#DAD9EF"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#7284FA"
        />
        <path d="M2.52405 8.9509L2.52405 17.4416" strokeLinecap="round" strokeLinejoin="round" stroke="#7284FA" />
        <path d="M2.52405 0.5L2.52405 4.96464" strokeLinecap="round" strokeLinejoin="round" stroke="#7284FA" />
    </svg>
);

export const exportIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" id="microsoft-excel" width="18.78" height="18" viewBox="0 0 18.78 18">
        <g id="Group_983" data-name="Group 983">
            <path
                id="Path_1263"
                data-name="Path 1263"
                d="M10.807,10.713a.391.391,0,0,0-.332-.078L.3,12.983a.391.391,0,0,0-.3.385v13.3a.391.391,0,0,0,.332.387L10.5,28.621a.391.391,0,0,0,.451-.387V11.02A.391.391,0,0,0,10.807,10.713Z"
                transform="translate(0 -10.626)"
                fill="#7284fa"
            />
            <path
                id="Path_1264"
                data-name="Path 1264"
                d="M285.549,68.244h-7.825a.391.391,0,0,1,0-.783h7.434v-13.3h-7.434a.391.391,0,0,1,0-.782h7.825a.391.391,0,0,1,.391.391V67.853A.391.391,0,0,1,285.549,68.244Z"
                transform="translate(-267.161 -51.809)"
                fill="#7284fa"
            />
        </g>
        <g id="Group_984" data-name="Group 984" transform="translate(3.123 5.469)">
            <path
                id="Path_1265"
                data-name="Path 1265"
                d="M89.459,166.812a.391.391,0,0,1-.332-.184l-3.912-6.26a.391.391,0,0,1,.65-.436l.013.022,3.912,6.26a.391.391,0,0,1-.332.6Z"
                transform="translate(-85.149 -159.758)"
                fill="#fff"
            />
            <path
                id="Path_1266"
                data-name="Path 1266"
                d="M85.745,166.791a.391.391,0,0,1-.331-.6l3.912-6.26a.391.391,0,0,1,.677.392l-.013.022-3.912,6.26A.391.391,0,0,1,85.745,166.791Z"
                transform="translate(-85.347 -159.737)"
                fill="#fff"
            />
        </g>
        <g id="Group_985" data-name="Group 985" transform="translate(10.172 1.568)">
            <path
                id="Path_1267"
                data-name="Path 1267"
                d="M363.058,68.243a.391.391,0,0,1-.391-.391V53.767a.391.391,0,1,1,.783,0V67.852A.391.391,0,0,1,363.058,68.243Z"
                transform="translate(-359.537 -53.376)"
                fill="#7284fa"
            />
            <path
                id="Path_1268"
                data-name="Path 1268"
                d="M285.549,374.158h-7.825a.391.391,0,0,1,0-.782h7.825a.391.391,0,1,1,0,.782Z"
                transform="translate(-277.333 -361.639)"
                fill="#7284fa"
            />
            <path
                id="Path_1269"
                data-name="Path 1269"
                d="M285.549,310.158h-7.825a.391.391,0,0,1,0-.782h7.825a.391.391,0,1,1,0,.782Z"
                transform="translate(-277.333 -299.986)"
                fill="#7284fa"
            />
            <path
                id="Path_1270"
                data-name="Path 1270"
                d="M285.549,246.158h-7.825a.391.391,0,0,1,0-.782h7.825a.391.391,0,1,1,0,.782Z"
                transform="translate(-277.333 -238.334)"
                fill="#7284fa"
            />
            <path
                id="Path_1271"
                data-name="Path 1271"
                d="M285.549,182.159h-7.825a.391.391,0,0,1,0-.783h7.825a.391.391,0,0,1,0,.783Z"
                transform="translate(-277.333 -176.681)"
                fill="#7284fa"
            />
            <path
                id="Path_1272"
                data-name="Path 1272"
                d="M285.549,118.159h-7.825a.391.391,0,0,1,0-.783h7.825a.391.391,0,0,1,0,.783Z"
                transform="translate(-277.333 -115.029)"
                fill="#7284fa"
            />
        </g>
    </svg>
);

export const whiteExportIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" id="microsoft-excel" width="18.78" height="18" viewBox="0 0 18.78 18">
        <g id="Group_983" data-name="Group 983">
            <path
                id="Path_1263"
                data-name="Path 1263"
                d="M10.807,10.713a.391.391,0,0,0-.332-.078L.3,12.983a.391.391,0,0,0-.3.385v13.3a.391.391,0,0,0,.332.387L10.5,28.621a.391.391,0,0,0,.451-.387V11.02A.391.391,0,0,0,10.807,10.713Z"
                transform="translate(0 -10.626)"
                fill="#fff"
            />
            <path
                id="Path_1264"
                data-name="Path 1264"
                d="M285.549,68.244h-7.825a.391.391,0,0,1,0-.783h7.434v-13.3h-7.434a.391.391,0,0,1,0-.782h7.825a.391.391,0,0,1,.391.391V67.853A.391.391,0,0,1,285.549,68.244Z"
                transform="translate(-267.161 -51.809)"
                fill="#fff"
            />
        </g>
        <g id="Group_984" data-name="Group 984" transform="translate(3.123 5.469)">
            <path
                id="Path_1265"
                data-name="Path 1265"
                d="M89.459,166.812a.391.391,0,0,1-.332-.184l-3.912-6.26a.391.391,0,0,1,.65-.436l.013.022,3.912,6.26a.391.391,0,0,1-.332.6Z"
                transform="translate(-85.149 -159.758)"
                fill="#7284fa"
            />
            <path
                id="Path_1266"
                data-name="Path 1266"
                d="M85.745,166.791a.391.391,0,0,1-.331-.6l3.912-6.26a.391.391,0,0,1,.677.392l-.013.022-3.912,6.26A.391.391,0,0,1,85.745,166.791Z"
                transform="translate(-85.347 -159.737)"
                fill="#7284fa"
            />
        </g>
        <g id="Group_985" data-name="Group 985" transform="translate(10.172 1.568)">
            <path
                id="Path_1267"
                data-name="Path 1267"
                d="M363.058,68.243a.391.391,0,0,1-.391-.391V53.767a.391.391,0,1,1,.783,0V67.852A.391.391,0,0,1,363.058,68.243Z"
                transform="translate(-359.537 -53.376)"
                fill="#fff"
            />
            <path
                id="Path_1268"
                data-name="Path 1268"
                d="M285.549,374.158h-7.825a.391.391,0,0,1,0-.782h7.825a.391.391,0,1,1,0,.782Z"
                transform="translate(-277.333 -361.639)"
                fill="#fff"
            />
            <path
                id="Path_1269"
                data-name="Path 1269"
                d="M285.549,310.158h-7.825a.391.391,0,0,1,0-.782h7.825a.391.391,0,1,1,0,.782Z"
                transform="translate(-277.333 -299.986)"
                fill="#fff"
            />
            <path
                id="Path_1270"
                data-name="Path 1270"
                d="M285.549,246.158h-7.825a.391.391,0,0,1,0-.782h7.825a.391.391,0,1,1,0,.782Z"
                transform="translate(-277.333 -238.334)"
                fill="#fff"
            />
            <path
                id="Path_1271"
                data-name="Path 1271"
                d="M285.549,182.159h-7.825a.391.391,0,0,1,0-.783h7.825a.391.391,0,0,1,0,.783Z"
                transform="translate(-277.333 -176.681)"
                fill="#fff"
            />
            <path
                id="Path_1272"
                data-name="Path 1272"
                d="M285.549,118.159h-7.825a.391.391,0,0,1,0-.783h7.825a.391.391,0,0,1,0,.783Z"
                transform="translate(-277.333 -115.029)"
                fill="#fff"
            />
        </g>
    </svg>
);

export const classificationIcon = (
    <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.5 4.5V17.5" stroke="#7284FA" strokeLinecap="square" strokeLinejoin="round" />
        <path d="M19.5 0.5H4.5V4.5H19.5V0.5Z" fill="#DAD9EF" stroke="#7284FA" strokeLinejoin="round" />
        <path d="M14.5 17.5H9.5V22.5H14.5V17.5Z" fill="#DAD9EF" stroke="#7284FA" strokeLinejoin="round" />
        <path d="M5.5 17.5H0.5V22.5H5.5V17.5Z" fill="#DAD9EF" stroke="#7284FA" strokeLinejoin="round" />
        <path d="M23.5 17.5H18.5V22.5H23.5V17.5Z" fill="#DAD9EF" stroke="#7284FA" strokeLinejoin="round" />
        <path d="M20.5 17.5V11.5H3.5V17.5" stroke="#7284FA" strokeLinecap="square" strokeLinejoin="round" />
    </svg>
);

export const bestPracticeCheckCircleIcon = (color: string) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
        <polyline points="22 4 12 14.01 9 11.01" />
    </svg>
);

export const bestPracticeAlertCircleIcon = (color: string) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="12" />
        <line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
);

export const bestPracticeXCircleIcon = (color: string) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <circle cx="12" cy="12" r="10" />
        <line x1="15" y1="9" x2="9" y2="15" />
        <line x1="9" y1="9" x2="15" y2="15" />
    </svg>
);

export const copyIcon = (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap={"round"} strokeLinejoin="round">
        <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
    </svg>
);

export const excelIcon = (
    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.4453 17.4791L0.5 15.9469V2.82968L10.4453 0.53476V17.4791Z" fill="#DAD9EF" stroke="#7284FA" />
        <path
            d="M18.3782 16.4332H10.5573C10.4535 16.4332 10.354 16.3919 10.2806 16.3186C10.2073 16.2452 10.166 16.1457 10.166 16.0419C10.166 15.9381 10.2073 15.8386 10.2806 15.7652C10.354 15.6918 10.4535 15.6506 10.5573 15.6506H17.9873V2.35766H10.5573C10.4537 2.35766 10.3543 2.31649 10.281 2.2432C10.2077 2.16991 10.1665 2.07052 10.1665 1.96687C10.1665 1.86323 10.2077 1.76383 10.281 1.69054C10.3543 1.61725 10.4537 1.57608 10.5573 1.57608H18.3782C18.4295 1.57608 18.4803 1.58619 18.5277 1.60583C18.5751 1.62547 18.6182 1.65425 18.6545 1.69054C18.6908 1.72683 18.7196 1.76991 18.7392 1.81732C18.7588 1.86473 18.7689 1.91555 18.7689 1.96687V16.0424C18.7689 16.0937 18.7588 16.1445 18.7392 16.1919C18.7196 16.2393 18.6908 16.2824 18.6545 16.3187C18.6182 16.355 18.5751 16.3838 18.5277 16.4034C18.4803 16.4231 18.4295 16.4332 18.3782 16.4332Z"
            fill="#7284FA"
        />
        <path
            d="M7.42914 12.5232C7.36277 12.5233 7.29747 12.5064 7.23941 12.4742C7.18136 12.4421 7.13246 12.3956 7.09732 12.3393L3.1874 6.08265C3.15878 6.03999 3.13885 5.99212 3.12874 5.94176C3.11863 5.89141 3.11855 5.83955 3.12848 5.78915C3.13841 5.73876 3.15817 5.69081 3.18663 5.64805C3.21509 5.60529 3.25169 5.56855 3.29434 5.53994C3.337 5.51133 3.38488 5.4914 3.43524 5.48129C3.4856 5.47118 3.53745 5.47108 3.58785 5.48101C3.63824 5.49094 3.68619 5.5107 3.72895 5.53916C3.77171 5.56762 3.80844 5.60424 3.83705 5.64689L3.85005 5.66887L7.75997 11.9255C7.79742 11.9848 7.81826 12.053 7.82031 12.123C7.82236 12.193 7.80555 12.2623 7.77162 12.3236C7.7377 12.3849 7.68792 12.436 7.62749 12.4715C7.56706 12.5069 7.49821 12.5255 7.42814 12.5252L7.42914 12.5232Z"
            fill="#7284FA"
        />
        <path
            d="M3.51927 12.5232C3.44929 12.5233 3.38056 12.5046 3.32027 12.4691C3.25998 12.4335 3.21034 12.3825 3.17654 12.3212C3.14274 12.2599 3.12601 12.1907 3.1281 12.1207C3.1302 12.0508 3.15104 11.9827 3.18844 11.9235L7.09836 5.66688C7.15031 5.57715 7.23578 5.51174 7.33597 5.48503C7.43615 5.45832 7.54284 5.4725 7.63257 5.52445C7.7223 5.57641 7.78772 5.66187 7.81443 5.76206C7.84114 5.86224 7.82695 5.96894 7.775 6.05867L7.762 6.08066L3.85209 12.3373C3.8171 12.3941 3.76815 12.4411 3.70989 12.4736C3.65163 12.5062 3.586 12.5232 3.51927 12.5232Z"
            fill="#7284FA"
        />
        <path
            d="M13.6857 16.4332C13.5821 16.4332 13.4827 16.392 13.4094 16.3187C13.3361 16.2454 13.2949 16.146 13.2949 16.0424V1.96487C13.2949 1.86109 13.3362 1.76157 13.4095 1.68819C13.4829 1.61481 13.5824 1.57358 13.6862 1.57358C13.79 1.57358 13.8895 1.61481 13.9629 1.68819C14.0363 1.76157 14.0775 1.86109 14.0775 1.96487V16.0424C14.0775 16.0938 14.0674 16.1447 14.0477 16.1922C14.028 16.2396 13.9991 16.2828 13.9627 16.3191C13.9263 16.3554 13.8831 16.3841 13.8356 16.4037C13.7881 16.4233 13.7371 16.4333 13.6857 16.4332Z"
            fill="#7284FA"
        />
        <path
            d="M18.3781 14.0864H10.5573C10.4536 14.0864 10.3542 14.0453 10.2809 13.972C10.2077 13.8987 10.1665 13.7993 10.1665 13.6956C10.1665 13.592 10.2077 13.4926 10.2809 13.4193C10.3542 13.346 10.4536 13.3048 10.5573 13.3048H18.3781C18.4818 13.3048 18.5812 13.346 18.6544 13.4193C18.7277 13.4926 18.7689 13.592 18.7689 13.6956C18.7689 13.7993 18.7277 13.8987 18.6544 13.972C18.5812 14.0453 18.4818 14.0864 18.3781 14.0864Z"
            fill="#7284FA"
        />
        <path
            d="M18.3781 11.7406H10.5573C10.4536 11.7406 10.3542 11.6995 10.2809 11.6262C10.2077 11.5529 10.1665 11.4535 10.1665 11.3499C10.1665 11.2462 10.2077 11.1468 10.2809 11.0735C10.3542 11.0002 10.4536 10.9591 10.5573 10.9591H18.3781C18.4295 10.9591 18.4803 10.9692 18.5277 10.9888C18.5751 11.0085 18.6182 11.0372 18.6544 11.0735C18.6907 11.1098 18.7195 11.1529 18.7392 11.2003C18.7588 11.2477 18.7689 11.2985 18.7689 11.3499C18.7689 11.4012 18.7588 11.452 18.7392 11.4994C18.7195 11.5468 18.6907 11.5899 18.6544 11.6262C18.6182 11.6625 18.5751 11.6913 18.5277 11.7109C18.4803 11.7305 18.4295 11.7406 18.3781 11.7406Z"
            fill="#7284FA"
        />
        <path
            d="M18.3781 9.39392H10.5573C10.4536 9.39392 10.3542 9.35273 10.2809 9.27944C10.2077 9.20616 10.1665 9.10676 10.1665 9.00312C10.1665 8.89947 10.2077 8.80008 10.2809 8.72679C10.3542 8.6535 10.4536 8.61234 10.5573 8.61234H18.3781C18.4818 8.61234 18.5812 8.6535 18.6544 8.72679C18.7277 8.80008 18.7689 8.89947 18.7689 9.00312C18.7689 9.10676 18.7277 9.20616 18.6544 9.27944C18.5812 9.35273 18.4818 9.39392 18.3781 9.39392Z"
            fill="#7284FA"
        />
        <path
            d="M18.3782 7.04914H10.5573C10.4535 7.04914 10.354 7.00792 10.2806 6.93453C10.2073 6.86115 10.166 6.76163 10.166 6.65786C10.166 6.55408 10.2073 6.45455 10.2806 6.38116C10.354 6.30778 10.4535 6.26657 10.5573 6.26657H18.3782C18.4819 6.26657 18.5815 6.30778 18.6548 6.38116C18.7282 6.45455 18.7694 6.55408 18.7694 6.65786C18.7694 6.76163 18.7282 6.86115 18.6548 6.93453C18.5815 7.00792 18.4819 7.04914 18.3782 7.04914Z"
            fill="#7284FA"
        />
        <path
            d="M18.3782 4.70241H10.5573C10.4535 4.70241 10.354 4.66119 10.2806 4.58781C10.2073 4.51443 10.166 4.4149 10.166 4.31112C10.166 4.20735 10.2073 4.10782 10.2806 4.03444C10.354 3.96106 10.4535 3.91983 10.5573 3.91983H18.3782C18.4819 3.91983 18.5815 3.96106 18.6548 4.03444C18.7282 4.10782 18.7694 4.20735 18.7694 4.31112C18.7694 4.4149 18.7282 4.51443 18.6548 4.58781C18.5815 4.66119 18.4819 4.70241 18.3782 4.70241Z"
            fill="#7284FA"
        />
    </svg>
);

export const aiMagicDustIcon = (
    <svg width="22" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M6.06055 2.41895V2.41992C6.47528 4.16404 7.83596 5.52472 9.58008 5.93945H9.58105L9.83594 6L9.58105 6.06055H9.58008C7.83596 6.47528 6.47528 7.83596 6.06055 9.58008V9.58105L6 9.83594L5.93945 9.58105V9.58008C5.52472 7.83596 4.16404 6.47528 2.41992 6.06055H2.41895L2.16406 6L2.41895 5.93945H2.41992C4.16404 5.52472 5.52472 4.16404 5.93945 2.41992V2.41895L6 2.16406L6.06055 2.41895Z"
            fill="#DAD9EF"
            stroke="#7284FA"
        />
        <path
            d="M5.51465 13.2275C5.87439 14.7409 7.00383 15.9428 8.47363 16.4033L8.77246 16.4854L8.83594 16.5L8.77246 16.5146C7.25911 16.8744 6.0572 18.0038 5.59668 19.4736L5.51465 19.7725L5.5 19.8359L5.48535 19.7725C5.12561 18.2591 3.99617 17.0572 2.52637 16.5967L2.22754 16.5146L2.16406 16.5L2.22754 16.4854C3.74089 16.1256 4.9428 14.9962 5.40332 13.5264L5.48535 13.2275L5.5 13.1641L5.51465 13.2275Z"
            fill="#DAD9EF"
            stroke="#7284FA"
        />
        <path
            d="M13 9.14551C13.3731 10.5395 14.4596 11.6266 15.8535 12C14.4599 12.3733 13.3733 13.4599 13 14.8535C12.6266 13.4596 11.5395 12.3731 10.1455 12C11.5398 11.6269 12.6269 10.5398 13 9.14551Z"
            fill="#DAD9EF"
            stroke="#7284FA"
        />
    </svg>
);

export const addSubsectionIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="20.37" height="17.599" viewBox="0 0 20.37 17.599">
        <g transform="translate(-1747.307 -889.418)">
            <g transform="translate(1747.807 889.918)">
                <rect width="19.37" height="7" fill="#dad9ef" stroke="#7284fa" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" />
            </g>
            <g transform="translate(1747.807 899.517)">
                <rect width="19.37" height="7" fill="#dad9ef" stroke="#7284fa" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" />
            </g>
        </g>
    </svg>
);

export const addControlIcon = (
    <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.5 4.5V17.5" stroke="#7284FA" strokeLinecap="square" strokeLinejoin="round" />
        <path d="M19.5 0.5H4.5V4.5H19.5V0.5Z" fill="#DAD9EF" stroke="#7284FA" strokeLinejoin="round" />
        <path d="M14.5 17.5H9.5V22.5H14.5V17.5Z" fill="#DAD9EF" stroke="#7284FA" strokeLinejoin="round" />
        <path d="M5.5 17.5H0.5V22.5H5.5V17.5Z" fill="#DAD9EF" stroke="#7284FA" strokeLinejoin="round" />
        <path d="M23.5 17.5H18.5V22.5H23.5V17.5Z" fill="#DAD9EF" stroke="#7284FA" strokeLinejoin="round" />
        <path d="M20.5 17.5V11.5H3.5V17.5" stroke="#7284FA" strokeLinecap="square" strokeLinejoin="round" />
    </svg>
);

export const showDiffIcon = (
    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.5 7L12.5 10L9.5 13" fill="#DAD9EF" />
        <path d="M9.5 7L12.5 10L9.5 13" stroke="#7284FA" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.5 10L0.5 10" stroke="#7284FA" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M3.5 0.5L0.5 3.5L3.5 6.5" fill="#DAD9EF" />
        <path d="M3.5 0.5L0.5 3.5L3.5 6.5" stroke="#7284FA" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M0.5 3.5H12.5" stroke="#7284FA" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const reorderSectionsIcon = (
    <svg width="11" height="24" viewBox="0 0 11 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 12.5H0.5" stroke="#7284FA" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5 23.5V15.5" stroke="#7284FA" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M2 20.5L5 23.5L8 20.5" fill="#DAD9EF" />
        <path d="M2 20.5L5 23.5L8 20.5" stroke="#7284FA" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5 0.5V8.5" stroke="#7284FA" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M2 3.5L5 0.5L8 3.5" fill="#DAD9EF" />
        <path d="M2 3.5L5 0.5L8 3.5" stroke="#7284FA" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const publishIcon = (
    <svg width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M15.8 13.8899H18.2C18.2 13.8899 22.5 13.3299 22.5 9.10986C22.5 6.43986 20.29 4.23984 17.54 4.33984C16.47 2.06984 14.17 0.5 11.5 0.5C7.94 0.5 5.03001 3.27979 4.82001 6.78979C2.59001 6.31979 0.5 8.0198 0.5 10.2998C0.5 13.9398 4.33002 13.8899 4.33002 13.8899H7.19"
            fill="#DAD9EF"
        />
        <path
            d="M15.8 13.8899H18.2C18.2 13.8899 22.5 13.3299 22.5 9.10986C22.5 6.43986 20.29 4.23984 17.54 4.33984C16.47 2.06984 14.17 0.5 11.5 0.5C7.94 0.5 5.03001 3.27979 4.82001 6.78979C2.59001 6.31979 0.5 8.0198 0.5 10.2998C0.5 13.9398 4.33002 13.8899 4.33002 13.8899H7.19"
            stroke="#7284FA"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M11.5 8.38989V19.3899" stroke="#7284FA" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14.5 11.3899L11.5 8.38989L8.5 11.3899" fill="#DAD9EF" />
        <path d="M14.5 11.3899L11.5 8.38989L8.5 11.3899" stroke="#7284FA" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const importIcon = (
    <svg width="24" height="27" viewBox="0 0 24 27" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="1" y="3.5" width="22" height="15" fill="#DAD9EF" />
        <rect x="1" y="10.5" width="16" height="15" fill="#DAD9EF" />
        <path d="M12 0.5V16.5" stroke="#7284FA" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M15.5 13.5L12 16.5L8.5 13.5" fill="#DAD9EF" />
        <path d="M15.5 13.5L12 16.5L8.5 13.5" stroke="#7284FA" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M16.5 26V19H23.5" fill="#DAD9EF" />
        <path d="M16.5 26V19H23.5" stroke="#7284FA" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M0.5 3V26H16.5L23.5 19V3" stroke="#7284FA" strokeLinecap="round" strokeLinejoin="round" />
        <line x1="0.5" y1="3" x2="6.5" y2="3" stroke="#7284FA" strokeLinecap="round" />
        <line x1="17.5" y1="3" x2="23.5" y2="3" stroke="#7284FA" strokeLinecap="round" />
    </svg>
);

export const dotLegalLogoWithPayoff = (
    <svg id="Lag_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 542.11 191.56">
        <g id="Lag_1-2" data-name="Lag_1">
            <g>
                <g>
                    <g>
                        <path d="M91.39,26.36v106.56h-20.3V26.36h20.3Z" />
                        <path d="M190.17,96.92h-58.46c.29,7.11,2.21,12.34,5.76,15.7,3.55,3.36,7.97,5.04,13.25,5.04,4.7,0,8.62-1.15,11.74-3.46,3.12-2.3,5.11-5.42,5.98-9.36h21.46c-1.06,5.57-3.31,10.56-6.77,14.98s-7.9,7.87-13.32,10.37c-5.42,2.5-11.45,3.74-18.07,3.74-7.78,0-14.69-1.66-20.74-4.97s-10.75-8.04-14.11-14.18-5.04-13.39-5.04-21.74,1.68-15.62,5.04-21.82c3.36-6.19,8.06-10.92,14.11-14.18,6.05-3.26,12.96-4.9,20.74-4.9s14.76,1.63,20.66,4.9c5.9,3.27,10.46,7.75,13.68,13.46,3.22,5.71,4.82,12.22,4.82,19.51,0,2.02-.24,4.32-.72,6.91h0ZM165.33,73.16c-3.7-3.36-8.23-5.04-13.61-5.04s-10.08,1.68-13.82,5.04-5.81,8.3-6.19,14.83h38.74c.29-6.53-1.42-11.47-5.11-14.83h0Z" />
                        <path d="M259.87,56.88c4.8,3.17,8.21,7.44,10.22,12.82v-16.56h20.16v80.06c0,7.39-1.46,14.04-4.39,19.94-2.93,5.9-7.3,10.53-13.1,13.9-5.81,3.36-12.84,5.04-21.1,5.04-11.52,0-20.83-2.74-27.94-8.21s-11.43-12.91-12.96-22.32h20.02c1.15,4.03,3.38,7.18,6.7,9.43,3.31,2.25,7.56,3.38,12.74,3.38,5.95,0,10.75-1.75,14.4-5.26s5.47-8.81,5.47-15.91v-16.99c-2.02,5.38-5.42,9.67-10.22,12.89-4.8,3.22-10.56,4.82-17.28,4.82s-12.77-1.63-18.14-4.9c-5.38-3.26-9.58-7.99-12.6-14.18s-4.54-13.46-4.54-21.82,1.51-15.62,4.54-21.82c3.02-6.19,7.22-10.92,12.6-14.18,5.38-3.26,11.42-4.9,18.14-4.9s12.48,1.58,17.28,4.75v.02ZM233.66,76.04c-3.84,4.13-5.76,9.79-5.76,16.99s1.92,12.84,5.76,16.92,8.93,6.12,15.26,6.12,11.21-2.09,15.19-6.26c3.98-4.18,5.98-9.77,5.98-16.78s-1.99-12.74-5.98-16.92c-3.99-4.18-9.05-6.26-15.19-6.26s-11.43,2.07-15.26,6.19h0Z" />
                        <path d="M363.26,56.88c4.8,3.17,8.21,7.44,10.22,12.82v-16.56h20.16v79.78h-20.16v-16.7c-2.02,5.38-5.42,9.67-10.22,12.89s-10.56,4.82-17.28,4.82-12.77-1.63-18.14-4.9c-5.38-3.26-9.58-7.99-12.6-14.18-3.02-6.19-4.54-13.46-4.54-21.82s1.51-15.62,4.54-21.82c3.02-6.19,7.22-10.92,12.6-14.18,5.37-3.26,11.42-4.9,18.14-4.9s12.48,1.58,17.28,4.75h0ZM337.05,76.04c-3.84,4.13-5.76,9.79-5.76,16.99s1.92,12.84,5.76,16.92,8.93,6.12,15.26,6.12,11.21-2.09,15.19-6.26c3.98-4.18,5.98-9.77,5.98-16.78s-1.99-12.74-5.98-16.92c-3.99-4.18-9.05-6.26-15.19-6.26s-11.43,2.07-15.26,6.19Z" />
                        <path d="M438.42,26.36v106.56h-20.3V26.36h20.3Z" />
                    </g>
                    <circle style={{ fill: "#8bbee8" }} cx="25.43" cy="117.96" r="15.79" />
                </g>
                <g style={{ isolation: "isolate" }}>
                    <g style={{ isolation: "isolate" }}>
                        <path d="M322.64,155.02c1.17.89,1.95,2.11,2.36,3.64h-2.46c-.34-.87-.88-1.55-1.62-2.06s-1.64-.76-2.71-.76c-.85,0-1.62.21-2.29.63-.67.42-1.2,1.02-1.58,1.8-.39.78-.58,1.69-.58,2.73s.19,1.93.58,2.71c.39.78.92,1.38,1.58,1.8.67.42,1.43.63,2.29.63,1.07,0,1.97-.25,2.71-.76s1.28-1.19,1.62-2.04h2.46c-.41,1.53-1.19,2.74-2.36,3.63-1.17.89-2.63,1.33-4.39,1.33-1.35,0-2.55-.31-3.6-.92s-1.85-1.48-2.42-2.58c-.57-1.1-.85-2.37-.85-3.79s.28-2.69.85-3.79c.57-1.1,1.38-1.97,2.42-2.59s2.24-.93,3.6-.93c1.76,0,3.22.45,4.39,1.34Z" />
                        <path d="M335.36,157.52c.87.46,1.54,1.12,2.03,1.99.49.87.73,1.88.73,3.05s-.24,2.2-.73,3.07c-.49.87-1.17,1.53-2.03,1.99-.87.46-1.84.69-2.93.69s-2.06-.23-2.92-.69c-.86-.46-1.54-1.13-2.03-2-.5-.87-.74-1.89-.74-3.06s.25-2.18.74-3.05c.49-.87,1.17-1.53,2.03-1.99.86-.46,1.83-.69,2.92-.69s2.06.23,2.93.69ZM330.79,159.25c-.5.27-.9.69-1.21,1.25-.3.56-.46,1.25-.46,2.06s.15,1.52.46,2.07c.3.56.71.97,1.21,1.24.5.27,1.05.41,1.65.41s1.14-.14,1.65-.41c.5-.27.9-.68,1.21-1.24.3-.55.46-1.25.46-2.07s-.15-1.5-.46-2.06c-.3-.56-.71-.98-1.21-1.25-.5-.27-1.05-.41-1.65-.41s-1.15.14-1.65.41Z" />
                        <path d="M357.54,158.05c.79.84,1.19,2.04,1.19,3.6v6.52h-2.32v-6.28c0-.97-.24-1.73-.73-2.27-.49-.53-1.16-.8-2.01-.8-.91,0-1.63.29-2.17.86s-.8,1.42-.8,2.53v5.95h-2.32v-6.28c0-.97-.24-1.73-.73-2.27-.49-.53-1.16-.8-2.01-.8-.91,0-1.63.29-2.16.86s-.8,1.42-.8,2.53v5.95h-2.32v-11.2h2.32v2.34c.28-.81.76-1.44,1.42-1.87s1.44-.65,2.34-.65,1.74.23,2.43.69c.68.46,1.18,1.12,1.49,1.99.33-.84.85-1.5,1.56-1.97.72-.47,1.53-.71,2.44-.71,1.33,0,2.39.42,3.18,1.26Z" />
                        <path d="M370.46,157.52c.77.46,1.37,1.12,1.8,1.99s.65,1.88.65,3.05-.22,2.2-.65,3.07-1.03,1.53-1.8,1.99c-.76.46-1.64.69-2.61.69s-1.88-.25-2.6-.75-1.22-1.17-1.5-1.99v7.92h-2.32v-16.52h2.32v2.6c.28-.83.79-1.49,1.5-1.99.72-.5,1.58-.75,2.6-.75s1.85.23,2.61.69ZM365.39,159.32c-.51.3-.92.74-1.22,1.3-.3.56-.45,1.21-.45,1.94s.15,1.4.45,1.95c.3.56.7.99,1.22,1.29s1.1.46,1.75.46c1.03,0,1.86-.33,2.48-.99s.93-1.56.93-2.71-.31-2.04-.93-2.7c-.62-.66-1.45-1-2.48-1-.65,0-1.23.15-1.75.46Z" />
                        <path d="M377.46,153.13v15.04h-2.32v-15.04h2.32Z" />
                        <path d="M380.35,152.75c.27-.26.63-.39,1.08-.39s.81.13,1.09.39c.28.26.42.58.42.98s-.14.71-.42.96c-.28.24-.64.37-1.09.37s-.81-.12-1.08-.37c-.27-.24-.41-.56-.41-.96s.14-.72.41-.98ZM382.58,156.97v11.2h-2.32v-11.2h2.32Z" />
                        <path d="M392.48,157.58c.72.5,1.23,1.17,1.52,1.99v-2.6h2.32v11.2h-2.32v-2.6c-.3.83-.81,1.49-1.52,1.99s-1.58.75-2.6.75-1.85-.23-2.61-.69c-.77-.46-1.37-1.12-1.8-1.99-.43-.87-.65-1.89-.65-3.07s.22-2.18.65-3.05c.43-.87,1.03-1.53,1.8-1.99s1.64-.69,2.61-.69,1.88.25,2.6.75ZM388.12,159.85c-.62.66-.92,1.56-.92,2.71s.31,2.06.92,2.71,1.44.99,2.47.99c.65,0,1.23-.15,1.75-.46.51-.3.92-.73,1.22-1.29s.45-1.21.45-1.95-.15-1.38-.45-1.94-.7-1-1.22-1.3c-.52-.3-1.1-.46-1.75-.46-1.03,0-1.85.33-2.47.99Z" />
                        <path d="M408.49,158.05c.79.84,1.18,2.04,1.18,3.6v6.52h-2.32v-6.28c0-1-.26-1.78-.77-2.33-.52-.55-1.22-.82-2.11-.82s-1.66.29-2.21.88c-.56.59-.83,1.45-.83,2.59v5.95h-2.32v-11.2h2.32v2.46c.3-.84.8-1.49,1.5-1.95.7-.46,1.52-.69,2.44-.69,1.3,0,2.34.42,3.13,1.26Z" />
                        <path d="M420.95,157.98c.95.77,1.54,1.81,1.77,3.12h-2.46c-.13-.7-.46-1.26-.99-1.66s-1.17-.6-1.96-.6c-.89,0-1.64.32-2.24.95-.6.63-.89,1.55-.89,2.77s.3,2.15.89,2.78c.6.64,1.34.96,2.24.96.79,0,1.44-.2,1.96-.61.52-.41.85-.96.99-1.67h2.46c-.23,1.31-.82,2.36-1.77,3.13-.95.77-2.15,1.16-3.6,1.16-1.08,0-2.04-.23-2.88-.69-.83-.46-1.49-1.12-1.96-1.99-.47-.87-.71-1.89-.71-3.07s.24-2.18.71-3.05c.47-.87,1.13-1.53,1.96-1.99.83-.46,1.79-.69,2.88-.69,1.45,0,2.65.38,3.6,1.15Z" />
                        <path d="M435.27,163.03h-8.62c.04,1.15.36,2,.96,2.56.6.56,1.33.83,2.21.83.77,0,1.43-.2,1.96-.59.54-.39.86-.91.99-1.56h2.48c-.15.79-.46,1.48-.93,2.09-.47.61-1.09,1.09-1.85,1.43s-1.6.52-2.54.52c-1.08,0-2.04-.23-2.88-.69-.83-.46-1.49-1.12-1.96-1.99s-.71-1.89-.71-3.07.24-2.18.71-3.05,1.13-1.53,1.96-1.99,1.79-.69,2.88-.69,2.06.23,2.88.68c.82.45,1.45,1.08,1.89,1.87.44.79.66,1.68.66,2.65,0,.38-.03.71-.08,1ZM432.64,160.13c-.28-.5-.66-.86-1.14-1.1-.48-.24-1.01-.36-1.58-.36-.91,0-1.67.28-2.28.83s-.94,1.38-1,2.46h6.36c.03-.73-.1-1.34-.38-1.84Z" />
                        <path d="M451.27,166.31c-.34.6-.85,1.09-1.54,1.45-.69.37-1.54.55-2.54.55s-1.85-.17-2.62-.52c-.77-.35-1.39-.83-1.85-1.45-.46-.62-.72-1.34-.79-2.15h2.48c.07.62.34,1.16.8,1.61.47.45,1.09.67,1.88.67.7,0,1.25-.19,1.64-.57.39-.38.58-.87.58-1.46,0-.51-.14-.94-.43-1.27s-.64-.59-1.06-.78-1-.41-1.73-.65c-.89-.28-1.62-.57-2.18-.85-.56-.28-1.04-.7-1.43-1.24-.39-.54-.59-1.25-.59-2.13,0-.77.19-1.45.57-2.03.38-.58.92-1.03,1.62-1.35.7-.32,1.52-.48,2.44-.48,1.46,0,2.62.35,3.49,1.06.86.7,1.35,1.62,1.47,2.76h-2.5c-.09-.54-.35-1.01-.76-1.39-.41-.39-.98-.58-1.7-.58-.65,0-1.17.17-1.56.5s-.59.81-.59,1.43c0,.49.13.89.41,1.21.27.32.61.57,1.03.75.41.18.98.4,1.7.64.91.28,1.65.57,2.23.86.58.29,1.06.71,1.46,1.27.4.56.6,1.29.6,2.19,0,.71-.17,1.36-.51,1.96Z" />
                        <path d="M462.14,157.52c.87.46,1.54,1.12,2.03,1.99.49.87.73,1.88.73,3.05s-.24,2.2-.73,3.07c-.49.87-1.17,1.53-2.03,1.99-.87.46-1.84.69-2.93.69s-2.06-.23-2.92-.69c-.86-.46-1.54-1.13-2.03-2-.5-.87-.74-1.89-.74-3.06s.25-2.18.74-3.05c.49-.87,1.17-1.53,2.03-1.99s1.83-.69,2.92-.69,2.06.23,2.93.69ZM457.57,159.25c-.5.27-.9.69-1.21,1.25-.3.56-.46,1.25-.46,2.06s.15,1.52.46,2.07c.3.56.71.97,1.21,1.24.5.27,1.05.41,1.65.41s1.14-.14,1.65-.41c.5-.27.9-.68,1.21-1.24.3-.55.46-1.25.46-2.07s-.15-1.5-.46-2.06c-.3-.56-.71-.98-1.21-1.25-.5-.27-1.05-.41-1.65-.41s-1.14.14-1.65.41Z" />
                        <path d="M470.45,155.09c-.37.33-.55.9-.55,1.7v.18h2.46v1.99h-2.46v9.21h-2.34v-9.21h-1.52v-1.99h1.52v-.37c0-1.37.4-2.39,1.2-3.08.8-.68,2-.99,3.6-.9v2.03c-.91-.04-1.54.11-1.91.44Z" />
                        <path d="M479.86,166.16v2.01h-1.42c-1.19,0-2.1-.29-2.71-.86-.62-.58-.92-1.53-.92-2.88v-5.49h-1.6v-1.97h1.6v-2.78h2.34v2.78h2.7v1.97h-2.7v5.53c0,.64.12,1.08.36,1.32.24.24.65.37,1.25.37h1.12Z" />
                        <path d="M497.72,156.97l-3.11,11.2h-2.56l-2.76-8.66-2.8,8.66h-2.54l-3.11-11.2h2.34l2.13,9.06,2.8-9.06h2.44l2.84,9.06,2.13-9.06h2.19Z" />
                        <path d="M506.39,157.58c.72.5,1.23,1.17,1.52,1.99v-2.6h2.32v11.2h-2.32v-2.6c-.3.83-.81,1.49-1.52,1.99-.72.5-1.58.75-2.6.75s-1.85-.23-2.61-.69c-.76-.46-1.36-1.12-1.8-1.99s-.65-1.89-.65-3.07.22-2.18.65-3.05,1.03-1.53,1.8-1.99c.77-.46,1.64-.69,2.61-.69s1.88.25,2.6.75ZM502.03,159.85c-.62.66-.92,1.56-.92,2.71s.31,2.06.92,2.71,1.44.99,2.47.99c.65,0,1.23-.15,1.75-.46s.92-.73,1.22-1.29.45-1.21.45-1.95-.15-1.38-.45-1.94-.7-1-1.22-1.3-1.1-.46-1.75-.46c-1.03,0-1.85.33-2.47.99Z" />
                        <path d="M516.96,157.43c.71-.43,1.52-.64,2.44-.64v2.52h-.69c-1.02,0-1.83.25-2.45.74-.62.5-.92,1.31-.92,2.45v5.67h-2.32v-11.2h2.32v2.19c.38-.73.92-1.31,1.62-1.74Z" />
                        <path d="M531.45,163.03h-8.62c.04,1.15.36,2,.96,2.56.6.56,1.33.83,2.21.83.77,0,1.42-.2,1.96-.59.53-.39.86-.91.99-1.56h2.48c-.15.79-.46,1.48-.93,2.09-.47.61-1.09,1.09-1.85,1.43-.76.35-1.61.52-2.54.52-1.08,0-2.04-.23-2.88-.69-.83-.46-1.49-1.12-1.96-1.99-.47-.87-.71-1.89-.71-3.07s.24-2.18.71-3.05c.47-.87,1.13-1.53,1.96-1.99s1.79-.69,2.88-.69,2.05.23,2.88.68c.82.45,1.45,1.08,1.89,1.87.44.79.66,1.68.66,2.65,0,.38-.03.71-.08,1ZM528.82,160.13c-.28-.5-.66-.86-1.14-1.1s-1.01-.36-1.57-.36c-.91,0-1.67.28-2.28.83s-.94,1.38-1,2.46h6.36c.03-.73-.1-1.34-.38-1.84Z" />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

// The padded viewBox keeps the arrowheads at the edge from clipping under the 1.25 stroke, and matches the
// asset icon's 24.5 scale so both menu strokes render at the same width.
export const processesIcon = (
    <svg width="24" height="24" viewBox="-0.25 -0.25 24.5 24.5" fill="none" strokeWidth="1.25" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10.4961" cy="12.4502" r="9.5" fill="#DAD9EF" />
        <path d="M20.0466 10.0801C21.3866 15.3901 18.2866 20.8802 12.9766 22.2302Z" fill="#DAD9EF" />
        <path d="M20.0466 10.0801C21.3866 15.3901 18.2866 20.8802 12.9766 22.2302" stroke="#7284FA" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M23.4869 13.8203L20.067 10.0303L17.377 14.3701" fill="#DAD9EF" />
        <path d="M23.4869 13.8203L20.067 10.0303L17.377 14.3701" stroke="#7284FA" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M3.98633 5.2301C8.16633 1.6901 14.4963 2.07013 18.0363 6.26013Z" fill="#DAD9EF" />
        <path d="M3.98633 5.2301C8.16633 1.6901 14.4963 2.07013 18.0363 6.26013" stroke="#7284FA" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.87683 0.500244L3.9668 5.24023L9.04681 5.74023" fill="#DAD9EF" />
        <path d="M5.87683 0.500244L3.9668 5.24023L9.04681 5.74023" stroke="#7284FA" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.20631 22.1702C2.03631 20.3402 -0.76371 14.7203 1.05629 9.55029Z" fill="#DAD9EF" />
        <path d="M7.20631 22.1702C2.03631 20.3402 -0.76371 14.7203 1.05629 9.55029" stroke="#7284FA" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M2.2168 22.9502L7.27686 22.2102L5.14685 17.5703" fill="#DAD9EF" />
        <path d="M2.2168 22.9502L7.27686 22.2102L5.14685 17.5703" stroke="#7284FA" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
